/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-09 16:41:54
 * @LastEditTime: 2019-12-19 10:53:49
 * @LastEditTime: 2019-09-09 11:43:43
 * @LastEditors: Please set LastEditors
 */

export default {
  v5: {
    select_files_to_upload: 'Select files to upload',
    my_video_shorts: 'என் வீடியோ குறும்படங்கள்',
    see_more: 'மேலும் காண்க',
    no_shorts_found: 'குறும்படங்கள் இல்லை',
    shorts: 'குறும்படங்கள்',
    general_information: 'பொது தகவல்',
    gamification: 'விளையாட்டு செயல்முறை',
    click_to_select_files: 'கோப்புகளைத் தேர்ந்தெடுக்க கிளிக் செய்யவும்',
    selected_files: 'தேர்ந்தெடுக்கப்பட்ட கோப்புகள்',
    uploaded: 'பதிவேற்றப்பட்டது',
    failed: 'தோல்வி',
    system_will_automatically_analyze_and_select_the_most_relevant:
      'உங்கள் நிறுவன நூலகத்தில் உள்ள உள்ளடக்க தேவைகளின் அடிப்படையில் மிகப் பொருத்தமான ஆவணங்களை சிஸ்டம் தானாக ஆய்வு செய்து தேர்ந்தெடுக்கிறது.',
    select_from_library: ' நூலகத்திலிருந்து தேர்ந்தெடுக்கவும்',
    search_document: 'ஆவணங்களைத் தேடவும்...',
    selected: 'தேர்ந்தெடுக்கப்பட்டது',
    loading_documents: 'ஆவணங்களை ஏற்றுகிறது...',
    review_generated_content:
      'உருவாக்கப்பட்ட உள்ளடக்கத்தை மதிப்பாய்வு செய்யவும்',
    confirm_and_replace_content: 'உறுதிப்படுத்தி உள்ளடக்கத்தை மாற்றவும்',
    the_generate_content_will_replace:
      'உருவாக்கப்பட்ட உள்ளடக்கம் தேர்ந்தெடுக்கப்பட்ட பக்கங்களில் உள்ள தற்போதைய உரையை மாற்றும். நீங்கள் இந்த மாற்றங்களைச் செய்ய விரும்பவில்லை என்றால், முந்தைய படிக்கு திரும்பலாம்.',
    pages_to_be_updated: 'புதுப்பிக்க வேண்டிய பக்கங்கள்',
    generated_revisions: 'உருவாக்கப்பட்ட திருத்தங்கள்',
    lesson_preview: 'பாடம் முன்னோட்டம்',
    create_new_folder: 'புதிய கோப்புறை உருவாக்கவும்',
    rename_item: 'உருப்படியின் பெயரை மாற்றவும்',
    enter_folder_name: 'கோப்புறையின் பெயரை உள்ளிடவும்:',
    enter_new_name: 'புதிய பெயரை உள்ளிடவும்:',
    folder_name: 'கோப்புறை பெயர்:',
    new_name: 'புதிய பெயர்',
    move_items: 'உருப்படிகளை நகர்த்தவும்',
    copy_items: 'உருப்படிகளை நகலெடுக்கவும்',
    move_here: 'இங்கே நகர்த்தவும்',
    copy_here: 'இங்கே நகலெடுக்கவும்',
    select_destination_library_and_folder:
      'இலக்கு நூலகம் மற்றும் கோப்புறையைத் தேர்ந்தெடுக்கவும்:',
    items_selected: 'தேர்ந்தெடுக்கப்பட்ட உருப்படிகள்',
    version: 'பதிப்பு',
    modified_by: 'மாற்றியவர்',
    size: 'அளவு',
    restore: 'மீட்டமைக்கவும்',
    are_you_sure_you_want_to_restore_this_version:
      'இந்த பதிப்பை மீட்டமைக்க விரும்புகிறீர்களா?',
    this_will_replce_the_current_version_with_the_selected_one:
      'இது தற்போதைய பதிப்பை தேர்ந்தெடுக்கப்பட்ட பதிப்பால் மாற்றும்.',
    restore_this_version: 'இந்த பதிப்பை மீட்டமைக்கவும்',
    restore_not_available: 'மீட்டமைப்பு கிடைக்கவில்லை',
    version_history: 'பதிப்பு வரலாறு:',
    by_making_items_public:
      'உருப்படிகளை பொது பயன்பாட்டிற்கு மாற்றுவதன் மூலம் அவை அனைவருக்கும் காண்பிக்கப்படும். தொடர்வதற்கு முன் விதிமுறைகளை சரிபார்க்கவும்.',
    the_selected_items_will_be_copied:
      'தேர்ந்தெடுக்கப்பட்ட உருப்படிகள் உங்கள் பொது நூலகத்திற்கு நகலெடுக்கப்படும் மற்றும் அனைவருக்கும் காட்சி தரப்படும்.',
    the_selected_items_will_be_copied_to_org:
      'தேர்ந்தெடுக்கப்பட்ட உருப்படிகள் உங்கள் நிறுவன நூலகத்திற்கு நகலெடுக்கப்படும் மற்றும் அனைத்து நிறுவன உறுப்பினர்களுக்கும் காட்சியளிக்கும்.',
    the_selected_items_will_be_copied_to_your_private:
      'தேர்ந்தெடுக்கப்பட்ட உருப்படிகள் உங்கள் தனிப்பட்ட நூலகத்திற்கு நகலெடுக்கப்படும் மற்றும் அது உங்களுக்கு மட்டுமே காணப்படும்.',
    loading_organization: 'நிறுவன பயனர்களை ஏற்றுகிறது...',
    click_download_to_view: 'காண "பதிவிறக்கம் செய்ய" கிளிக் செய்யவும்',
    archive_file: 'ஆர்கைவ் கோப்பு',
    no_preview_available: 'முன்னோட்டம் கிடைக்கவில்லை',
    audit_report: 'ஆடிட் அறிக்கை',
    audit_type: 'செயல் வகை',
    i_agree_to_the_terms_and_conditions:
      'நான் விதிமுறைகளையும் நிபந்தனைகளையும் ஒப்புக்கொள்கிறேன்.',
    this_file_is_indexed_for_ai: 'இந்த கோப்பு AI க்கு குறியிடப்பட்டுள்ளது.',
    file_is_not_indexed_for_ai: 'கோப்பு AI க்கு குறியிடப்படவில்லை.',
    no_users_found: 'பயனர்கள் எவரும் இல்லை',
    no_users_available: 'பயனர்கள் கிடைக்கவில்லை',
    add_people: 'பயனர்களைச் சேர்க்கவும்',
    people: 'பயனர்கள்',
    access_type: 'அணுகல் வகை',
    no_group_found: 'குழுக்கள் எதுவும் இல்லை',
    add_group: 'குழுக்களைச் சேர்க்கவும்',
    groups: 'குழுக்கள்',
    users_top: 'பயனர்(கள்)',
    confirm_delete: 'அழிப்பை உறுதிப்படுத்தவும்',
    do_you_want_remove: 'நீங்கள் அகற்ற விரும்புகிறீர்களா',
    form_this_documents_permissions: 'இந்த ஆவணத்தின் அனுமதிகளிலிருந்து?',
    no_users_found_in_this_group: 'இந்த குழுவில் பயனர்கள் எவரும் இல்லை',
    add_selected_users: 'தேர்ந்தெடுக்கப்பட்ட பயனர்களைச் சேர்க்கவும்',
    choose_users_from_the_list: 'பட்டியலிலிருந்து பயனர்களை தேர்ந்தெடுக்கவும்',
    selected_users: 'தேர்ந்தெடுக்கப்பட்ட பயனர்கள்',
    archived: 'ஆர்கைவ் செய்யப்பட்டது',
    request_approval: 'அனுமதி கோரவும்',
    document_in_review: 'ஆவணம் மதிப்பாய்வில் உள்ளது',
    approve: 'அங்கீகரிக்கவும்',
    reject: 'நிராகரிக்கவும்',
    comment: 'கருத்து:',
    enter_your_commit: 'உங்கள் கருத்தை உள்ளிடவும்...',
    confirm_cancel: 'ரத்து செய்யும் செயல்பாட்டை உறுதிப்படுத்தவும்',
    upload_3d_zip: '3D ZIP பதிவேற்றவும்',
    delete_items: 'உருப்படிகளை நீக்கவும்',
    video_upload_request: 'வீடியோ பதிவேற்ற கோரிக்கை',
    reject_video: 'வீடியோவை நிராகரிக்கவும்',
    enter_rejection_reason: 'நிராகரிக்கும் காரணத்தை உள்ளிடவும்...',
    please_provide_a_reason_for_reejection_this_video:
      'இந்த வீடியோவை நிராகரிக்கும் காரணத்தை வழங்கவும்:',
    generate_trivia_with_ai: 'AI மூலம் டிரிவியா உருவாக்கவும்',
    select_category: 'வகையை தேர்ந்தெடுக்கவும்:',
    number_of_question: 'கேள்விகளின் எண்ணிக்கை',
    generated_questions: 'உருவாக்கப்பட்ட கேள்விகள்',
    this_will_clear_all_generate_question:
      'இது அனைத்து உருவாக்கப்பட்ட கேள்விகளையும் அழிக்கும். தொடரவா?',
    sure_delete: 'நீங்கள் மிச்சமாக நீக்க விரும்புகிறீர்களா?',
    delete_this_question: 'இந்த கேள்வியை நீக்க விரும்புகிறீர்களா?',
    loading_quiz: 'க்விஸ் ஏற்றுகிறது...',
    creteing_file: 'கோப்பை உருவாக்குகிறது',
    opening_desktop_app: 'டெஸ்க்டாப் செயலியை திறக்கிறது',
    this_folder_is_empty: 'இந்த கோப்புறை காலியாக உள்ளது',
    select_a_competition: 'போட்டி தேர்ந்தெடுக்கவும்...',
    activity_badges: 'செயற்பாட்டுப் பேட்ஜ்கள்',
    awarded_every_badges:
      'ஒவ்வொரு 4, 8, 16, 32, 64, 128, 256, 512 உள்நுழைவுகளுக்கும் வழங்கப்பட்டது',
    learning_badges: 'கற்றல் பேட்ஜ்கள்',
    awarded_every_courses:
      'ஒவ்வொரு 1, 4, 8, 16, 32, 64, 128 முடிக்கப்பட்ட பாடங்களுக்கும் வழங்கப்பட்டது',
    test_badges: 'தேர்வு பேட்ஜ்கள்',
    awarded_every_passes_tests:
      'ஒவ்வொரு 2, 4, 8, 16, 32, 64, 128, 256 தேர்வுகளுக்கும் வழங்கப்பட்டது',
    assignment_badges: 'பணி பேட்ஜ்கள்',
    awarded_every_passed_assignments:
      'ஒவ்வொரு 1, 2, 4, 8, 16, 32, 64, 128 பணி முடிப்புகளுக்கும் வழங்கப்பட்டது',
    perfectionism_badges: 'சிறப்புப் பேட்ஜ்கள்',
    awarded_every_assignments_with_scrore:
      'ஒவ்வொரு 1, 2, 4, 8, 16, 32, 64, 128 90%+ மதிப்பெண்கள் பெற்ற பணி/தேர்வுகளுக்கும் வழங்கப்பட்டது',
    communication_badges: 'தொடர்புப் பேட்ஜ்கள்',
    awarded_every_topics_or_comments:
      'ஒவ்வொரு 2, 4, 8, 16, 32, 64, 128, 256 தலைப்புகள் அல்லது கருத்துக்களுக்கு வழங்கப்பட்டது',
    certification_badges: 'சான்றிதழ் பேட்ஜ்கள்',
    awarded_every_certificates:
      'ஒவ்வொரு 1, 2, 4, 8, 16, 32, 64, 128 சான்றிதழ்களுக்கு வழங்கப்பட்டது',
    level_name: 'நிலை பெயர்',
    delete_competition: 'போட்டியை நீக்கவும்',
    this_week: 'இந்த வாரம்',
    this_year: 'இந்த ஆண்டு',
    make_organization: 'நிறுவனம் உருவாக்கவும்',
    no_results_found: 'முடிவுகள் எதுவும் கிடைக்கவில்லை',
    no_items_available: 'வस्तுக்கள் கிடைக்கவில்லை',
    help_video: 'உதவி வீடியோக்கள்',
    select_a_video_from_the_list:
      'கற்றலைத் தொடங்க பட்டியலில் இருந்து ஒரு வீடியோ தேர்ந்தெடுக்கவும்'
  },
  v4: {
    upload_another_file: 'Upload another file',
    all_files_uploaded: 'All files uploaded',
    upload_and_submit: 'Upload & Submit',
    drop_files:
      'கோப்புகளை இழுத்து விடவும் மற்றும் பதிவேற்ற இடத்தைத் தேர்ந்தெடுக்கவும்.',
    duplicate_lessoon: 'இந்த பாடம் ஏற்கனவே பாடநுழைவில் உள்ளது',
    skill_rule_title: 'திறன் பயணத் தலைப்பை பதிவு செய்யவும்',
    imageCreatorTitle: 'பட உருவாக்கி',
    isTranslated: 'மொழிபெயர்க்கப்பட்டது',
    translationCourseDesc:
      'இந்த பாடநூல் மொழிபெயர்ப்பு சில நிமிடங்கள் எடுக்கலாம். உங்கள் பொறுமைக்கு நன்றி!',
    translateCourseTip:
      'மற்றும் முழு பாடங்கள், பக்கங்கள் இணக்கமாக மறுபயன்படி திருத்தக்கூடியப் பிரதி மொழிபெயர்ப்பு பாடநூலை உருவாக்குங்கள்.',
    translateModalBtn: 'மொழிபெயர்க்கவும்',
    translationSuccess: '“<0/>” பாடநூல் வெற்றிகரமாக மொழிபெயர்க்கப்பட்டது!',
    translatingCourse: 'பாடநூலை மொழிபெயர்க்கப்படுகிறது...',
    translateModalTitle: 'பாடநூல் மொழிபெயர்க்கவும்',
    translateSelectLang: 'மொழியை தேர்ந்தெடுக்கவும்',
    fileDeleteconfirm:
      'இந்தக் கோப்பை நீக்க விரும்புகிறீர்களா? இது மீட்க முடியாதது.',
    fileDeleteMessage: 'கோப்பு வெற்றிகரமாக நீக்கப்பட்டது.',
    fileDeleteFailedMessage: 'கோப்பை நீக்க முடியவில்லை!',
    fileDelete: 'இந்தக் கோப்பை நீக்கவும்.',
    certificate_save_btn: 'சான்றிதழை சேர் ',
    maze_path_info: 'வரிசை வரைபடத்திற்கு ஏதும் பாதைகள் இல்லை!',
    file_size_mb: 'கோப்பு அளவு 25MB க்கும் குறைவாக இருக்க வேண்டும்!',
    reports: {
      products: 'பொருட்கள்',
      users: 'பயனர்கள்',
      ph_username: 'பயனர் பெயரில் தேடவும்',
      ph_id: 'பயனர் ஐடி எண் மூலம் தேடவும்',
      ph_email: 'மின்னஞ்சலில் பயனர் தேடவும்'
    },
    select_upload_section_id: 'பிரிவு கோப்பு தேவை',
    tags_all: 'அனைத்தும்',
    delete_file_confirm: 'இந்தக் கோப்பை நீக்க விரும்புகிறீர்களா?',
    delete_file_title: 'கோப்பை நீக்கு',
    tooltip_publish: 'தேர்ந்தெடுக்கப்பட்ட விருப்பத்தில் பாடநூலை வெளியிடவும்',
    tooltip_save: 'மوجود புதுப்பிப்புகளோடு பாடநூலை சேமிக்கவும்',
    tooltip_next: 'அடுத்த பாடநூல் அமைப்பிற்கு செல்லவும்',
    tooltip_finish: 'தற்போதைய புதியதையுடன் முடித்து சேமிக்கவும்',
    stories_modal: {
      title_upload: 'கதைகள் பதிவேற்றுதல்',
      title_update: 'கதை புதுப்பிப்பு',
      title_audio: 'கதை ஒலி கோப்பு',
      btn_upload: 'பதிவேற்று',
      btn_update: 'புதுப்பி',
      btn_close: 'மூடு',
      btn_cancel: 'ரத்துசெய்',
      lbl_cover: 'கதை மேலொளிக்குறிப்பு படம்',
      rule_cover: 'கதை audio –க்கு மேலொளியை பதிவேற்றவும்!',
      lbl_title: 'கதை audio தலைப்பு',
      rule_title: 'கதை audio-க்கு தலைப்பு பதிவு செய்யவும்!',
      lbl_description: 'கதை audio விளக்கம்',
      rule_description: 'கதை audio விளக்கத்தை பதிவு செய்யவும்!',
      lbl_file: 'கதையின் ஒலி கோப்பை பதிவேற்று',
      rule_file: 'ஒலி கோப்பு பதிவேற்றவும்!',
      rule_file_type: 'சரியான கதை ஒலி கோப்பை பதிவேற்றவும்!',
      lbl_select_file: 'கதை audio கோப்பைத் தேர்ந்தெடுக்கவும்',
      msg_valid_file: 'சரியான கதை audio கோப்பை தேர்ந்தெடுக்கவும்!',
      msg_success: 'கதை audio கோப்பு வெற்றிகரமாக பதிவேற்றப்பட்டது',
      msg_failed: 'மீடியா தரவை அமைக்க முடியவில்லை!',
      msg_error: 'கோப்பு பதிவேற்றத்தில் பிழை!'
    },
    audio_modal: {
      title_upload: 'பதிவேற்று',
      title_update: 'புதுப்பி',
      title_audio: 'ஒலி கோப்பு',
      btn_upload: 'பதிவேற்று',
      btn_update: 'புதுப்பி',
      btn_close: 'மூடு',
      btn_cancel: 'ரத்துசெய்',
      lbl_cover: 'ஒலி மேலொளிக்குறிப்பு',
      rule_cover: 'ஒலி மேலொளியை பதிவேற்று!',
      lbl_title: 'ஒலி தலைப்பு',
      rule_title: 'ஒலிக்கு தலைப்பு பதிவு செய்யவும்!',
      lbl_description: 'ஒலி விளக்கம்',
      rule_description: 'ஒலக்கான விளக்கத்தை பதிவு செய்யவும்!',
      lbl_file: 'ஒலி கோப்பை பதிவேற்று',
      rule_file: 'ஒலி கோப்பை பதிவேற்றவும்!',
      rule_file_type: 'சரியான ஒலி கோப்பை பதிவேற்றவும்!',
      lbl_select_file: 'ஒலி கோப்பைத் தேர்ந்தெடுக்கவும்',
      msg_valid_file: 'சரியான ஒலி கோப்பை தேர்ந்தெடுக்கவும்!',
      msg_success: 'ஒலி கோப்பு வெற்றிகரமாக பதிவேற்றப்பட்டது',
      msg_failed: 'மீடியா தரவை அமைக்க முடியவில்லை!',
      msg_error: 'கோப்பு பதிவேற்றத்தில் பிழை!'
    },
    info_episode: 'எபிசோடை மேல் ஒளிக்குறிப்பு படம்.',
    btn_delete_episode: 'இந்த போட்காஸ்ட் எபிசோடை நீக்கு.',
    btn_edit_marketplace: 'மார்க்கெட்ப்ளேஸின் விவரங்களைத் திருத்து.',
    btn_save_marketplace: 'தற்போதைய மாற்றங்களை சேமி.',
    btn_ai_podcast: 'AI போட்காஸ்ட் எபிசோடு உருவாக்கு.',
    btn_upload_podcast: 'உங்கள் சொந்த போட்காஸ்ட் ஒலி பதிவேற்று.',
    attach_file: 'பெரும்பாலான உள்ளடக்கத்தை பகிர கோப்புகள் பதிவேற்று',
    fileDownload: 'இந்தக் கோப்பை பதிவிறக்கவும்.',
    singleEpishode: 'எபிசோடு',
    podcast_music: 'போட்காஸ்ட், இசை மற்றும் கதைகள்',
    publishHeader: 'போட்காஸ்ட், இசை மற்றும் கதைகள் வெளியிடுங்கள்',
    editHeader: 'போட்காஸ்ட், இசை மற்றும் கதைகள் திருத்தவும்',
    createHeader: 'போட்காஸ்ட், இசை மற்றும் கதைகள் உருவாக்கவும்',
    marketplaceHeader: 'போட்காஸ்ட், இசை மற்றும் கதைகள் மார்க்கெட்ப்ளேஸ் விவரம்',
    message_marketplace:
      'மார்க்கெட்ப்ளேஸ் படிவத்தை தயவுசெய்து பூர்த்தி செய்யவும்!',
    create_podcast_live: 'நேரடி போட்காஸ்ட் மற்றும் இசை',
    create_podcast_custom: 'தனிப்பயனான போட்காஸ்ட் மற்றும் இசை',
    create_podcast_stories: 'கதைகள்',
    ai_Assisted_podcast_reation: 'AI உதவியுடன் போட்காஸ்ட் மற்றும் இசை',
    publishTitle:
      'போட்காஸ்ட், இசை மற்றும் கதைகள் பொது பார்வைக்கு வெளியிடுங்கள்.',
    customButton: 'தனிப்பயனாக்கு',
    customTitle: 'போட்காஸ்டில் செய்யப்பட்ட மாற்றங்களை சேமிக்கவும்.',
    updateButton: 'புதுப்பி',
    createButton: 'உருவாக்கு',
    createNewButton: 'புதிய ஒன்றை உருவாக்கு',
    updateTitle:
      'தற்போதைய போட்காஸ்ட், இசை மற்றும் கதைகள் விவரங்களை புதுப்பிப்பு.',
    createTitle: 'புதிய போட்காஸ்ட், இசை மற்றும் கதைகள் உருவாக்கு',
    createNewTitle:
      'புதிய போட்காஸ்ட், இசை மற்றும் கதைகள் தற்போதைய உள்ளீட்டின் அடிப்படையில் உருவாக்கப்படும்.',
    podcastTitle: 'எபிசோடுகளின் பட்டியல்',
    podcastStoryTitle: 'கதைகளின் எபிசோடுகளின் பட்டியல்',
    podcastToolTipTitle: 'பட்காஸ்ட் எபிசோடுகளின் பட்டியல்',
    uploadAudio: 'ஒலி பதிவேற்று',
    aiAudio: 'AI ஒலி',
    emptyPodcast:
      'இன்னும் எவ்விதமான போட்காஸ்ட், இசை அல்லது குறும்படத் தொடரும் பதிவேற்றப்படவில்லை.',
    emptyStoriesPodcast: 'கதைகள் இனியும் சேர்க்கப்படவில்லை.',
    emptyCreatePodcast: 'ஒலியைச் சேர்க்க முன் ஒரு போட்காஸ்ட் உருவாக்கவும்.',
    playPodcast:
      'தேர்ந்தெடுக்கப்பட்ட போட்காஸ்ட், இசை மற்றும் கதைகளை இயக்கவும்.',
    pausePodcast:
      'தேர்ந்தெடுக்கப்பட்ட போட்காஸ்ட், இசை மற்றும் கதைகளை இடைநீக்கவும்.',
    selectPodcast: 'இந்த போட்காஸ்ட், இசை மற்றும் கதைகளைத் தேர்ந்தெடுக்கவும்.',
    downloadPodcast: 'இந்த ஒலியை பதிவிறக்கவும்.',
    uploadAudioFile: 'புதிய ஒலியை பதிவேற்று மற்றும் நடப்பு ஒலியை மாற்றவும்.',
    deleteConfirm: 'இந்த ஒலியை நீக்க வேண்டுமா?',
    roomName: 'போட்காஸ்ட் பெயர்',
    addGuestTitle: 'அதிதி பேச்சாளர் காண்பி',
    showTime: 'தொடர்ச்சி நேரம்',
    startTime: 'தொடக்க நேரம்',
    endTime: 'முடிவு நேரம்',
    erorMsgImg: 'தயவுசெய்து செல்லுபடியான படத்தை தேர்ந்தெடுக்கவும்.',
    failedMsgImg:
      'படத்தைப் பதிவேற்ற முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்!',
    failedMsgUpload: 'மேலொளி பதிவேற்றத்தில் தோல்வி!',
    btnCoverUpload: 'மேலொளி பதிவேற்று',
    is_private: 'தனியார்',
    to_attach: 'கோப்பை இணை',
    file_attached: 'கோப்புகள் இணைக்கப்பட்டன',
    main_event: 'முக்கிய நிகழ்வு',
    event: 'நிகழ்வு',
    upload_pdf: 'PDF பதிவேற்று',
    portrait: 'நில portrait',
    landscape: 'நில landscape',
    import_from_library: 'மீடியா நூலகத்திலிருந்து உரையை இறக்குமதி செய்யவும்',
    question_answer_ai: 'கேள்வி/பதில் AI',
    take_maze: 'MetaMaze ஐ தொடங்கு',
    training: 'பயிற்சி',
    select_transcribe_locale: 'மொழிபெயர்க்க மொழியைத் தேர்வு செய்க',
    transcribe_limit: 'மொழிபெயர்க்க வேண்டிய நிமிடங்களை உள்ளிடவும்',
    not_complete: 'சந்தைத் தகவல் முழுமையாக இல்லை',
    complete: 'சந்தைத் தகவல் முழுமையாக உள்ளது',
    not_admin: 'சந்தைக்கு வெளியிட நிர்வாக அனுமதி தேவை',
    no_course:
      'தலைப்பை உள்ளிடவும் மற்றும் சந்தையை இயக்க படத்தைத் தேர்ந்தெடுக்கவும்',
    scorm_not_complete:
      'SCORM கோப்பை பதிவேற்ற தலைப்பை உள்ளிடவும் மற்றும் படத்தைத் தேர்ந்தெடுக்கவும்',
    not_found_maze: 'MetaMaze காணவில்லை',
    email_require: 'மின்னஞ்சல்கள் தேவை',
    poll_required: 'மதிப்பீட்டு தரவுகள் தேவை',
    alert: 'எச்சரிக்கை!',
    warning: 'எச்சரிக்கை!',
    ok: 'சரி',
    cancel: 'ரத்துசெய்',
    done: 'முடிந்தது',
    insert: 'சேர்',
    private: 'தனிப்பட்டது',
    public: 'பொதுவானது',
    no_connection: 'இணைய இணைப்பு கிடையாது',
    switch: 'மாற்று',
    share_screen: 'திரையை பகிர்',
    stop_share_screen: 'திரை பகிர்வதை நிறுத்து',
    share_screen_with_camera: 'கேமராவுடன் திரையை பகிர்',
    stop_share_screen_with_camera: 'கேமராவுடன் திரை பகிர்வதை நிறுத்து',
    camera_on: 'கேமரா இயக்கப்பட்டது',
    camera_off: 'கேமரா அணைக்கப்பட்டது',
    mic_on: 'மூடியதை திற',
    mic_off: 'மூடு',
    fullscreen: 'முழுத்திரை',
    live_now: 'இப்போது நேரலை',
    schedule_on: 'திட்டமிடப்பட்ட தேதி:',
    organisations: 'நிறுவனங்கள்',
    org_groups: 'நிறுவனக் குழுக்கள்',
    specific_user: 'குறிப்பிட்ட பயனர்',
    gif: 'GIF',
    unavailable: 'கிடைக்கவில்லை',
    yes: 'ஆம்',
    no: 'இல்லை',
    event_duration_message: 'அதிகபட்சம் 300 நிமிடங்கள் (5 மணி நேரம்)',
    send_email: 'மின்னஞ்சல் அறிவிப்பை அனுப்பு',
    admin_only: 'நிர்வாகிகள் மட்டுமே',
    join: 'சேரு',
    leave: 'விலகு',
    share: 'பகிர்',
    share_text:
      'இந்த கோப்பைப் பகிர விரும்பும் நபரின் மின்னஞ்சல் முகவரியை உள்ளிடவும்.',
    share_text_title: 'PDF பகிர்',
    share_text_title_txt: 'உரையை பகிர்',
    select_users: 'பயனர்களைத் தேர்ந்தெடுக்கவும்',
    delete: 'அழி',
    attachment_event: 'நிகழ்வுக்கான இணைப்புகள்:',
    transcribe_limit: 'மொழிபெயர்ப்பு நிமிடங்கள்',
    monthly_transcribe: 'மாதாந்திர மொழிபெயர்ப்பு வரம்பு:',
    enable_ai: 'AIஐ இயக்கவும்:',
    enable_maze: 'MetaMazeஐ இயக்கவும்:',
    media_service: 'ஊடக சேவை',
    allow_others: 'மற்றவர்கள் திருத்த அனுமதிக்கவும்',
    join_breakout_room: 'தனி அறைக்கு செருகவும்',
    bio: 'வாழ்க்கை வரலாறு',
    linkedin: 'LinkedIn',
    select_org_report:
      'அறிக்கையை உருவாக்க நிறுவனம் ஒன்றைத் தேடி தேர்ந்தெடுக்கவும்.',
    org_image_not_found: 'படம் கிடைக்கவில்லை',
    insert_text: 'உரையை உள்ளிடவும்',
    insert_question_answer: 'கேள்வி/பதில் AI',
    modal_title2: 'உரைத் தொகுப்பு',
    my_text_library: 'என் உரை நூலகம்',
    ai: 'AI',
    public_text_library: 'பொது உரை நூலகம்',
    organization_text_library: 'நிறுவன உரை நூலகம்',
    no_transcribed_text: 'மொழிபெயர்க்கப்பட்ட உரை எதுவும் இல்லை',
    public_text_not_found: 'பொதுவான மொழிபெயர்ப்பு உரை காணவில்லை',
    org_text_not_found: 'நிறுவன மொழிபெயர்ப்பு உரை காணவில்லை',
    org_video_not_found: 'வீடியோ காணவில்லை',
    canva: 'Canva இல் செய்யவும்',
    canva_open: 'Canva திருத்தியைத் திறக்க இங்கே கிளிக் செய்யவும்.',
    pdf: 'PDF',
    txt: 'உரை',
    human: 'பிரீமியம்',
    shared_file: 'உங்கள் கோப்பு வெற்றிகரமாக பகிரப்பட்டுள்ளது.',
    error_shared_file:
      'கோப்பைப் பகிர்வதில் சிக்கல் ஏற்பட்டுள்ளது. மீண்டும் முயற்சிக்கவும்.',
    publish: 'வெளியிடு',
    maze_scenes: 'MetaMaze காட்சிகள்',
    pexel_images: 'Pexel படங்கள்',
    group: 'குழு',
    group_name: 'குழு பெயர்',
    select_group: 'குழுவைத் தேர்வு செய்க',
    search_maze: 'MetaMaze ஐத் தேடு',
    hosts: 'தொகுப்பாளர்கள்',
    avg_score: 'சதவீத மதிப்பெண்',
    maze_report: 'மேஸ் அறிக்கை',
    maze_view: 'மேஸ் காட்சி',
    title_maze: 'MetaMaze',
    author: 'ஆசிரியர்',
    match: 'பாதை பொருந்தும்',
    preview_mazeTitle: 'தலைப்பு:',
    other: 'மற்றவை',
    total: 'மொத்தம்',
    report_course: 'பாடநெறி',
    report_courses: 'பாடநெறிகள்',
    report_event: 'நிகழ்வு',
    report_events: 'நிகழ்வுகள்',
    report_maze: 'மேஸ்',
    report_personalize_learning: 'தனிப்பயன் கற்றல்',
    report_live_assessment: 'நேரடி மதிப்பீடு',
    report_live_assessments: 'நேரடி மதிப்பீடுகள்',
    report_skill_journey: 'திறன் பயணம்',
    skill_journey: 'திறன் பயணம்',
    skill_journeys: 'திறன் பயணங்கள்',
    date: 'தேதி:',
    search_people: 'மக்களைத் தேடவும்',
    passed: 'தேர்ச்சி பெற்றது',
    failed: 'தோல்வியடைந்தது',
    item: 'உருப்படி',
    type: 'வகை',
    minimum_pass_score: 'குறைந்தபட்ச தேர்ச்சி மதிப்பெண்',
    resources_count: 'ஆதார எண்ணிக்கை',
    back: 'மீண்டும்',
    resources: 'ஆதாரங்கள்',
    time_spent: 'பயன்படுத்திய நேரம் (நிமிடங்கள்)',
    detail: 'விவரம்',
    watched_time_mins: 'பார்த்த நேரம் (நிமிடங்கள்)',
    personalize_learning: 'தனிப்பயன் கற்றல்',
    result: 'முடிவு',
    assessment_title: 'தலைப்பு',
    marketPlace_graph: 'சந்தை வரைபடம்',
    attachments: 'கூடுதல் இணைப்புகள்',
    new_scorm_course: 'புதிய SCORM பாடத்தை பதிவேற்று',
    upload_scorm_course: 'SCORM பாடத்தை பதிவேற்று',
    new_maze: 'புதிய MetaMaze ஒன்றை உருவாக்கு',
    new_skill_journey: 'ஒரு திறன் பயணத்தை உருவாக்கு',
    tags_scorm: 'SCORM',
    tags_skillJourney: 'திறன் பயணம்',
    new_discussion_room: 'புதிய பாட்காஸ்ட் ஒன்றை உருவாக்கு',
    title: 'இன்று நீங்கள் என்ன செய்ய விரும்புகிறீர்கள்?',
    build_course: 'என் பாடத்தை உருவாக்கு',
    live_broadcast: 'நேரலை ஒளிபரப்பு',
    invite_users: 'என் நிறுவனம் பயனர்களை அழை',
    build_voice_over: 'என் குரல் ஒலிப்பதிவை உருவாக்கு',
    view_reports: 'அறிக்கைகளைப் பார்க்க',
    upload_media: 'என் ஊடகங்கள் அல்லது வேலைகளை பதிவேற்று மற்றும் பகிர்',
    main_menu: 'முக்கிய மெனு',
    get_started: 'தொடங்கு',
    search_group: 'நிறுவனக் குழுவைத் தேடு',
    ai_course: 'ஏ.ஐ. பாடம்',
    search_user: 'நிறுவனத்தின் பெயரைத் தேடு',
    no_maze: 'தற்போது எந்த MetaMaze இலும் இல்லை.',
    conference_event_title: 'மாநாட்டு நிகழ்வுகள்',
    conference_event_subTitle: 'முடிந்த மாநாட்டு நிகழ்வுகள்',
    conference_event: 'தற்போது எந்த மாநாட்டு நிகழ்வுகளும் இல்லை.',
    no_skill: 'தற்போது எந்த திறன் பயணங்களும் இல்லை.',
    no_podcast: 'தற்போது எந்த பாட்காஸ்டும் இல்லை.',
    maze_channel: 'MetaMaze',
    past_live_assessment: 'முந்தைய நேரலை மதிப்பீடுகள்',
    no_live_assessment: 'தற்போது எந்த நேரலை மதிப்பீடுகளும் இல்லை.',
    enrolled_courses: 'பாடங்கள்',
    my_video_channel: 'என் வீடியோ சேனல்கள்',
    enrolled_liveEvents: 'நேரலை நிகழ்வுகள்',
    sharebot: 'ஷேர்பாட்',
    selected_language: 'தேர்ந்தெடுத்த மொழி',
    shareSphere_game: 'ஷேர் ஸ்பியர் விளையாட்டு',
    maze: 'MetaMaze',
    skill: 'திறன் பயணம்',
    channel: 'சேனல்',
    order: 'ஆர்டர்',
    is_record: 'பதிவு',
    no_maze_found: 'எந்த MetaMaze கண்டுபிடிக்கப்படவில்லை.',
    maze_self_limit_reached:
      'MetaMaze சுய மதிப்பீட்டு வரம்பை அடைந்துவிட்டீர்கள்.',
    metamaze_two_times:
      'இந்த MetaMaze ஐ நீங்கள் ஏற்கனவே 2 முறை எடுத்துள்ளீர்கள்.',
    metamaze_two_times_no_result:
      'இந்த MetaMaze ஐ நீங்கள் 2 முறை எடுத்துள்ளீர்கள். மூன்றாவது முறையின் முடிவுகள் பதிவு செய்யப்படாது.',
    scorm_zip: 'SCORM ZIP',
    pass_score: 'தேர்ச்சி பெற தேவையான குறைந்தபட்ச மதிப்பெண்',
    organization: 'தயவுசெய்து ஒரு நிறுவனத்தைத் தேர்வுசெய்க',
    pass_score_mark: '1 முதல் 100 வரை மதிப்பெண்களை உள்ளிடவும்',
    maze_cloning_success: 'MetaMaze "<0/>" வெற்றிகரமாக நகலெடுக்கப்பட்டது!',
    create_certificate: 'சான்றிதழ் உருவாக்கு',
    create_badge: 'பதக்கம் உருவாக்கு',
    certificate_added: 'சான்றிதழ் சேர்க்கப்பட்டது.',
    badge_added: 'பதக்கம் சேர்க்கப்பட்டது.',
    certificate_warning:
      'சான்றிதழ்/பதக்கத்தை ஒரு முறை வெளியிட்ட பிறகு அதைத் திருத்த முடியாது!',
    created_course_plan:
      'உருவாக்கிய பாடத்தைத் திருத்தி, நேரலை நிகழ்வுகளை திட்டமிடு மற்றும் வெளியிடு',
    market_place_space: 'சந்தை இடம்',
    select_course_language: 'பாட மொழியைத் தேர்ந்தெடு (விருப்பத்தேர்வு)',
    select_language: 'மொழியைத் தேர்ந்தெடு',
    file_upload: 'கோப்பைப் பதிவேற்று',
    text: 'உரையை இங்கே எழுதவும்…',
    attempts_count: 'பயனர் முயற்சி செய்யக்கூடிய முறை எண்ணிக்கை',
    no_of_people_placeholder: 'நபர்களின் எண்ணிக்கை',
    back_to_maze: 'MetaMaze காட்சிக்கு திரும்பு',
    edit_maze: 'Maze ஐத் திருத்து',
    wait: 'காத்திருங்கள்...',
    retry: 'மீண்டும் முயற்சிக்கவும்',
    publish_scorm_course: 'உங்கள் SCORM பாடத்தை வெளியிடுங்கள்',
    publish_maze: 'உங்கள் MetaMaze ஐ வெளியிடுங்கள்',
    import: 'உள்ளடக்கங்களை இறக்குமதி செய்க',
    answer_correct: 'சரியான பதிலைத் தேர்ந்தெடுக்கவும்',
    author_name: 'தயவுசெய்து ஆசிரியரின் பெயரை உள்ளிடவும்',
    select_category: 'தயவுசெய்து வகையைத் தேர்ந்தெடுக்கவும்',
    course_outline: 'தயவுசெய்து பாடத்திட்ட அவுட்லைனை உள்ளிடவும்',
    course_obj: 'தயவுசெய்து பாடத்திட்ட நோக்கங்களை உள்ளிடவும்',
    course_description: 'தயவுசெய்து பாடத்திட்ட விளக்கத்தை உள்ளிடவும்',
    maze_outline: 'தயவுசெய்து மேஸ் அவுட்லைனை உள்ளிடவும்',
    maze_obj: 'தயவுசெய்து மேஸ் நோக்கங்களை உள்ளிடவும்',
    maze_description: 'தயவுசெய்து மேஸ் விளக்கத்தை உள்ளிடவும்',
    lessons: 'தயவுசெய்து பாடங்களின் எண்ணிக்கையை உள்ளிடவும்',
    user_email_require: 'பயனர் மின்னஞ்சல் தேவை',
    team_size: 'அணியின் அளவு தேவை',
    enter_price: 'தயவுசெய்து விலையை உள்ளிடவும் (5 அல்லது அதற்கு மேல்)',
    input_title_maze: 'தயவுசெய்து மேஸ் தலைப்பை உள்ளிடவும்',
    trainer_bio: 'தயவுசெய்து பயிற்சியாளர் சுயசரிதையை உள்ளிடவும்',
    trainer_linkedin: 'தயவுசெய்து பயிற்சியாளர் லிங்க்ட்இன் லிங்கை உள்ளிடவும்',
    error_video: 'தயவுசெய்து வீடியோ எண்ணிக்கையை உள்ளிடவும்',
    input_video_link: 'தயவுசெய்து வீடியோ லிங்கை உள்ளிடவும்',
    number_of_video: 'வீடியோ எண்ணிக்கை',
    number_of_lessions: 'பாடங்களின் எண்ணிக்கை',
    no_of_people_in_conference: 'மாநாட்டில் எத்தனை பேர் உள்ளனர்?',
    transcribe_settings: 'டிரான்ஸ்கிரைப் அமைப்புகள்',
    transcribe: 'டிரான்ஸ்கிரைப்',
    cloning_maze: 'மெட்டாமேஸை நகலெடுக்கிறது...',
    id_number: 'அடையாள எண்',
    timezone: 'நேர மண்டலம்',
    edit_maze: 'திருத்து',
    delete_maze: 'நீக்கு',
    view_maze: 'பார்வையிடு',
    create_metamaze: 'மெட்டாமேஸை உருவாக்கு',
    metamaze_scenario: 'மெட்டாமேஸ் காட்சி',
    publish_metamaze: 'வெளியீட்டு அமைப்புகள்',
    search_result: 'தேடல் முடிவுகள்:',
    search_for: 'தேடு',
    search_no_result: '- முடிவுகள் எதுவும் கிடைக்கவில்லை!',
    channel_no_available: 'சேனல் கிடைக்கவில்லை!',
    this_card: 'இது கார்டு',
    course_no_available: 'பாடத்திட்டங்கள் கிடைக்கவில்லை!',
    exit_fullscreen: 'முழுத் திரையிலிருந்து வெளியேறு',
    bg_image: 'பின்னணி படம்',
    introduction: 'அறிமுகம்',
    summary: 'சுருக்கம்',
    generate_introduction: 'அறிமுகம் உருவாக்கு',
    generate_summary: 'சுருக்கம் உருவாக்கு',
    bullet_points: 'முக்கிய புள்ளிகள்',
    title_simulation: 'தயவுசெய்து சிமுலேஷன் தலைப்பை உள்ளிடவும்',
    view_generated_images: 'உருவாக்கப்பட்ட படங்களைப் பார்வையிடு',
    image_transparency: 'படத்தின் வெளிப்படைத்தன்மை',
    template_bg_color: 'டெம்ப்ளேட் பின்னணி நிறம்',
    select_template_layout: 'டெம்ப்ளேட் அமைப்பைத் தேர்ந்தெடுக்கவும்',
    reload_template: '(டெம்ப்ளேட்களை மீண்டும் ஏற்று)',
    are_you_sure_want_close: 'நீங்கள் நிச்சயமாக மூட விரும்புகிறீர்களா?',
    all_your_changes_will_be_lost: 'உங்கள் எல்லா மாற்றங்களும் இழக்கப்படும்.',
    please_checked_before_generated_video:
      'வீடியோ உருவாக்குவதற்கு முன் அனைத்து நிபந்தனைகளும் நிறைவேற்றப்பட்டுள்ளன என்பதை உறுதிப்படுத்தவும்.',
    voice_must_be_selected: 'குரல் தேர்ந்தெடுக்கப்பட வேண்டும்',
    avatar_must_be_selected: 'அவதார் தேர்ந்தெடுக்கப்பட வேண்டும்.',
    maximum_five_slides_try_again:
      'உங்கள் கோப்பிலிருந்து படங்களை பிரித்தெடுப்பதில் பிழை. 5க்கு மேல் ஸ்லைடுகள் இல்லை என்றும் ஒவ்வொன்றிலும் உள்ளடக்கம் உள்ளது என்றும் உறுதிப்படுத்தவும். தயவுசெய்து மீண்டும் முயற்சிக்கவும்!',
    back_to_upload: 'அப்லோடுக்கு திரும்பு',
    uploading_file_to_server: 'சர்வரில் கோப்பை அப்லோட் செய்கிறது',
    extracting_images_from_your_file:
      'உங்கள் கோப்பிலிருந்து படங்களை பிரித்தெடுக்கிறது',
    upload_your_ppt_or_drag:
      'உங்கள் பிரசன்டேஷன் கோப்பை (.PPTX) அப்லோட் செய்யவும் அல்லது இங்கே இழுக்கவும்.',
    maximum_five_slides_error:
      'பவர்பாயிண்ட் கோப்பில் 5 ஸ்லைடுகளுக்கு மேல் இல்லை என்றும் ஒவ்வொரு ஸ்லைடிலும் உள்ளடக்கம் உள்ளது என்றும் உறுதிப்படுத்தவும். இல்லையெனில், பிழை ஏற்படும்.',
    number_of_questions_generated: 'உருவாக்கப்பட வேண்டிய கேள்விகளின் எண்ணிக்கை',
    quiz_page_this_cannot_be_done:
      'இந்தப் பக்கத்தில் குவிஸ் சேர்க்க விரும்புகிறீர்களா? இதைச் செயல்தவிர்க்க முடியாது.',
    confirm_selection: 'தேர்வை உறுதிப்படுத்து',
    select_quiz_page: 'குவிஸ் பக்கத்தைத் தேர்ந்தெடுக்கவும்',
    lesson_do_you_want_add_this_quiz:
      'பாடத்தின் எந்தப் பகுதியில் இந்த குவிஸை சேர்க்க விரும்புகிறீர்கள்?',
    beginning_of_lesson: 'பாடத்தின் தொடக்கத்தில்',
    end_of_lesson: 'பாடத்தின் முடிவில்',
    currently_active_page: 'தற்போது செயலில் உள்ள பக்கம்',
    finish: 'முடிக்கவும்',
    upload_selection_file: 'தேர்வு கோப்பை அப்லோட் செய்யவும்',
    general_quiz: 'பொதுவான குவிஸ்',
    manage_sequence: 'வரிசையை நிர்வகிக்கவும்',
    save_sequence: 'வரிசையை சேமிக்கவும்',
    new: 'புதிய',
    in_progress: 'முன்னேற்றத்தில்',
    recommended_course: 'பரிந்துரைக்கப்பட்ட பாடத்திட்டம்',
    up_coming: 'வரவிருக்கும்',
    past_live: 'கடந்த நேரலை',
    input_your_channel_name: 'தயவுசெய்து உங்கள் சேனல் பெயரை உள்ளிடவும்!',
    organization_place: 'நிறுவன இடம்',
    marketplace_report: 'சந்தை அறிக்கை',
    story_writing: 'கதை எழுதுதல்',
    Ai_quiz: 'செயற்கை நுண்ணறிவு குவிஸ்',
    generate_quiz: 'குவிஸ் உருவாக்கு',
    create_story: 'கதை உருவாக்கு',
    change_layout_page:
      'நீங்கள் இந்தப் பக்கத்தின் அமைப்பை மாற்றப் போகிறீர்கள்.',
    change_layout_message:
      'உரை, படங்கள், பின்னணி மற்றும் லோகோ மட்டுமே சேமிக்கப்படும் என்பதை நினைவில் கொள்ளவும். மற்ற எல்லா உறுப்புகளும் அகற்றப்படும்.',
    reviews: 'மதிப்புரைகள்',
    tab_attachments: 'இணைப்புகள்',
    zoom_in: 'பெரிதாக்கு',
    zoom_out: 'சிறிதாக்கு',
    zoom_reset: 'பெரிதாக்கலை மீட்டமை',
    no_attachment: 'இணைப்புகள் இல்லை.',
    select_upload_simulation:
      'தயவுசெய்து சிமுலேஷனைத் தேர்ந்தெடுக்கவும்/அப்லோட் செய்யவும்.',
    quiz_updated_successfully: 'குவிஸ் வெற்றிகரமாக புதுப்பிக்கப்பட்டது!',
    quizes: 'குவிஸ்கள்',
    trivia: 'பொது அறிவு கேள்விகள்',
    closing: 'மூடுகிறது...',
    products: 'தயாரிப்புகள்',
    ask_questions: 'உங்கள் கேள்வியை இங்கே பதிவு செய்யவும்...',
    course_information: 'பாடநெறி தகவல்',
    course_assistance: 'பாடநெறி உருவாக்குநருக்கான உதவி',
    go_back: 'மீண்டும் செல்',
    ai_generate_content_progress: 'உள்ளடக்கம் உருவாக்கப்படுகிறது...',
    view_generate_content: 'உருவாக்கப்பட்ட உள்ளடக்கத்தைப் பார்க்க',
    generate_error: 'உள்ளடக்கம் உருவாக்கப்படுவதில் பிழை!',
    confirm_creating_course:
      'இந்த உள்ளடக்கத்துடன் பாடநெறியை உருவாக்க விரும்புகிறீர்களா?',
    generate_content_automatically:
      'இது உருவாக்கப்பட்ட அனைத்து உள்ளடக்கத்தையும் தானாகவே பாடநெறியில் பாடங்களாகவும் பக்கங்களாகவும் சேர்க்கும்.',
    quiz_created_successfully: 'வினாத்தாள் வெற்றிகரமாக உருவாக்கப்பட்டது!',
    create_quiz: 'வினாத்தாள் உருவாக்கவும்',
    quiz_setting: 'வினாத்தாள் அமைப்புகள்',
    please_fill_quiz_setting:
      '* தயவுசெய்து வினாத்தாள் அமைப்புகளை முழுமையாக நிரப்பவும்',
    question_list: 'கேள்விகள் பட்டியல்',
    add_quiz_to_page: 'வினாத்தாளை பக்கத்தில் சேர்க்கவும்',
    form_create_question: 'கேள்வி உருவாக்கும் படிவம்',
    user_information_updated: 'பயனர் தகவல் வெற்றிகரமாக புதுப்பிக்கப்பட்டது!',
    your_stripe_activete_to_continue:
      'உங்கள் Stripe கணக்கு செயலிலில்லை. தொடர இணைக்கவும் அல்லது செயல்படுத்தவும்.',
    connect_tripe: 'Stripe-ஐ இணைக்கவும்',
    certificate_sent_sucessfully:
      'சான்றிதழ் உங்கள் மின்னஞ்சலுக்கு வெற்றிகரமாக அனுப்பப்பட்டது.',
    error_try_again: 'பிழை. மீண்டும் முயற்சிக்கவும்!',
    error_delete_channel: 'சேனலை அழிக்கும்போது பிழை ஏற்பட்டது.',
    error_update_sub: 'சந்தாவை புதுப்பிக்க முடியவில்லை.',
    end_time_cannot_start:
      'முடிவு நேரம் தொடக்கம் நேரத்தைக் காட்டிலும் குறைவாக இருக்க முடியாது.',
    start_date_time_interval: 'தொடங்கும் தேதி மற்றும் நேரம் தேவை!',
    podcast_updated_successful: 'பாட்காஸ்ட் வெற்றிகரமாக புதுப்பிக்கப்பட்டது.',
    podcast_created_successful: 'பாட்காஸ்ட் வெற்றிகரமாக உருவாக்கப்பட்டது.',
    podcast_published_successful: 'பாட்காஸ்ட் வெற்றிகரமாக வெளியிடப்பட்டது.',
    podcast_cover_updated: 'பாட்காஸ்ட் அட்டைப்படம் புதுப்பிக்கப்பட்டது.',
    new_podcast_details: 'புதிய விவரங்களுடன் புதிய பாட்காஸ்ட் உருவாக்கப்படும்.',
    current_update_podcast:
      'தற்போதைய பாட்காஸ்ட்டை புதுப்பிக்கவும் (இசை மற்றும் கதைகள் உட்பட).',
    create_new_podcast: 'புதிய பாட்காஸ்ட் உருவாக்கவும்',
    publish_podcast_public_view: 'பாட்காஸ்ட்டை பொதுவாகப் பகிரவும்',
    only_allowed_twenty_five_email:
      'அதிகபட்சம் 25 மின்னஞ்சல்கள் மட்டுமே அனுமதிக்கப்படும்.',
    only_allowed_five_email:
      'அதிகபட்சம் 5 மின்னஞ்சல்கள் மட்டுமே அனுமதிக்கப்படும்.',
    cover_is_required: 'கவர் படம் தேவை.',
    topic_is_required: 'தலைப்பு தேவை.',
    delete_schedule: 'அட்டவணையை நீக்கவும்',
    make_as_coaching: 'தகுதிப்படுத்தல் அமர்வாக மாற்றவும்',
    manage_category: 'வகையை நிர்வகிக்கவும்',
    threshold: 'வரம்பு',
    threshold_popup:
      'ஒரு குறிப்பிட்ட வகைக்கான பரிந்துரையை உருவாக்கும் சதவீதம் (%)',
    list_of_catagory: 'வகைகள் பட்டியல்',
    category_name: 'வகை பெயர்',
    category_threshold: 'வகையின் வரம்பு',
    play_game: 'விளையாடவும்',
    switching_organization: 'அமைப்பை மாற்றுகிறது...',
    coaching_session: 'தகுதிப்படுத்தல் அமர்வு',
    required_channel_id: 'Channel ID தேவை!',
    error_occured_try_again: 'பிழை ஏற்பட்டது. மீண்டும் முயற்சிக்கவும்!',
    please_complete_marketplace_form:
      'தயவுசெய்து மார்க்கெட்பிளேஸ் படிவத்தை முடிக்கவும்!',
    upload_file_corrupt: 'பதிவேற்றிய கோப்பு சேதமடைந்துள்ளது.',
    course_not_published: 'இந்த பாடநெறி இன்னும் வெளியிடப்படவில்லை!',
    error_request:
      'வேண்டுகோளில் பிழை ஏற்பட்டது. தயவுசெய்து மீண்டும் முயற்சிக்கவும்!',
    skill_request: 'தேவையான புலங்களை நிரப்பவும்!',
    error_occured: 'பிழை ஏற்பட்டது. மீண்டும் முயற்சிக்கவும்!',
    show_time: 'நேரத்தை காட்டு',
    start_time: 'தொடக்க நேரம்',
    end_time: 'முடிவு நேரம்',
    room_name: 'பாட்காஸ்ட் அறையின் பெயர்',
    add_guest_speaker: 'விருந்தினர் பேச்சாளரைச் சேர்க்கவும்',
    cover_picture: 'கவர் படம்',
    guest_speaker: 'விருந்தினர் பேச்சாளர்',
    see_more: 'மேலும் காண்க',
    see_less: 'குறைவாக காண்க',
    background: 'பின்புலம்',
    icon: 'அடையாளம்',
    icon_size: 'அடையாளத்தின் அளவு',
    icon_color: 'அடையாளத்தின் நிறம்',
    only_text: 'வெறும் உரை',
    change_bg: 'பின்புல நிறத்தை மாற்றவும்',
    bg_color: 'பின்புல நிறம்',
    font_size: 'எழுத்தளவு',
    normal: 'இயல்பானது',
    change_color: 'உரையின் நிறத்தை மாற்றவும்',
    slant_text: 'சாய்ந்த உரை',
    text_radius: 'உரையின் வட்டமயமாக்கல்',
    vertical_align: 'செங்குத்து அடுக்கம்',
    horizontal_align: 'கிடைமட்ட அடுக்கம்',
    change_icon_color: 'அடையாளத்தின் நிறத்தை மாற்றவும்',
    upload_icon: 'அடையாளத்தை பதிவேற்றவும்',
    upload_signature: 'கையொப்பத்தை பதிவேற்றவும்',
    add_another_sign: 'மற்றொரு கையொப்பத்தைச் சேர்க்கவும்',
    name_badges: 'பேட்ஜ் பெயர்',
    should_less_150: '150 எழுத்துகள் அல்லது அதற்குள் இருக்க வேண்டும்',
    your_badge: 'உங்கள் பேட்ஜ்',
    do_you_want_delete_badge: 'இந்த பேட்ஜை நீக்க விரும்புகிறீர்களா?',
    do_you_want_delete_cert: 'இந்த சான்றிதழை நீக்க விரும்புகிறீர்களா?',
    upload_logo: 'லோகோவை பதிவேற்றவும்',
    name_of_cert: 'சான்றிதழின் பெயர்',
    upload_cert: 'சான்றிதழை புதுப்பிக்கவும்',
    your_cert: 'உங்கள் சான்றிதழ்',
    translate_to: 'மொழிபெயர்க்கவும்',
    select_file_attach: 'இணைக்க கோப்பை தேர்ந்தெடுக்கவும்',
    certificate: 'சான்றிதழ்',
    badge: 'பேட்ஜ்',
    publish_options: 'வெளியீட்டு விருப்பங்கள்',
    publish_skills_journey: 'திறன்கள் பயணத்தை வெளியிடவும்',
    videos: 'வீடியோக்கள்',
    generate_ai_video:
      'AI வீடியோ உருவாக்கம் நேரம் எடுக்கலாம். தயார் ஆனதும் மின்னஞ்சலில் தெரிவிக்கப்படும்.',
    trainer_information: 'பயிற்றுநர் தகவல்',
    promotional_video_link: 'விளம்பர வீடியோ இணைப்பு',
    please_select: 'தயவுசெய்து தேர்ந்தெடுக்கவும்',
    image_name: 'படப்பெயர்:',
    image_size: 'படத்தின் அளவு:',
    charecters_fifteen_less: '15 எழுத்துகள் அல்லது அதற்குள்',
    leadership: 'முன்னணித்துவம்',
    text_arc: 'வட்ட உரை',
    vertical: 'செங்குத்து',
    horizontal: 'கிடைமட்டம்',
    badge_history: 'பேட்ஜ் வரலாறு',
    templates: 'மாதிரிகள்',
    sign: 'கையொப்பம்',
    logo: 'லோகோ',
    certificate_history: 'சான்றிதழ் வரலாறு',
    please_wait: 'தயவுசெய்து காத்திருக்கவும்...',
    information: 'தகவல்',
    support_five_thousand_live_event:
      '5000 நபர்களை ஒரே நேரத்தில் ஆதரிக்கும் நேரடி நிகழ்வு',
    support_ten_live_event: '10 நபர்களை வீடியோ நேரடி நிகழ்வில் ஆதரிக்கும்',
    we_will_back_participant: 'அதிகமான பங்கேற்பாளர்களுடன் மீண்டும் வருவோம்.',
    course_objectives: 'பாடநெறி நோக்கங்கள்',
    course_outlines: 'பாடத்திட்டம்',
    price_dollor: 'விலை (USD)',
    not_completed: 'முடிக்கப்படவில்லை',
    enable_marketplace: 'மார்க்கெட்பிளேஸை இயக்கவும்',
    enable_course_ai: 'AI மூலம் பாடநெறி உருவாக்கத்தை இயக்கவும்',
    enable_report_to_admin: 'நிர்வாகிக்கு அறிக்கையை இயக்கவும்',
    enable_white_label: 'வைவெள்ளை லேபிள் (White Label) ஐ இயக்கவும்',
    enable_eleven_labs_for_maze_play: 'Maze Play-க்கு Elevenlabs ஐ இயக்கவும்',
    enable_eleven_labs_for_maze_play_cloned:
      'Clone செய்யப்பட்ட Elevenlabs குரலை இயக்கவும்',
    simulation_quiz: 'முறைப்படுத்திய வினாத்தாள்',
    bg_color_setting: 'பின்புல நிற அமைப்புகள்',
    color_preview: 'நிற முன்னோட்டம்',
    choose_new_color: 'புதிய நிறத்தை தேர்ந்தெடுக்கவும்',
    remove_color: 'நிறத்தை அகற்றவும்',
    apply_color: 'நிறத்தை பயன்படுத்தவும்',
    elemeent_in_a_sceenario_page:
      'காட்சிப் பக்கத்தில் இன்னொரு உருப்படியைச் சேர்க்க முடியாது. வேறு பக்கம் அல்லது தற்போது உள்ளதை அகற்றவும்.',
    no_data_found: 'தரவு எதுவும் கிடைக்கவில்லை.',
    references: 'குறிப்புகள்',
    open_file: 'கோப்பை திறக்கவும்',
    showing_result: 'முடிவுகளை காட்டுகிறது:',
    fiften_day_free_trail: '15 நாள் இலவச சோதனை',
    your_browser_does_not_support:
      'உங்கள் உலாவி இந்த ஒலி கூறுகளை ஆதரிக்கவில்லை.',
    podcast_desc: 'பாட்காஸ்ட் விவரம்',
    input_podcast_desc: 'தயவுசெய்து பாட்காஸ்ட் விவரத்தை உள்ளிடவும்',
    podcast_obj: 'பாட்காஸ்ட் நோக்கங்கள்',
    input_podcast_obj: 'தயவுசெய்து பாட்காஸ்ட் நோக்கங்களை உள்ளிடவும்',
    podcast_outline: 'பாட்காஸ்ட் வரைவமைப்பு',
    input_podcast_outline: 'தயவுசெய்து பாட்காஸ்ட் வரைவமைப்பை உள்ளிடவும்',
    add_file: 'கோப்பை சேர்க்கவும்',
    generate_podcast_audio: 'பாட்காஸ்ட் ஒலியை உருவாக்கவும்',
    generate_uploaded_file_input_parameter:
      'பயனர் பதிவேற்றிய கோப்புகளின் உள்ளீட்டுப் பரிமாணங்களின் அடிப்படையில் உள்ளடக்கத்தை உருவாக்குகிறது.',
    go_backe_generation_state: 'உள்ளடக்க உருவாக்க நிலைக்குச் செல்லவும்.',
    create_ai_powered_podcast:
      'AI இயந்திரத்தால் இயக்கப்படும் பாட்காஸ்ட் எபிசோட்களை உருவாக்கவும்.',
    generate_voice_for_all_podcast:
      'தயவுசெய்து அனைத்து பாட்காஸ்ட் எபிசோட்களுக்குமான குரலை உருவாக்கவும்',
    create_podcast_episode: 'பாட்காஸ்ட் எபிசோட்டை உருவாக்கவும்',
    voice_name: 'குரல் பெயர்',
    input_custom_name: 'தயவுசெய்து தனிப்பயன் பெயரை உள்ளிடவும்!',
    enter_custom_name: 'தனிப்பயன் குரல் பெயரை உள்ளிடவும்',
    upload_complete: 'பதிவேற்றம் முடிந்தது',
    uploading_in_progress: 'பதிவேற்றம் நடந்து கொண்டிருக்கிறது...',
    podcast_stream_content: 'பாட்காஸ்ட் ஒளிபரப்பு உள்ளடக்கம்',
    upload_podcast_cover: 'தயவுசெய்து பாட்காஸ்ட் அட்டையை பதிவேற்றவும்!',
    enter_podcast_name: 'தயவுசெய்து பாட்காஸ்ட் பெயரை உள்ளிடவும்!',
    podcast_topic: 'பாட்காஸ்ட் தலைப்பு',
    enter_podcast_topic: 'தயவுசெய்து பாட்காஸ்ட் தலைப்பை உள்ளிடவும்!',
    enter_podcast_desc: 'தயவுசெய்து பாட்காஸ்ட் விவரத்தை உள்ளிடவும்!',
    number_of_speaker: 'பேசுபவர்களின் எண்ணிக்கை',
    select_the_number_of_speaker:
      'தயவுசெய்து பேசுபவர்களின் எண்ணிக்கையைத் தேர்வுசெய்க!',
    number_of_episode: 'எபிசோட்களின் எண்ணிக்கை',
    input_number_of_episode: 'தயவுசெய்து எபிசோட்களின் எண்ணிக்கையை உள்ளிடவும்!',
    podcast_length: 'பாட்காஸ்ட் நீளம்',
    select_the_podcast_length: 'தயவுசெய்து பாட்காஸ்ட் நீளத்தைத் தேர்வுசெய்க!',
    short_podcast: 'குறைந்தது (5-10 நிமிடம்)',
    medium_podcast: 'மத்தியம் (15-18 நிமிடம்)',
    long_podcast: 'நீண்டது (18+ நிமிடம்)',
    name_of_host: 'தொகுப்பாளரின் பெயர்',
    enter_host_name: 'தயவுசெய்து தொகுப்பாளரின் பெயரை உள்ளிடவும்!',
    guest_name: 'விருந்தினர் பெயர்',
    enter_guest_name: 'தயவுசெய்து விருந்தினர் பெயரை உள்ளிடவும்!',
    choose_speaker_tone: 'பேசுபவரின் தொனியைத் தேர்வுசெய்க',
    enter_speaker_tone: 'தயவுசெய்து பாட்காஸ்ட் தொனியைத் தேர்வுசெய்க!',
    informal: 'தனித்துவமானது',
    formal: 'அதிகாரபூர்வமானது',
    serious: 'தீவிரமானது',
    light_humor: 'லேசான நகைச்சுவை',
    casual: 'சாதாரணமானது',
    select_content_source: 'உள்ளடக்க மூலத்தைத் தேர்வுசெய்க',
    from_internet: 'இணையத்திலிருந்து',
    upload_pdf_internet: 'PDF அல்லது உள் ஆவணத்தை பதிவேற்றவும்',
    note: 'குறிப்பு:',
    podcast_content_will_be_automatically_generated:
      'பாட்காஸ்ட் உள்ளடக்கம் நம்பிக்கைக்குரிய இணையத் தகவல்களை அடிப்படையாகக் கொண்டு தானாக உருவாக்கப்படும்.',
    upload_or_select_file:
      'தயவுசெய்து கோப்புகளை பதிவேற்றவும் அல்லது தேர்வுசெய்க!',
    podcast_eposode_title: 'பாட்காஸ்ட் எபிசோட் தலைப்பு',
    enter_podcast_title: 'தயவுசெய்து எபிசோட் தலைப்பை உள்ளிடவும்!',
    podcast_episode_des: 'பாட்காஸ்ட் எபிசோட் விவரம்',
    enter_podcast_episode_des: 'தயவுசெய்து எபிசோட் விவரத்தை உள்ளிடவும்!',
    voice: 'குரல்',
    music: 'இசை',
    select_music: 'இசையைத் தேர்ந்தெடுக்கவும்',
    play_the_music: 'இசையை வாசிக்கவும்',
    stop_the_music: 'இசையை நிறுத்தவும்',
    context: 'சூழ்நிலை',
    generate_audio_content_selected_voice:
      'தேர்ந்தெடுக்கப்பட்ட குரல்களின் அடிப்படையில் ஒலி உள்ளடக்கம் உருவாக்கப்படும்.',
    required_field_before_submitting:
      'சமர்ப்பிப்பதற்கு முன் அனைத்து கட்டாய புலங்களையும் நிரப்பவும்.',
    regenerate_voice: 'குரலை மீண்டும் உருவாக்கவும்',
    generate_voice: 'குரலை உருவாக்கவும்',
    your_browser_does_not_suppot: 'உங்கள் உலாவி ஒலி கூறுகளை ஆதரிக்கவில்லை.',
    are_sure_leave_podcast: 'பாட்காஸ்டை விட்டு வெளியேற விரும்புகிறீர்களா?',
    broadcast_ongoing:
      'ஒளிபரப்பு நடந்து கொண்டிருக்கிறது. இந்தப் பக்கத்திலிருந்து வெளியேற விரும்புகிறீர்களா?',
    brodcaster_unavailable: 'தற்போது ஒளிபரப்பாளர் கிடைக்கவில்லை.',
    setting_calender_for_booking: 'முன்பதிவுக்கான நாட்காட்டியை அமைக்கிறது',
    add_calender: 'நாட்காட்டியைச் சேர்க்கவும்',
    waiting_join_host: 'தொகுப்பாளர் இணைவதற்காக காத்திருக்கிறது...',
    no_reviews_found: 'மதிப்பீடுகள் எதுவும் காணப்படவில்லை.',
    rated_already:
      'இந்த நேரடி நிகழ்வுக்கு நீங்கள் ஏற்கனவே மதிப்பீடு செய்துள்ளீர்கள்.',
    downlink_png: 'png பதிவிறக்கவும்',
    downlink_jpg: 'jpg பதிவிறக்கவும்',
    donwload_file_format:
      'பதிவிறக்க விரும்பும் கோப்பு வடிவத்தைத் தேர்ந்தெடுக்கவும்.',
    crashed_event:
      'இந்த நிகழ்வு சிக்கல் காரணமாக முடங்கியது. புதிய நிகழ்வை உருவாக்கவும். இந்த தாமதத்திற்கு மன்னிக்கவும்.',
    prompt: 'கேள்வி:',
    generated_image:
      '🚀 உங்கள் படத்தை உருவாக்கி கொண்டு இருக்கிறது... தயவுசெய்து காத்திருங்கள்.',
    download_add: 'அனைத்தையும் பதிவிறக்கவும்',
    setting_generator: 'உருவாக்கி அமைப்பு',
    enter_image_prompt:
      'தயவுசெய்து படம் உருவாக்க வேண்டிய வழிகாட்டியைக் கொடுக்கவும்',
    image_prompt: 'பட உந்துதலை உள்ளிடவும்',
    negative_prompt: 'எதிர்மறை உந்துதல்',
    negative_image_prompt: 'எதிர்மறை பட உந்துதலை உள்ளிடவும்',
    number_output: 'வெளியீடுகளின் எண்ணிக்கை',
    enter_number_output: 'வெளியீடுகளின் எண்ணிக்கையை உள்ளிடவும்',
    image_style: 'படத்திற்கு ஒரு பாணியைத் தேர்ந்தெடுக்கவும்',
    output_format: 'வெளியீடு வடிவம்',
    seeds: 'விதைகள்',
    enter_seeds: 'விதை எண்ணிக்கையை உள்ளிடவும்',
    performance_mode: 'செயல்திறன் முறை',
    quality: 'தரம்',
    speed: 'வேகம்',
    balanced: 'சமநிலை',
    guidance_scale: 'வழிகாட்டி அளவு',
    enter_guidance: 'வழிகாட்டி அளவை உள்ளிடவும்',
    select_image: 'தயவுசெய்து படத்தைத் தேர்ந்தெடுக்கவும்.',
    image_prmt: 'பட உந்துதல்',
    generate_image_list_empty: 'உருவாக்கப்பட்ட பட பட்டியல் காலியாக உள்ளது.',
    knowledge_center_tooltrip_des:
      'பொதுத் தகவல் மற்றும் அறிவுக் கேள்விகளுக்கு சுருக்கமான மற்றும் சூழ்நிலைக்கு ஏற்ப பதில்கள் வழங்கப்படுகின்றன. இந்த பதில்கள் இணையத்திலுள்ள பல்வேறு ஆதாரங்களில் இருந்து பயிற்சி பெற்ற AI மாதிரியின் அடிப்படையில் உருவாக்கப்படுகின்றன.',
    contexts: 'சூழ்நிலைகள்',
    ai_processing_video_sharebot:
      'இந்த வீடியோவின் AI செயலாக்கம் முடிவடைய 24 மணி நேரம் வரை எடுத்துக் கொள்ளலாம் மற்றும் பிறகு Sharebot-இல் பிரதிபலிக்கப்படும்.',
    remove_sharebot_video:
      'இந்த வீடியோவின் Sharebot குறிப்பு நீக்க விரும்பினால், அதனுடன் தொடர்புடைய உரையையும் நீக்கவும்.',
    remove_sharebot_video_audio:
      'உரையை நீக்கினால் சம்பந்தப்பட்ட வீடியோ/ஆடியோ Sharebot-இல் காண்பிக்கப்படாது, ஆனால் மீடியா நூலகத்தில் வீடியோ காணப்படும்.',
    monthly_live_stream:
      'உங்கள் மாத ஒளிபரப்புக் கோட்டையை மாற்ற, தயவுசெய்து தொடர்புகொள்ளவும்',
    monthly_transcribe_limit:
      'உங்கள் மாத எழுத்தாக்க வரம்பை மாற்ற, தயவுசெய்து தொடர்புகொள்ளவும்',
    must_be_one_to_three_hundred:
      '1 முதல் 300 நிமிடங்களுக்கு இடையில் இருக்க வேண்டும்.',
    all_field_required: 'அனைத்து புலங்களும் தேவை.',
    duration_minute: 'கால அளவு (அதிகபட்சம் 300 நிமிடங்கள்)',
    gender: 'பாலினம்',
    select_gender: 'பாலினத்தை தேர்வுசெய்க',
    accent: 'உச்சரிப்பு',
    select_accent: 'உச்சரிப்பைத் தேர்வுசெய்க',
    create_voice: 'குரலை உருவாக்கவும்',
    enter_voice_name: 'குரலின் பெயரை உள்ளிடவும்',
    select_voice_gender: 'தயவுசெய்து குரலின் பாலினத்தைத் தேர்ந்தெடுக்கவும்',
    upload_voice: 'உங்கள் குரலை பதிவேற்றவும்',
    upload_voice_mp_three: 'உங்கள் குரலை பதிவேற்றவும் (.mp3)',
    cloned_voice: 'நகலெடுக்கப்பட்ட குரல்கள்',
    voice_type: 'குரல் வகை',
    select_voice_type: 'குரல் வகையைத் தேர்ந்தெடுக்கவும்',
    sharelook_stand: 'ஸ்டாண்டர்ட்',
    sharelook_premium: 'பிரீமியம்',
    sharelook_custum_voice: 'தனிப்பயன் (குரல் நகலெடுக்கும்)',
    create_auto_flow: 'தானாக ஓட்டத்தை உருவாக்கு',
    how_many_layers: 'எத்தனை அடுக்குகள்',
    verify_selection: 'தேர்வை சரிபார்க்கவும்',
    uploaded_successful: 'வெற்றிகரமாக பதிவேற்றப்பட்டது',
    upload_failed: 'பதிவேற்றம் தோல்வியடைந்தது',
    upload_only_five_mb:
      'உள்ளடக்கத்தை பதிவேற்றவும் (PDF கோப்புகள், அதிகபட்சம் 5)',
    docs_from_org_library:
      'அமைப்பின் நூலகத்திலிருந்து ஆவணங்களைப் பயன்படுத்தவும்',
    failed_maze_generate:
      'மயக்கப்படையை உருவாக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.',
    generate_metamaze: 'மெட்டாமேஸை உருவாக்குகிறது...',
    metamaze_being_generated:
      'உங்கள் மெட்டாமேஸை தற்போது உருவாக்கப்படுகிறது. முடிந்தவுடன் மின்னஞ்சல் மூலம் அறிவிக்கப்படும்.',
    metamaze_generate_successfully: 'மெட்டாமேஸ் வெற்றிகரமாக உருவாக்கப்பட்டது!',
    metamaze_with_proceed: 'இப்போது மெட்டாமேஸைத் தொடர்ந்து செல்லலாம்.',
    ai_metamaze_generate: 'AI மெட்டாமேஸ் உருவாக்கம்',
    what_kind_maze_create:
      'எந்த வகையான மயக்கப்படையை உருவாக்க விரும்புகிறீர்கள்?',
    manual_metamaze_creation: 'கைமுறையாக மெட்டாமேஸ் உருவாக்கம்',
    manually_maze_customizing_scnario:
      'காட்சியும் விருப்ப மரத்தையும் தனிப்பயனாக்கி கைமுறையாக உருவாக்கவும்',
    maze_ai_generated: 'AI மூலம் தானாக மயக்கப்படை உருவாக்கப்பட்டது',
    unmark_deadend: 'முடிவாக குறிக்க வேண்டாம்',
    mark_deadend: 'முடிவாக குறிக்கவும்',
    select_multiple_image_for_scenario:
      'காட்சிக்காக பல படங்களைத் தேர்ந்தெடுக்கலாம்.',
    select_your_image: 'தேர்ந்தெடுத்த படங்கள்',
    click_to_preview: 'முன்னோட்டத்தைக் காண கிளிக் செய்யவும்',
    are_you_sure_delete_image: 'இந்த படத்தை அழிக்க விரும்புகிறீர்களா?',
    select_image_from_library: 'ஊடக நூலகத்திலிருந்து படம் தேர்ந்தெடுக்கவும்',
    uploading_video: 'வீடியோ பதிவேற்றம் நடைபெறுகிறது...',
    tree_node_type: 'மரம் நொட்களின் வகை',
    correct_option_scenario: 'சரியான விருப்பம் அல்லது காட்சி',
    incorrect_option: 'தவறான விருப்பம்',
    option_scenario_without_text: 'எழுத்து இல்லாமல் விருப்பம் அல்லது காட்சி',
    dead_end: 'முடிவு (சிவப்பு எல்லை)',
    correct_path: 'சரியான பாதை',
    incorrect_path_not_selected_correct_option_path:
      'தவறான பாதை / சரியான விருப்பம் தேர்ந்தெடுக்கப்படாத பாதை.',
    double_click_on_tree_node:
      'மர நொடில் இருமுறை கிளிக் செய்தால், அந்தக் குறிப்பிட்ட உள்ளடக்கம் காணும் வகையில் எழுத்து தொகுப்பி தானாகச் சறுக்கும்.',
    add_scenario: 'காட்சியைச் சேர்க்கவும்',
    add_option: 'விருப்பத்தைச் சேர்க்கவும்',
    an_error_occured: 'ஒரு பிழை ஏற்பட்டது:',
    download_summary: 'சுருக்கத்தை பதிவிறக்கவும்',
    step_wise_analysis: 'படியாக பகுப்பாய்வு',
    step: 'படி',
    upload_csv_file: 'CSV கோப்பை பதிவேற்றவும்',
    download_template_to_import:
      'இறக்குமதிக்கான மாதிரி டெம்ப்ளேட்டை பதிவிறக்கவும்',
    please_input_email: 'மின்னஞ்சலை உள்ளிடவும்.',
    email_at_least_three_characters:
      'மின்னஞ்சல் குறைந்தது மூன்று எழுத்துகளாக இருக்க வேண்டும்.',
    email_cannot_be_empty: 'மின்னஞ்சல் காலியாக இருக்க முடியாது.',
    input_email_in_new_line:
      'தயவுசெய்து ஒவ்வொரு மின்னஞ்சலையும் புதிய வரியில் உள்ளிடவும்',
    role: 'பங்கு',
    select_role: 'தயவுசெய்து ஒரு பங்கைத் தேர்ந்தெடுக்கவும்',
    select_group: 'தயவுசெய்து குழுவைத் தேர்ந்தெடுக்கவும்',
    identification_number: 'அடையாள எண் (விருப்பமானது)',
    add_identification_number: 'தயவுசெய்து அடையாள எண்ணைச் சேர்க்கவும்',
    pie_chart_of_all_categories:
      'Sharelook-இல் பயன்பாட்டின் அடிப்படையில் அனைத்து வகைகளின் வட்டப்படவட்ட வரைபடம்.',
    total_sharesphere_question_answered_by_users:
      'தற்போதைய நிறுவனத்தில் பயனர்கள் பதிலளித்த ShareSphere கேள்விகளின் மொத்த எண்ணிக்கை, அவை மற்றும் வெற்றி/தோல்வி விவரங்களுடன்.',
    voice_style_over_the_text: `நீங்கள் டைப் செய்கிற எழுத்துகளில் பல குரல் பாணிகளைப் பயன்படுத்தலாம். பிளா பிளா பிளா. Lorem Ipsum என்பது அச்சிடும் மற்றும் அமைக்கும் தொழில்நுட்பத்தில் பாவிக்கப்படும் மாதிரி உரையாகும்.`,
    input_your_question: 'தயவுசெய்து உங்கள் கேள்வியை உள்ளிடவும்!',
    make_me_sales_manager:
      'எ.கா.: என்னால் விற்பனை மேலாளராக மாற என்ன செய்ய வேண்டும்?',
    enter_the_number_relevant_document:
      'தொடர்புடைய ஆவணங்களின் எண்ணிக்கையை உள்ளிடவும்',
    please_wait_loading_result:
      'தயவுசெய்து காத்திருக்கவும், முடிவுகள் ஏற்றப்படுகின்றன...',
    no_result_found: 'எந்த முடிவும் காணப்படவில்லை, மேலும் கேள்விகள் கேளுங்கள்',
    browser_doesnot_support_iframes: 'உங்கள் உலாவி iframes-ஐ ஆதரிக்கவில்லை',
    total_duration: 'மொத்த கால அளவு',
    number_of_messages: 'செய்திகளின் எண்ணிக்கை',
    search_result: 'தேடல் முடிவுகள்',
    count_result: '(1244 முடிவுகள்)',
    your_other_interests: 'உங்கள் பிற விருப்பங்கள்',
    your_total_score: 'உங்கள் மொத்த மதிப்பெண்',
    add_a_question: '+ஒரு கேள்வியைச் சேர்க்கவும்',
    travia_question_empty: 'Travia கேள்விப் பட்டியல் காலியாக உள்ளது.',
    video_generation_is_on_queue: 'உங்கள் வீடியோ உருவாக்கம் வரிசையில் உள்ளது!',
    checking_video_status: 'வீடியோ நிலையை சரிபார்க்கிறது...',
    total_quizzes: 'மொத்த வினாடிவினா',
    number_of_votes: 'வாக்களன்களின் எண்ணிக்கை',
    total_events: 'மொத்த நிகழ்வுகள்',
    number_of_rates: 'மதிப்பீடுகளின் எண்ணிக்கை',
    number_of_likes: 'விருப்பங்களின் எண்ணிக்கை',
    all_courses: 'அனைத்து பாடநெறிகள்',
    total_questions: 'மொத்த கேள்விகள்',
    no_skill_journey: 'எந்தத் திறன் பயணமும் இல்லை!',
    search_no_results: '- எந்த முடிவுகளும் இல்லை!',
    no_image_generated: 'படங்கள் உருவாக்கப்படவில்லை!',
    all_topic_in_this_lesson:
      'இந்த பாடத்திலுள்ள அனைத்து தலைப்புகளும் நீக்கப்படும். இதை மீட்டெடுக்க முடியாது.',
    content_has_been_generated:
      'இந்த தலைப்பிற்கான உள்ளடக்கம் உருவாக்கப்பட்டுள்ளது.',
    update_course_template: 'பாடநெறி வார்ப்புருவை புதுப்பிக்கவும்',
    add_course_template: 'பாடநெறி வார்ப்புருவைச் சேர்க்கவும்',
    create_course_now: 'இப்போது பாடநெறியை உருவாக்கவும்',
    preview_course: 'பாடநெறியை முன் பார்வையிடவும்',
    layout: 'தளக்கோலம்',
    import_from_youtube: 'YouTube-இலிருந்து இறக்குமதி செய்யவும்',
    my_media_library: 'என் ஊடக நூலகம்',
    bg_added: 'பின்னணி சேர்க்கப்பட்டது',
    add_bg: 'பின்னணி சேர்க்கவும்',
    booked_schedule: 'முன்பதிவு செய்யப்பட்ட அட்டவணை',
    add_schedule: 'அட்டவணையைச் சேர்க்கவும்',
    are_you_delete_schedule: 'இந்த அட்டவணையை நீக்க விரும்புகிறீர்களா?',
    add_task: 'பணியைச் சேர்க்கவும்',
    update_calender: 'நாள்காட்டியை புதுப்பிக்கவும்',
    manage_cookies: 'குக்கீகளை நிர்வகிக்கவும்',
    cookie_banner_text:
      'உங்கள் உலாவல் அனுபவத்தை மேம்படுத்த, வலைத்தள போக்குவரத்தை பகுப்பாய்வு செய்ய மற்றும் உள்ளடக்கத்தை தனிப்பயனாக்க குக்கீகளை நாங்கள் பயன்படுத்துகிறோம். உங்கள் தனியுரிமை எங்களுக்கு முக்கியம்.',
    accept_all_cookies: 'அனைத்து குக்கீகளையும் ஏற்று',
    reject_all: 'அனைத்தையும் நிராகரிக்கவும்',
    customize: 'தனிப்பயனாக்கவும்',
    cookie_preferences_title: 'குக்கீ முன்னுரிமைகள் & தனியுரிமை அமைப்புகள்',
    privacy_subtitle:
      'உங்கள் தனியுரிமை எங்களுக்கு முக்கியம். எந்த குக்கீகளுடன் நீங்கள் ஒப்புக்கொள்கிறீர்கள் என்பதை தேர்ந்தெடுக்கவும். நீங்கள் எப்போதும் இந்த அமைப்புகளை மாற்றலாம்.',
    save_choices: 'எனது விருப்பங்களைச் சேமிக்கவும்',
    strictly_necessary: 'கடுமையாக அவசியமானவை',
    strictly_necessary_desc:
      'இந்தக் குக்கீகள் வலைத்தளம் சரியாக செயல்பட அவசியம். இவை பக்க வழிசெலுத்தல், படிவ சமர்ப்பிப்புகள் மற்றும் பாதுகாப்பான பகுதிகளுக்கான அணுகல் போன்ற அடிப்படை செயல்பாடுகளை இயக்குகின்றன. இவை இல்லாமல் வலைத்தளம் சரியாக செயல்பட முடியாது.',
    analytics_performance: 'ஆனலிட்டிக்ஸ் & செயல்திறன்',
    analytics_performance_desc:
      'இந்தக் குக்கீகள் விருந்தினர் எவ்வாறு வலைத்தளத்துடன் தொடர்பு கொள்கிறார்கள் என்பதை அறிய உதவுகின்றன, தகவல்களை அனானிமஸ் முறையில் சேகரித்து அறிக்கையிடுகின்றன. இது வலைத்தளத்தின் செயல்திறன் மற்றும் பயனர் அனுபவத்தை மேம்படுத்த உதவுகிறது.',
    advertising_marketing: 'விளம்பரங்கள் & மார்க்கெட்டிங்',
    advertising_marketing_desc:
      'இந்தக் குக்கீகள் விளம்பர செய்திகள் உங்களுக்கு பொருந்தக்கூடியவையாக இருக்க உதவுகின்றன. ஒரே விளம்பரம் தொடர்ந்து தோன்றாமல் தடுக்கும் மற்றும் விளம்பரதாரர்களுக்கான விளம்பரங்கள் சரியாக காட்சி பெறுவதை உறுதிப்படுத்தும்.',
    tracking_social: 'டிராக்கிங் & சமூக ஊடகம்',
    tracking_social_desc:
      'இந்தக் குக்கீகள் மேம்பட்ட செயல்பாடு மற்றும் தனிப்பயனாக்கத்தை அனுமதிக்கின்றன, உதாரணமாக சமூக ஊடக அம்சங்கள் மற்றும் தனிப்பட்ட உள்ளடக்கம். இவை எங்களால் அல்லது மூன்றாம் தரப்பு வழங்குநர்களால் அமைக்கப்படலாம்.',
    functional: 'செயல்பாட்டுக் குக்கீகள்',
    functional_desc:
      'இந்தக் குக்கீகள் சாட் ஆதரவு, நேரடி உதவி மற்றும் உங்கள் வலைத்தள அனுபவத்தை மேம்படுத்தும் பிற தொடர்புடைய அம்சங்களை இயங்கச் செய்யும்.',
    your_rights: 'உங்கள் உரிமைகள்:',
    rights_description:
      'நீங்கள் எப்போதும் உங்கள் ஒப்புதலை மீள்கட்டணிக்கலாம், உங்கள் தரவுகளை அணுகலாம் அல்லது தேவையாயின் நீக்க கேட்கலாம்.',
    withdraw_consent: 'அனைத்து ஒப்புதலையும் மீள்கட்டணிக்கவும்',

    how_many_options: 'எத்தனை விருப்பங்கள்',
    add_content: 'உள்ளடக்கத்தைச் சேர்க்கவும்',
    downloads_center: 'பதிவிறக்க மையம்',
    sharelook_help_center: 'ஷேர் லுக் உதவி மையம்',
    channel_outline: 'சேனல் கோட்பாடு',
    channel_objectives: 'சேனல் இலக்குகள்',
    no_sop_available: 'SOP பட்டியல் கிடைக்கவில்லை.',
    generate_world_summary: 'சூழலை உருவாக்கவும்',
    world_scenario: 'உண்மை உலக சூழல்',
    drag_icon_hint: 'குறிப்பு: ஐகானை கேன்வாஸில் இழுத்து இடம் மாற்றவும்',
    drag_text_hint: 'குறிப்பு: உரையை கேன்வாஸில் இழுத்து இடம் மாற்றவும்',
    edit_badge: 'பேட்ஜ் திருத்தவும்',
    create_new_badge: 'புதிய பேட்ஜ்',
    select_video_preview: 'முன்னோட்டத்திற்கு வீடியோ தேர்ந்தெடுக்கவும்',
    certificate_title_required: 'சான்றிதழ் தலைப்பு தேவை',
    discard_changes: 'மாற்றங்களை விட்டு வைக்கவும்',
    edit_certificate: 'சான்றிதழ் திருத்தவும்',
    add_another_logo: 'மேலும் ஒரு லோகோ சேர்க்கவும்',
    optional: 'விருப்பமானது',
    doc: 'DOC',
    ppt: 'PPT',
    quest_title: 'புதிய சவாலை உருவாக்கவும்',
    quest_filter_title: 'சவால்',
    sharelook_assistance: 'ஷேர் லுக் உதவி',
    upload_scorm_zip: 'SCORM Zip பதிவேற்றவும்',
    only_letters_numbers_space_dot_allowed:
      'அகரங்கள், எண்கள், இடைவெளி மற்றும் புள்ளி மட்டுமே அனுமதிக்கப்படுகிறது!',
    video_playing: 'பிளே செய்கிறது',
    course_price_message:
      '*இந்த பாடநெறி நிறுவனம் உள்ள பயனர்களுக்கு மட்டுமே வெளியிடப்படும் மற்றும் சந்தையில் மீளவிற்பனை செய்ய முடியாது.',
    lesson_must_be_positive:
      'பாடங்களின் எண்ணிக்கை 1 ஐ விட அதிகமாக இருக்க வேண்டும்',
    btn_proceed: 'தொடரவும்',
    rule_select_music: 'தயவுசெய்து இசையை தேர்ந்தெடுக்கவும்',
    course_info: 'பாடநெறி தகவல்',
    content_selection: 'உள்ளடக்கத் தேர்வு',
    course_content_source: 'பாடநெறி உள்ளடக்க மூலாதாரம்',
    choose_how_to_source:
      'இந்த பாடநெறிக்கான உள்ளடக்கத்தை எவ்வாறு பெற விரும்புகிறீர்கள் என்பதைத் தேர்ந்தெடுக்கவும்:',
    automatic_selection: 'தானியங்கி தேர்வு',
    system_will_automatically_select_relavant_documents:
      'சிஸ்டம் உங்கள் நூலகத்திலிருந்து சம்பந்தப்பட்ட ஆவணங்களை தானாக தேர்ந்தெடுக்கிறது',
    manual_selection: 'முறையாக தேர்வு',
    choose_specific_documents_from_your_library:
      'உங்கள் நூலகத்திலிருந்து குறிப்பிட்ட ஆவணங்களை தேர்ந்தெடுக்கவும்',
    upload_files: 'கோப்புகளை பதிவேற்றவும்',
    upload_new_documents:
      'புதிய ஆவணங்களை பதிவேற்றவும் (PDF, DOC, DOCX, PPT, PPTX, TXT) - அதிகபட்சம் 5 கோப்புகள்',
    file: 'கோப்பு',
    ready_to_upload: 'பதிவேற்ற தயாராக உள்ளது',
    clear_all: 'எல்லாவற்றையும் அழிக்கவும்',
    confirm_course_wide_premiew: 'பாடநெறி முழு முன்னோட்டத்தை உறுதிப்படுத்தவும்',
    generate_course_preview: 'பாடநெறி முன்னோட்டத்தை உருவாக்கவும்',
    instructions_across_the_course_to_generate:
      'முன்னோட்டத்தை உருவாக்க உங்கள் நெறிமுறைகளை முழு பாடநெறியில் பயன்படுத்துவோம். எல்லாவற்றையும் சரிபார்த்து பின்னர் மாற்றங்களைச் சேமிக்கவோ அல்லது விட்டு வைக்கவோ முடிவு செய்யுங்கள்.',
    instruction_to_preview_course_wide:
      'முழு பாடநெறி முன்னோட்டத்திற்கான வழிமுறைகள்:',
    edit_content: 'உள்ளடக்கத்தை திருத்தவும்',
    manage_course_template: 'பாடநெறி டெம்ப்ளேட்டை நிர்வகிக்கவும்',
    undo: 'மீட்டெடுக்கவும்',
    apply_changes: 'மாற்றங்களைப் பயன்படுத்தவும்',
    characters: 'அட்சரங்கள்',
    apply_all: 'அனைத்தையும் பயன்படுத்தவும்',
    apply_to_all: 'எல்லாவற்றுக்கும் பயன்படுத்தவும்',
    use_this_content: 'இந்த உள்ளடக்கத்தைப் பயன்படுத்தவும்',
    original: 'மூல',
    edited: 'திருத்தப்பட்டது',
    edited_content_preview: 'திருத்தப்பட்ட உள்ளடக்க முன்னோட்டம்',
    apply_edits_to_all_topices:
      'எல்லா தலைப்புகளுக்கும் மாற்றங்களைப் பயன்படுத்தவா?',
    current_editing_instructions_across_the_whole_course:
      'இது உங்கள் தற்போதைய திருத்த வழிமுறைகளை முழு பாடநெறியிலும் பயன்படுத்தும். சேமிப்புக்கு முன் இணைந்த முன்னோட்டத்தைப் பார்க்கலாம்.',
    edit_content_instructions: 'உள்ளடக்கத் திருத்த வழிமுறைகள்',
    generate_content_for_this_topic_instruction:
      'உங்கள் வழிமுறைகளைப் பயன்படுத்தி இந்த தலைப்பிற்கான உள்ளடக்கத்தை உருவாக்கவும்',
    descrip_edit_content:
      'இந்த உள்ளடக்கத்தை எவ்வாறு திருத்துவது என்பதை விவரிக்கவும் (எ.கா., குறைக்க, எளிமைப்படுத்த, மறுஅம்சமீட்டு)',
    try_short_clear_direcctives:
      'குறுகிய, தெளிவான வழிமுறைகளை முயற்சிக்கவும். உதாரணம்: “100 வார்த்தைகளுக்கு குறைக்கவும், முக்கிய புள்ளிகளை வைத்திருக்கவும்”, “மொழியை எளிமைப்படுத்தவும்”, “குறுகியாக மாற்றவும் மற்றும் கூடுதல் தகவலை அகற்றவும்”.',
    we_preserve_the_core_meaning:
      'உங்கள் வழிமுறைகளை பயன்படுத்தும்போது முக்கிய அர்த்தத்தை பாதுகாப்போம்.',
    feedback_optional: 'பின்னூட்டம் (விருப்பமானது)',
    write_your_feedback_here: 'உங்கள் பின்னூட்டத்தை இங்கே எழுதவும்',
    from_web: 'வலைத்தளம் மூலம்',
    from_desktop: 'டெஸ்க்டாப் மூலம்',
    pleae_wait_processing: 'தயவுசெய்து செயலாக்கப்படும்போது காத்திருங்கள்...',
    create_simulation_from_screen_capture:
      'திரை பிடிப்பில் இருந்து சிமுலேஷன் உருவாக்கவும்',
    sharelook_not_found: 'ShareLook கிடைக்கவில்லை',
    sharelook_screen_capture_application_not_be_opened:
      'ShareLook Screen Capture செயலியை திறக்க முடியவில்லை. இது உங்கள் கணினியில் நிறுவப்படவில்லையாயிருக்கலாம்.',
    download_sharelook: 'ShareLook ஐ பதிவிறக்கவும்',
    launch_sharelook_application: 'ShareLook செயலியை துவங்கவும்',
    this_will_open_the_sharelook_application_for_screen_capture:
      'திரை பிடிப்புக்காக ShareLook செயலியை திறக்கும்.',
    sharelook_dosenot_open:
      'ShareLook திறக்கப்படாவிட்டால், இது உங்கள் கணினியில் நிறுவப்படவில்லையாயிருக்கலாம்.',
    open_sharelook: 'ShareLook ஐ திறக்கவும்',
    download_app: 'செயலியை பதிவிறக்கவும்',
    background_image_setting: 'பின்னணி பட அமைப்புகள்',
    current_image: 'தற்போதைய படம்',
    change_image: 'படத்தை மாற்றவும்',
    remove_image: 'படத்தை நீக்கவும்',
    no_background_image_selected: 'எந்த பின்னணி படம் தேர்வுசெய்யப்படவில்லை',
    add_image: 'படத்தைச் சேர்க்கவும்',
    this_will_open_for_screen_recording:
      'திரை பதிவிற்கு ShareLook செயலியை திறக்கும்.',
    ai_image_generation: 'AI பட உருவாக்கம்',
    image_edit: 'படத்தை திருத்தவும்',
    text_to_image: 'உரை -> படம்',
    output_gallary: 'வெளியீட்டு காட்சிப்படை',
    instant_generation: 'தொடர்ந்து உருவாக்க தயாராக உள்ளது',
    prompt_and_unleash_the_power:
      'உங்கள் ப்ராம்ப்டை உள்ளிடவும் மற்றும் சக்தியை விடுவிக்கவும்',
    use_this_image: 'இந்த படத்தைப் பயன்படுத்தவும்',
    error_generating: 'உருவாக்குவதில் பிழை.',
    generation_tips: 'உருவாக்கக் குறிப்புகள்',
    detailed_descriptions_for_more_accurate_results:
      'சரியான முடிவுகளுக்காக விரிவான விளக்கங்களை பயன்படுத்தவும்',
    reference_image: 'குறிப்புக்கான படம்',
    select_pixel_image: 'பிக்சல் படம் தேர்ந்தெடுக்கவும்',
    max_mb: 'அதிகபட்சம் 50MB',
    please_enter_text_to_appear_image:
      'படத்தில் தோன்ற வேண்டிய உரையை உள்ளிடவும்',
    enter_text_to_apear_in_the_image: 'படத்தில் தோன்ற வேண்டிய உரையை உள்ளிடவும்',
    generate_image: 'படத்தை உருவாக்கவும்',
    prompt_assistant: 'ப்ராம்ப்ட் உதவியாளர்',
    generate_image_using_suggested_prompt:
      'சிபார்சிடப்பட்ட ப்ராம்ப்ட் பயன்படுத்தி படம் உருவாக்கவும்',
    talk_to_ai_about_the_image_generate:
      'உருவாக்க வேண்டிய படம் பற்றி AI உடன் பேசுங்கள்',
    ask_for_prompt_suggestions: 'ப்ராம்ப்ட் பரிந்துரைகளை கேளுங்கள்...',
    enter_a_search_term_to_find_stock_images:
      'பங்கு படங்களை கண்டுபிடிக்க தேடல் சொல்லை உள்ளிடவும்',
    choose_your_content_source: 'உங்கள் உள்ளடக்க மூலத்தைத் தேர்ந்தெடுக்கவும்:',
    upload_new_document_from_your_device:
      'உங்கள் சாதனத்திலிருந்து புதிய ஆவணங்களை பதிவேற்றவும்',
    automatic_library_selection: 'தானியங்கி நூலக தேர்வு',
    system_automatically_selects_relevant_document:
      'சிஸ்டம் தானாக தொடர்புடைய ஆவணங்களை தேர்வு செய்கிறது',
    manual_library_selection: 'மனுவல் நூலக தேர்வு',
    generate_content: 'உள்ளடக்கத்தை உருவாக்கவும்',
    add_to_current_page: 'தற்போதைய பக்கத்திற்கு சேர்க்கவும்',
    generate_bullet_points: 'முக்கிய புள்ளிகளை உருவாக்கவும்',
    generating: 'உருவாக்கப்படுகிறது',
    this_may_take_a_few_moments: 'இது சில விநாடிகள் எடுக்கலாம்',
    apply_to_page: 'பக்கத்தில் பயன்படுத்தவும்',
    scenario_escription: 'சூழல் விளக்கம்:',
    feedback: 'பின்மறை',
    form_mode: 'வடிவம் முறை',
    chat_mode: 'அரட்டை முறை',
    this_will_generate_a_continuation_of_the_seleccted_story:
      'தேர்ந்தெடுக்கப்பட்ட கதையின் தொடர்ச்சியை AI பயன்படுத்தி உருவாக்கும்.',
    continue_this_story_question: 'இந்த கதையை தொடர்வதா?',
    continue_this_story: 'இந்த கதையை தொடரவும்',
    what_will_happen: 'என்ன நடக்கும்:',
    the_ai_will_analyze_the_existing_story_content:
      'AI நிலைமையிலுள்ள கதையின் உள்ளடக்கத்தை பகுப்பாய்வு செய்யும்',
    generate_a_natural_continuation_that_follows_the_same_tone:
      'அதே சப்தம் மற்றும் शैली பின்பற்றும் இயல்பான தொடர்ச்சியை உருவாக்கவும்',
    create_new_content_that_build_upon_the_current_narrative:
      'தற்போதைய கதையை மேம்படுத்தும் புதிய உள்ளடக்கத்தை உருவாக்கவும்',
    this_process_may_take_a_few_moments_to_complete:
      'இந்த செயல்முறை சில தருணங்கள் எடுக்கும்.',
    no_existing_stories_found_for_this_course:
      'இந்த பாடத்திற்கு ஏற்கனவே உள்ள கதைகள் கிடைக்கவில்லை.',
    create_your_first_story: 'உங்கள் முதல் கதையை உருவாக்கவும்',
    existing_stories: 'நிலையான கதைகள்',
    create_new_story: 'புதிய கதை உருவாக்கவும்',
    tone: 'சப்தம்',
    style: 'ஷைலி',
    genre: 'வகை',
    loading_your_stories: 'உங்கள் கதைகள் ஏற்றப்படுகின்றன...',
    edit_story: 'கதை தொகுக்கவும்',
    story_preferences: 'கதை விருப்பங்கள்',
    please_input_your: 'உங்கள் ... ஐ உள்ளிடவும்',
    add_character_names_and_press_enter:
      'பாத்திரங்களின் பெயர்களைச் சேர்க்கவும், பிறகு Enter அழுத்தவும்',
    select_or_type_your: 'உங்கள் ... தேர்ந்தெடுக்க அல்லது எழுதவும்',
    enter_your: 'உங்கள் ... உள்ளிடவும்',
    position_of_the_story_in_the_lesson:
      'பாடத்தில் கதையின் இடம். குறிப்பிட்ட இடத்தில் ஒரு பகுதி ஆகக் கதையை சேர்க்கும்.',
    save_previous_content_on_the_pages:
      'பக்கங்களில் முந்தைய உள்ளடக்கத்தைச் சேமிக்கவும்',
    the_existing_content_in_the_selected_pages:
      'தேர்ந்தெடுக்கப்பட்ட பக்கங்களில் உள்ள உள்ளடக்கம் உருவாக்கப்பட்ட கதையால் மாற்றப்படும்.',
    real_world_scenario: 'உண்மை உலகத் தொடர்புடைய காட்சி',
    add_optional_instructions:
      'விருப்பமான வழிகாட்டுதல்களைச் சேர்க்கவும் (சப்தம், நீளம், பார்வையாளர்கள், போன்றவை)',
    ready_to_enerate_your_real_world_scenario:
      'உங்கள் உண்மை உலகத் தொடர்புடைய காட்சியை உருவாக்க தயாராக உள்ளது',
    click_generate_real_world_scenario_to_create_a_realistic_scenario:
      'உங்கள் பாடக் கொண்டடக்கத்தை அடிப்படையாகக் கொண்டு உண்மை உலகத் தொடர்புடைய காட்சியை உருவாக்க "உருவாக்கவும்" கிளிக் செய்யவும்.',
    the_ai_will_analyze_your_lesson_topic_and_content:
      'AI உங்கள் பாடத்தின் தலைப்பு மற்றும் உள்ளடக்கத்தை பகுப்பாய்வு செய்யும்',
    generate_a_practical_real_world_scenario:
      'ஒரு நடைமுறை உண்மை உலகத் காட்சியை உருவாக்கவும்',
    you_can_then_edit_and_customize_the_result:
      'பிறகு நீங்கள் முடிவை தொகுத்து தனிப்பயனாக்கலாம்',

    add_it_as_a_new_page_to_your_lesson:
      'உங்கள் பாடத்தில் புதிய பக்கமாக சேர்க்கவும்',
    regenerate_with_instructions: 'வழிகாட்டுதலுடன் மீண்டும் உருவாக்கவும்',
    add_real_world_scenario: 'உண்மை உலகக் காட்சியைச் சேர்க்கவும்',
    generate_real_world_scenario: 'உண்மை உலகக் காட்சியை உருவாக்கவும்',
    simulation_has_been_stopped: 'செயற்பாட்டு முயற்சி நிறுத்தப்பட்டது!',
    loading_simulation: 'செயற்பாட்டை ஏற்றுகிறது...',
    you_have_exhausted_all_the_attempts:
      'நீங்கள் அனைத்து முயற்சிகளையும் முடித்துவிட்டீர்கள்',
    study_the_scenario_on_this_page_and_select_the_correct_answer:
      'இந்த பக்கத்தில் காட்சியைப் படித்து கீழுள்ள விருப்பங்களில் இருந்து சரியான பதிலைத் தேர்ந்தெடுக்கவும்.',
    attempts_limit_reached:
      'முயற்சி வரம்பு எட்டப்பட்டது. நீங்கள் மீண்டும் விளையாடலாம், ஆனால் உங்கள் மதிப்பெண் சேமிக்கப்படாது.',
    play_again: 'மீண்டும் விளையாடவும்',
    import_music_from_computer: 'கணினியிலிருந்து இசையை இறக்குமதி செய்யவும்.',
    more: 'மேலும்',
    no_badge_yet: 'இன்னும் பேட்ஜ்கள் இல்லை',
    competition_filter: 'போட்டி வடிகட்டி',
    global_leaderboard: 'உலகளாவிய அணி அட்டவணை',
    placeholder_for_the_global_leaderboard:
      'இது உலகளாவிய அணி அட்டவணைக்கான இடமாற்றக் குறியீடு.',
    badge_editor: 'பேட்ஜ் தொகுப்பாளர்',
    adjust_the_appearance_of_this_badge_icon:
      'இந்த பேட்ஜ் ஐகானின் தோற்றத்தை மாற்றவும். மாற்றங்கள் இந்த பேட்ஜுக்கு மட்டுமே பொருந்தும்.',
    badge_style: 'பேட்ஜ் பாணி',
    the_image_must_be_pixels: 'படம் 200x200 பிக்சல்களாக இருக்க வேண்டும்.',
    badge_name: 'பேட்ஜ் பெயர்',
    badge_descrription: 'பேட்ஜ் விளக்கம்',
    enter_badge_criteria: 'பேட்ஜ் அளவுருக்களை உள்ளிடவும்',
    discard: 'ரத்து செய்',
    badge_enable: 'பேட்ஜ்கள் இயலுமைப்படுத்தப்பட்டுள்ளன',
    award_users_with_badges_to_highlight_the_milestones:
      'பயனாளர்களுக்கு முக்கிய முன்னேற்றங்களை வெளிப்படுத்த பேட்ஜ்களை வழங்கவும்.',
    badge_types: 'பேட்ஜ் வகைகள்',
    enable_or_disable_specific_badge_types_for_your_users:
      'உங்கள் பயனாளர்களுக்காக குறிப்பிட்ட பேட்ஜ் வகைகளை இயலுமைப்படுத்த அல்லது முடக்கவும்.',
    levels_enabled: 'நிலைகள் இயலுமைப்படுத்தப்பட்டன',
    level_rules: 'நிலை விதிகள்',
    points: 'புள்ளிகள்',
    add_new_level: 'புதிய நிலையைச் சேர்க்கவும்',
    add_level: 'நிலையைச் சேர்க்கவும்',
    points_enabled: 'புள்ளிகள் இயலுமைப்படுத்தப்பட்டன',
    learning_activities_and_encourage_healthy_competition:
      'பல்வேறு கற்றல் நடவடிக்கைகளுக்காக பயனாளர்களுக்கு புள்ளிகளை வழங்கவும் மற்றும் ஆரோக்கிய போட்டியை ஊக்குவிக்கவும்.',
    award_points: 'புள்ளிகளை வழங்கவும்',
    the_following_equates_the_value_of_one_item_completion:
      'பின்வரும் ஒரு பொருளை முடித்த மதிப்பிற்குத் இணையாகும்',
    general: 'பொது',
    others: 'பிறர்',
    certificate: 'சான்றிதழ்',
    quiz_passed: 'வினாத்தாள் उत्तীर्णம்',
    tip_approved: 'உத்தரவு அனுமதிக்கப்பட்டது',
    tip_liked: 'உத்தரவு விரும்பப்பட்டது',
    rewards: 'வெகுமதி',
    offer_discounts_when_learners_achieve:
      'கற்றோர் புள்ளிகள், பேட்ஜ்கள் அல்லது நிலைகளின் ஒரு தொகுப்பை அடைந்தால் தள்ளுபாடுகளை வழங்கவும்.',
    give_rewards: 'வெகுமதிகளை வழங்கவும்',
    discount_course_purchases_by: 'பாடநெறி வாங்குதலில் தள்ளுபாடு',
    with_points_more_than: 'புள்ளிகள் அதிகமானால்',
    with_badges_more_than: 'பேட்ஜ்கள் அதிகமானால்',
    with_level_upwards_more_than: 'நிலை அதிகமானால்',
    leaderboard: 'அணி அட்டவணை',
    leaderboard_enabled: 'அணி அட்டவணை இயலுமைப்படுத்தப்பட்டுள்ளது',
    leaderboards_offer_users_an_overview_of_their_learning_progress:
      'அணி அட்டவணைகள் பயனாளர்களுக்கு அவர்களது கற்றல் முன்னேற்றத்தின் ஒட்டுமொத்த காட்சியை வழங்கும்.',
    show_levels: 'நிலைகளை காண்பி',
    show_points: 'புள்ளிகளை காண்பி',
    show_badges: 'பேட்ஜ்களை காண்பி',
    show_courses: 'பாடநெறிகளை காண்பி',
    show_certificates: 'சான்றிதழ்களை காண்பி',
    leaderboard_settings: 'அணி அட்டவணை அமைப்புகள்',
    set_up_engaging_leaderboard_experiences_to_boost_learner_motivation:
      'கற்றோரின் உற்சாகத்தை அதிகரிக்க ஈடுபடுத்தும் அணி அட்டவணை அனுபவங்களை அமைக்கவும்.',
    award_users_with_points_for_different_learning_activities:
      'பல்வேறு கற்றல் நடவடிக்கைகளுக்காக பயனாளர்களுக்கு புள்ளிகளை வழங்கவும்.',
    badge_set: 'பேட்ஜ் தொகுப்பு',
    choose_the_type_of_badges_your_users:
      'உங்கள் பயனாளர்கள் கற்றுக்கொள்வதை தொடர்ந்தால் எந்த வகை பேட்ஜ்களைப் பெறுவார்கள் என்பதனை தேர்ந்தெடுக்கவும்.',
    levels: 'நிலைகள்',
    Levels_represent_the_stages:
      'நிலைகள் பயனாளரின் கற்றல் பயணத்தில் கட்டங்களை பிரதிபலிக்கின்றன.',
    enabled: 'இயலுமைப்படுத்தப்பட்டது',
    disabled: 'முடக்கப்பட்டது',
    quick_select: 'விரைவு தேர்வு',
    yesterday: 'நேற்று',
    last_week: 'கடந்த வாரம்',
    Last_month: 'கடந்த மாதம்',
    last_quarter: 'கடந்த காலாண்டு',
    historical_leaderboard: 'வரலாற்று அணி அட்டவணை',
    track_your_performance_and_see_how_you_rank_among_your_peers:
      'உங்கள் செயல்திறனை கண்காணித்து, உங்கள் தோழர்களிடையே எவ்வாறு தரவரிசை பெற்றுள்ளீர்கள் என்பதைப் பாருங்கள்',
    time_period: 'காலம்',
    page_of: 'பக்கம் 1 இல் 1',
    edit_competition: 'போட்டி திருத்தவும்',
    create_competition: 'போட்டி உருவாக்கவும்',
    arrow_right: 'வலது அம்பு',
    update_competition: 'போட்டியை புதுப்பிக்கவும்',
    competition_title: 'போட்டி தலைப்பு',
    enter_competition_title: 'போட்டி தலைப்பை உள்ளிடவும்',
    enter_competition_description: 'போட்டி விளக்கத்தை உள்ளிடவும்',
    leaderboard_skill: 'திறமை',
    select_a_skill: 'ஒரு திறமையைத் தேர்ந்தெடுக்கவும்',
    no_skills_found: 'திறமைகள் எதுவும் இல்லை',
    competition_period: 'போட்டி காலம்',
    add_badge_rule: 'பேட்ஜ் விதியைச் சேர்க்கவும்',
    create_badge: 'பேட்ஜ் உருவாக்கவும்',
    add_level_rule: 'நிலை விதியைச் சேர்க்கவும்',
    selected_participants: 'தேர்ந்தெடுக்கப்பட்ட பங்கேற்பாளர்கள்',
    no_participants: 'பங்கேற்பாளர்கள் இல்லை',
    start_end_date: 'தொடக்கம்–முடிவு தேதி',
    created_date: 'உருவாக்கியவர்',
    new_competition: 'புதிய போட்டி',
    competitions_list: 'போட்டிகள் பட்டியல்',
    search_competitions: 'போட்டிகளைத் தேடவும்...',
    are_you_sure_you_want_to_delete_the_competition:
      'நீங்கள் இந்த போட்டியை நீக்க விரும்புகிறீர்களா?',
    history: 'வரலாறு',
    export: 'ஏற்றுமதி',
    search_by_name: 'பெயரின் மூலம் தேடு...',
    no_historical_data_available_for_the_selected_period:
      'தேர்ந்தெடுக்கப்பட்ட காலத்திற்கான வரலாற்று தரவுகள் இல்லை.',
    no_leaderboard_data_available: 'அணி அட்டவணை தரவுகள் இல்லை.',
    competitions: 'போட்டிகள்',
    leaderboards: 'அணி அட்டவணைகள்',
    welcome_back: 'திரும்ப வருக',
    track_your_performance_and_see:
      'உங்கள் செயல்திறனை கண்காணித்து உங்கள் தரவரிசையை காணவும்',
    team_leaderboard: 'அணி அட்டவணை',
    try_again: 'மீண்டும் முயற்சிக்கவும்',
    no_competitions_for_search: 'தேடுதலுக்கான போட்டிகள் இல்லை',
    no_competitions_available: 'போட்டிகள் இல்லை',
    no_competitions_matching_search:
      'உங்கள் தேடுதலுக்கு பொருந்தும் போட்டிகள் இல்லை. தேடல் வார்த்தைகளை சரி செய்யவும் அல்லது பிறகு மீண்டும் முயற்சிக்கவும்.',
    no_competitions_general:
      'தற்போது எந்த போட்டிகளும் அமைக்கப்படவில்லை. பிறகு மீண்டும் முயற்சிக்கவும் அல்லது புதிய போட்டிகளை உருவாக்க நிர்வாகியை தொடர்பு கொள்ளவும்.',
    media_management: 'மீடியா மேலாண்மை',
    badgess_set: 'பேட்ஜ் தொகுப்பு',
    choose_the_default_visual_style_for_badge:
      'பிளாட்ஃபாமில் பயன்படுத்தப்படும் பேட்ஜ் ஐகான்களின் இயல்புநிலை காட்சி வடிவத்தைத் தேர்ந்தெடுக்கவும்.',
    enable_badges: 'பேட்ஜ்களை இயலுமைப்படுத்தவும்',
    add_badge: 'பேட்ஜ் சேர்க்கவும்',
    min: 'குறைந்த',
    max: 'அதிக',
    your_rank: 'உங்கள் தரவரிசை',
    your_points: 'உங்கள் புள்ளிகள்',
    your_level: 'உங்கள் நிலை',
    rank: 'தரவரிசை #',
    level: 'நிலை',
    progress: 'முன்னேற்றம்',
    new_folder: 'புதிய கோப்புறை',
    file_upload: 'கோப்பை பதிவேற்றவும்',
    writer: 'எழுத்தாளர்',
    text_documents: 'உரை ஆவணங்கள்',
    spreadsheets: 'ஸ்ப்ரெட்ஷீட்கள்',
    impress: 'மின்னணு விளக்கம்',
    presentations: 'விளக்கப்படங்கள்',
    capture_desktop_screen: 'டெஸ்க்டாப் திரையை பிடி',
    capture_desktop_screens: 'டெஸ்க்டாப் திரைகள் பிடி',
    your_documents: 'உங்கள் ஆவணங்கள்',
    manage_your_videos_images_audio_files:
      'உங்கள் வீடியோக்கள், படங்கள், ஒலி கோப்புகள் மற்றும் உள்ளடக்க உருவாக்கத்தில் பயன்படுத்தப்படும் பிற சொத்துகளை நிர்வகிக்கவும்.',
    your_organization_documents: 'உங்கள் நிறுவனம் ஆவணங்கள்',
    keep_your_organization_creative_assets_organized:
      'உங்கள் நிறுவனத்தின் படைப்பாற்றல் சொத்துகளை ஒழுங்குபடுத்தி அணுகக்கூடியவையாக வைக்கவும்—குழு வேலை மற்றும் உள்ளடக்க உற்பத்தியை சீரமைக்கவும்.',
    your_public_documents: 'உங்கள் பொது ஆவணங்கள்',
    curated_collection_of_media_assets_available:
      'ஒவ்வோருக்கும் கிடைக்கக்கூடிய ஊரியமான மீடியா சொத்துகள் தொகுப்பு—உறுதிப்படுத்தி, மீண்டும் பயன்படுத்தி உருவாக்கவும்.',
    your_download_center_documents: 'உங்கள் பதிவிறக்கம் மைய ஆவணங்கள்',
    repository_of_approved_media_assets_for_download:
      'உங்கள் திட்டங்களில் பதிவிறக்கம் மற்றும் பயன்படுத்துவதற்கான அங்கீகாரம் பெற்ற மீடியா சொத்துக்களின் தொகுப்பு.',
    search_files_and_folders: 'கோப்புகள் மற்றும் கோப்புறைகளைத் தேடு..',
    home: 'முகப்பு',
    folders: 'கோப்புறைகள்',
    folder_name: 'கோப்புறை பெயர்',
    owner: 'உரிமையாளர்',
    last_updated: 'கடைசி புதுப்பிப்பு',
    action: 'நடவடிக்கை',
    no_folders_found: 'கோப்புறைகள் எதுவும் இல்லை',
    files: 'கோப்புகள்',
    enabling_ai: 'AI இயலுமைப்படுத்துகிறது...',
    rename: 'பெயரை மாற்றவும்',
    copy: 'நகலெடு',
    move: 'நகர்த்தவும்',
    verson_history: 'பதிப்பு வரலாறு',
    manage_permission: 'அனுமதிகளை நிர்வகிக்கவும்',
    generate_audit_report: 'ஆடிட் அறிக்கை உருவாக்கவும்',
    last_edited: 'கடைசி திருத்தம்',
    no_files_found: 'கோப்புகள் எதுவும் இல்லை',
    are_you_sure_you_want_to_make_this_item_public:
      'இந்த உருப்படியை பொது சேமிக்க விரும்புகிறீர்களா? இது உங்கள் பொது நூலகத்தில் நகலெடுக்கப்படும்.',
    move_to_organization: 'நிறுவனத்துக்கு நகர்த்தவும்',
    are_you_sure_you_want_to_copy_this_item_to_your_organization_library:
      'இந்த உருப்படியை உங்கள் நிறுவனம் நூலகத்திற்கு நகலெடுக்க விரும்புகிறீர்களா?',
    are_you_sure_you_want_to_make_this_item_private:
      'இந்த உருப்படியை தனிப்பட்டதாக மாற்ற விரும்புகிறீர்களா? இது உங்கள் சொந்த நூலகத்தில் நகலெடுக்கப்படும்.',
    date_modified: 'மாற்றிய தேதி',
    workflow_management: 'வேலைப்ப 흐ி் நிர்வாகம்',
    configure_editors_approvers_and_viewers_for_this_document:
      'இந்த ஆவணத்திற்கான தொகுப்பாளர்கள், ஒப்புதலாளர்கள் மற்றும் பார்வையாளர்களை அமைக்கவும்.',
    error_Loading_editor: 'தொகுப்பாளர் ஏற்றும்போது பிழை',
    debug_info: 'திறந்த தகவல்',
    loading_editor: 'தொகுப்பாளர் ஏற்றப்படுகிறது...',
    submitted_for_review: 'மறுஆய்வுக்கான சமர்ப்பிப்பு',
    editors: 'தொகுப்பாளர்கள்',
    no_editors_added_yet:
      'இன்னும் தொகுப்பாளர்கள் சேர்க்கப்படவில்லை. ஒருவரைச் சேர்க்க "தொகுப்பாளரைச் சேர்க்கவும்" கிளிக் செய்யவும்.',
    add_editor: 'தொகுப்பாளரைச் சேர்க்கவும்',
    approvers: 'ஒப்புதலாளர்கள்',
    no_approvers_added_yet:
      'இன்னும் ஒப்புதலாளர்கள் சேர்க்கப்படவில்லை. ஒருவரைச் சேர்க்க "ஒப்புதலாளரைச் சேர்க்கவும்" கிளிக் செய்யவும்.',
    add_approvers: 'ஒப்புதலாளர்களைச் சேர்க்கவும்',
    viewer: 'பார்வையாளர்',
    no_viewers_added_yet:
      'இன்னும் பார்வையாளர்கள் சேர்க்கப்படவில்லை. ஒருவரைச் சேர்க்க "பார்வையாளரைச் சேர்க்கவும்" கிளிக் செய்யவும்.',
    add_viewer: 'பார்வையாளரைச் சேர்க்கவும்',
    are_you_sure_you_want_to_delete_the_selected_items:
      'தேர்ந்தெடுக்கப்பட்ட உருப்படிகளை நீக்க விரும்புகிறீர்களா?'
  },
  v3: {
    reportShareSphere: 'பகிர்வு பரப்பளம்',
    overview: 'சமூகக் கருத்துக்கணிப்பு மேலோட்டம்',
    triviaReport: 'ShareSphere வினோதங்கள்',
    overviewGraph: 'சமூக மேலோட்ட வரைபடம்',
    category: 'வகை',
    phCategory: 'வகையைத் தேர்ந்தெடுக்கவும்',
    podcast: 'பாட்காஸ்ட், இசை மற்றும் கதைகள்',
    pastPodcast: 'முந்தைய பாட்காஸ்ட்',
    upcomingPodcast: 'வரவுள்ள பாட்காஸ்ட்',
    podcastLanguageTitle: 'பாட்காஸ்ட், இசை மற்றும் கதையின் மொழி',
    podcastLanguageCheckbox: 'என் பாட்காஸ்ட் மொழிக்காக AI-ஐ பயன்படுத்தவும்',
    howRate: 'இந்த பாட்காஸ்ட்டைப் பற்றி உங்கள் மதிப்பீடு என்ன?',
    podcastSubmit: 'சமர்ப்பிக்கவும்',
    podcastGuest: 'விருந்தினர்:',
    podcastReview: 'விமர்சனம்',
    podcastEpishode: 'அத்தியாயம்',
    podcastEnd: 'பாட்காஸ்ட் முடிவடைந்தது',
    date_podcast: 'பாட்காஸ்ட் தேதி',
    skill_not_found: 'மன்னிக்கவும்! திறன்சார் பயணம் இல்லை.',
    coaching: 'பயிற்சி',
    webinar: 'வலைமாநாடு',
    public_conference: 'பொது மாநாடு',
    skill_journey_subtitle:
      'உங்கள் திறன்களைத் தேர்ந்தெடுத்து, அதை யார் பார்க்கலாம் மற்றும் தொடர்பு கொள்ளலாம் என்பதை கட்டுப்படுத்தவும்.',
    enable_white_label: 'வெள்ளை லேபிளை இயக்கு',
    create_new_event_org: 'உங்கள் நிறுவத்திற்கு புதிய நிகழ்வை உருவாக்கவும்',
    create_new_event_marketplace: 'சந்தைக்கு புதிய நிகழ்வை உருவாக்கவும்',
    create_new_event_both:
      'உங்கள் நிறுவத்திற்கும் சந்தைக்கும் புதிய நிகழ்வை உருவாக்கவும்',
    event_outline: 'நிகழ்வு தோற்றத்தை உள்ளிடவும்',
    event_obj: 'நிகழ்வின் குறிக்கோள்களை உள்ளிடவும்',
    event_description: 'நிகழ்வு விளக்கத்தை உள்ளிடவும்',
    create_new_metamaze_org:
      'உங்கள் நிறுவத்திற்கு புதிய மெட்டாமேஸை உருவாக்கவும்',
    create_new_metamaze_marketplace: 'சந்தைக்கு புதிய மெட்டாமேஸை உருவாக்கவும்',
    create_new_metamaze_both:
      'உங்கள் நிறுவத்திற்கும் சந்தைக்கும் புதிய மெட்டாமேஸை உருவாக்கவும்',
    add_key_words: 'முக்கிய சொற்களைச் சேர்க்கவும்',
    press_enter_make_keyword: 'முக்கியச் சொல்லை உருவாக்க Enter அழுத்தவும்',
    disable_skip_quiz: 'வினாத்தாளைத் தவிர்த்தலை முடக்கு',
    warning_complete_quiz: 'தொடர வினாத்தாளை முடிக்கவும்.',
    signup_email_verification:
      'உங்கள் மின்னஞ்சலுக்கு உறுதிப்படுத்தல் இணைப்பு அனுப்பப்பட்டுள்ளது. தயவுசெய்து உங்கள் பதிவை உறுதிப்படுத்த இணைப்பைப் பயன்படுத்தவும்.',
    verifying_registration: 'பதிவைச் சரிபார்க்கிறது...',
    reset_password_linK:
      'உங்கள் மின்னஞ்சலுக்கு கடவுச்சொல் மீட்டமைப்புக்கான இணைப்பு அனுப்பப்பட்டுள்ளது. புதிய கடவுச்சொல்லை அமைக்க அதை கிளிக் செய்யவும்.',
    reset_email_error:
      'இந்த மின்னஞ்சலுடன் பயனர் இல்லை. உங்கள் பயனர்பெயரை முயற்சிக்கவும்!',
    first_name: 'முதல் பெயர்',
    last_name: 'கடைசி பெயர்',
    error_firstName: 'தயவுசெய்து உங்கள் முதல் பெயரை உள்ளிடவும்',
    error_sharebot_organization: 'தயவுசெய்து நிறுவனத்தை உள்ளிடவும்',
    error_lastName: 'தயவுசெய்து உங்கள் கடைசி பெயரை உள்ளிடவும்',
    private_conference: 'தனியார் மாநாடு',
    public_conference: 'பொது மாநாடு',
    discussion_room: 'விவாத அறை',
    training_no_courses: 'நீங்கள் தற்போதைய எந்த பாடத்தையும் சேரவில்லை.',
    training_no_events: 'நீங்கள் தற்போது எந்த நிகழ்விலும் பங்கேற்கவில்லை.',
    allow_sharing_trainer_info: 'பயிற்றுநரின் மின்னஞ்சலை சந்தையில் பகிர அனுமதி',
    error_username_space: 'பயனர்பெயரில் இடைவெளி இருக்க முடியாது.',
    error_sharebot_organization_space:
      'நிறுவனப் பெயரில் இடைவெளி இருக்க முடியாது.',
    edit_permission: 'திருத்த அனுமதி',
    valid_price: 'விலை 0-ஐ விட அதிகமாக இருக்க வேண்டும்',
    course_price_message:
      '*இந்த பாடங்கள் நிறுவத்தின் பயனர்களுக்கு மட்டுமே கிடைக்கும் மற்றும் சந்தையில் விற்க முடியாது',
    valid_edit_price:
      'திருத்த வேண்டிய விலை வாங்கிய விலையைவிட குறைவாக இருக்க வேண்டும்.',
    my_calendar: 'என் நாள்காட்டி',
    error_valid_firstName: 'தயவுசெய்து சரியான பெயரை உள்ளிடவும்.',
    error_valid_organization: 'தயவுசெய்து சரியான நிறுவனப் பெயரை உள்ளிடவும்.',
    error_valid_lastName: 'தயவுசெய்து சரியான கடைசி பெயரை உள்ளிடவும்.',
    error_name_spaces: 'பெயரில் இடைவெளி இருக்கக்கூடாது',
    items: 'உருப்படிகள்',
    publish_to_channel: 'என் சேனலில் வெளியிடவும்',
    create_a_channel: 'என் சேனலை உருவாக்கவும்',
    create_a_trivia: 'ஒரு புதிர் உருவாக்கவும்',
    create_a_new_channel: 'புதிய சேனலை உருவாக்கவும்',
    add_videos: 'வீடியோக்களைச் சேர்க்கவும்',
    save_and_continue: 'சேமித்து தொடரவும்',
    channel: 'சேனல்',
    channels: 'சேனல்கள்',
    view_channel: 'சேனலைப் பார்க்க',
    edit_channel: 'சேனலைத் திருத்த',
    delete_channel: 'சேனலை அழிக்க',
    my_video_channels: 'என் வீடியோ சேனல்கள்',
    training_no_channel: 'நீங்கள் தற்போது எந்த சேனலிலும் பங்கேற்கவில்லை.',
    monthly_price_required: 'மாத தவணை விலை தேவை',
    yearly_price_required: 'ஆண்டுத் தவணை விலை தேவை',
    one_time_price_required: 'ஒரே முறை கட்டணம் தேவை',
    marketplace_quantity: 'மதிப்பு',
    report_webinar: 'வலைமாநாடு',
    report_coaching: 'பயிற்சி',
    report_channel: 'சேனல்',
    report_public_conference: 'பொது மாநாடு',
    report_maze: 'மேஸ்',
    channel: 'சேனல்',
    edit_price: 'விலையைத் திருத்து ($)',
    quantity: 'அளவு',
    payment_type: 'கட்டண வகை',
    total_amount: 'மொத்தம் ($)',
    net_amount: 'நிகர தொகை ($)',
    edit_option: 'விருப்பத்தைத் திருத்து',
    marketplace_price: 'சந்தை விலை ($)',
    market_name: 'பெயர்',
    duration_min: 'நேரம் (நிமிடங்கள்)',
    users_total: 'பயனர்கள் (மொத்தம்)',
    sales_total: 'மொத்த விற்பனை (USD)',
    search_coaching: 'பயிற்சி தேடுங்கள்',
    search_channel: 'சேனல் தேடுங்கள்',
    search_webinar: 'வலைமாநாடு தேடுங்கள்',
    search_maze: 'மேஸ் தேடுங்கள்',
    search_public_conference: 'பொது மாநாடு தேடுங்கள்',
    buyer_type: 'வாங்குநர் வகை',
    quanity: 'அளவு',
    channel_unit_amount: 'நிகர தொகை ($)',
    channel_updated_at: 'புதுப்பிக்கப்பட்டது',
    month_price: 'விலை (மாதம்)',
    year_price: 'விலை (ஆண்டு)',
    one_time_price: 'விலை (ஒரு முறை)',
    sharebot_organization: 'புதிய நிறுவனப்பெயரை உள்ளிடவும்',
    share_sphere: 'பகிர்வு பரப்பளம்',
    ai_course_title: 'பாடத்திட்டத்தின் தலைப்பு',
    ai_input_course_title: 'தயவுசெய்து பாடத்திட்டத்தின் தலைப்பை உள்ளிடவும்!',
    learning_objective_label: 'கற்றலின் நோக்கம்',
    learning_objective_message: 'தயவுசெய்து கற்றலின் நோக்கத்தை உள்ளிடவும்!',
    standard_question: 'மாணவர் பின்பற்ற வேண்டிய தரநிலை ஏதும் உள்ளதா?',
    standard_details_label: 'தரநிலை விவரங்கள்',
    standard_details_message: 'தயவுசெய்து தரநிலை விவரங்களை உள்ளிடவும்!',
    estimated_duration_label: 'முன்னறிவு கால அளவு (நிமிடங்களில்)',
    estimated_duration_message: 'தயவுசெய்து கால அளவை உள்ளிடவும்!',
    min_duration_message: 'குறைந்தபட்ச கால அளவு 5 நிமிடங்கள்.',
    ai_mins: '25 நிமிடங்கள்',
    industry_specific_question: 'இது ஒரு குறிப்பிட்ட துறையுடன் தொடர்புடையதா?',
    industry_label: 'துறையை குறிப்பிடவும்',
    industry_message: 'தயவுசெய்து துறையை உள்ளிடவும்!',
    ai_course_creation: 'AI உதவியுடன் பாடத்தை உருவாக்குதல்',
    course_generated: 'Sharelook ஆல் உருவாக்கப்பட்ட பாடம்',
    ai: 'AI',
    ai_you: 'நீங்கள்',
    ai_prompt_ready:
      'உங்கள் கோரிக்கை தயாராக உள்ளது. இப்போது உள்ளடக்க அட்டவணையை உருவாக்கலாம்.',
    ai_unable_respond:
      'மன்னிக்கவும்! உங்கள் கோரிக்கைக்கு தற்போது பதிலளிக்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.',
    ai_hide_toc: 'உள்ளடக்க அட்டவணையை மறைக்கவும்',
    ai_preview_toc: 'உள்ளடக்க அட்டவணையின் முன்காட்சியைப் பார்க்கவும்',
    ai_generate_toc_now: 'உள்ளடக்க அட்டவணையை இப்போது உருவாக்கவும்',
    ai_creation_course_title: 'பாடத்திட்டத்தின் தலைப்பு:',
    ai_creation_industry_specific: 'துறை சார்ந்ததா:',
    ai_creation_industry: 'துறை:',
    ai_creation_standard_needed:
      'மாணவர்கள் பின்பற்ற வேண்டிய தரநிலை ஏதாவது உள்ளதா?:',
    ai_creation_standard_details: 'தரநிலை விவரங்கள்:',
    ai_creation_estimated_duration: 'முன்னறிவு கால அளவு (நிமிடங்களில்):',
    minutes: 'நிமிடங்கள்',
    ai_creation_learning_objective: 'கற்றலின் நோக்கம்:',
    setup_again: 'மீண்டும் அமைக்கவும்',
    ai_creation_confirm_title:
      'நீங்கள் இந்த படிவத்தை மீண்டும் அமைக்க விரும்புகிறீர்களா?',
    ai_creation_confirm_content:
      'உங்கள் உரையாடல் மற்றும் உருவாக்கப்பட்ட உள்ளடக்கங்கள் அனைத்தும் மீட்டமைக்கப்படும்.',
    ai_toc: 'உள்ளடக்க அட்டவணை',
    ai_note_topic:
      'குறிப்பு: ஒரு பாடத்திற்குள் உள்ள தலைப்புகளை இழுத்து விடலாம்.',
    ai_add_topic: '+ தலைப்பைச் சேர்க்கவும்',
    add_topic: 'தலைப்பைச் சேர்க்கவும்',
    add_lesson: 'பாடத்தைச் சேர்க்கவும்',
    add_new_lesson: 'புதிய பாடத்தைச் சேர்க்கவும்',
    ai_add_lesson: '+ பாடத்தைச் சேர்க்கவும்',
    attention: 'கவனம்',
    before_varifying: 'சரிபார்ப்பதற்கு முன்',
    ai_save_later: 'பின்னர் சேமிக்கவும்',
    ai_download_word_doc: 'Word ஆவணமாக பதிவிறக்கவும்',
    ai_download_course_word_doc: 'பாடத்தை Word ஆவணமாக பதிவிறக்கவும்',
    ai_create_course_button: 'பாடத்தை உருவாக்கவும்',
    ai_generate_course_content: 'பாட உள்ளடக்கத்தை உருவாக்கவும்',
    ai_out_of: '/',
    ai_subtopic_failed_content:
      'சில துணைத்தலைப்புகளுக்கு உள்ளடக்கம் உருவாக்கப்படவில்லை. மீண்டும் "பாட உள்ளடக்கத்தை உருவாக்கவும்" என்பதை கிளிக் செய்து மீளாய்வு செய்யவும்.',
    ai_edit_topic: 'தலைப்பைத் திருத்தவும்',
    ai_edit_lesson_title: 'பாடத்தின் தலைப்பைத் திருத்தவும்',
    ai_save_topic: 'தலைப்பைச் சேமிக்கவும்',
    ai_save: 'சேமிக்கவும்',
    ai_save_lesson_title: 'பாட தலைப்பைச் சேமிக்கவும்',
    ai_add_new_topic: 'புதிய தலைப்பைச் சேர்க்கவும்',
    ai_download_ref: 'மூலங்களுடன் பதிவிறக்கவும்',
    ai_download_ref_content:
      'பாடம் Word ஆவணமாக, மூல குறிப்புகளுடன் பதிவிறக்கப்படும்.',
    ai_download_without_ref: 'மூலங்கள் இல்லாமல் பதிவிறக்கவும்',
    ai_download_two_word: 'இரண்டு Word ஆவணங்கள் பதிவிறக்கப்படும்:',
    ai_download_two_word_content_one:
      '- ஒன்று முக்கிய உள்ளடக்கத்துடன் (மூலங்கள் இல்லாமல்),',
    ai_download_two_word_content_two:
      'மற்றொன்று மூலக்குறிப்புகளுடன் (உள்ளடக்கம் இல்லாமல்).',
    ai_manage_content: 'உள்ளடக்கத்தை நிர்வகிக்கவும்',
    ai_add_content_from_internet:
      '+இணையத்திலிருந்து உள்ளடக்கத்தைச் சேர்க்கவும்',
    ai_confirm_start: 'தொடங்க உறுதிபடுத்தவும்',
    ai_Verify: 'சரிபார்க்கவும்',
    ai_undo_warning:
      'இந்த செயல்முறை சிறிது நேரம் ஆகலாம். முடியும் வரை இந்த சாளரத்தை மூட வேண்டாம், பின்வாங்க முடியாது.',
    ai_verified_content:
      'நீங்கள் உள்ளடக்கத்தை சரிபார்த்துள்ளீர்கள். தற்போது AI உரையாடலை மீண்டும் அணுக முடியாது.',
    ai_want_proceed: 'தொடர விரும்புகிறீர்களா?',
    upload_simulation: 'உருவகத்தைப் பதிவேற்றவும்',
    name_simulation: 'உருவகத்திற்கு பெயர் கொடுக்கவும்',
    selected_simulation_files: 'தேர்ந்தெடுக்கப்பட்ட உருவகக் கோப்புகள்',
    score_between_one_hundred: 'மதிப்பெண் 1 முதல் 100 வரை இருக்க வேண்டும்.',
    are_sure_simulation: 'இந்த உருவகக் கோப்பை நீக்க விரும்புகிறீர்களா?',
    required_simulation: 'மதிப்பெண் தேவை',
    required_section_file: 'பிரிவு கோப்பு தேவை',
    simulation: 'உருவகம்',
    simulation_quiz_games:
      'வினாத்தாளில் கேள்விகள் விளையாட்டில் சேர்க்கப்பட வேண்டும்',
    simulation_alert_des:
      'மொத்த கேள்விகளும் ஒரே பதில் அல்லது பல பதில்கள் வகையாக இருந்தால் மட்டுமே விளையாட்டுகளைச் சேர்க்க முடியும்.',
    alert_info: 'தகவல்',
    ai_number_quiz: 'வினாத்தாள் எண்ணிக்கை',
    ai_point: 'மதிப்பெண்',
    ai_points: 'மதிப்பெண்கள்',
    val_required: 'தேவையானது',
    games: 'விளையாட்டுகள்',
    add_simulation: 'உருவகத்தைச் சேர்க்கவும்',
    text_tiewer: 'உரையைக் காண்பிக்கவும்',
    back_to_account: 'கணக்கிற்கு திரும்பவும்',
    delete_account: 'கணக்கை நீக்கவும்',
    delete_account_title: 'கணக்கை நீக்க விரும்புகிறீர்களா?',
    delete_account_subtitle: 'இங்கே உங்கள் கணக்கை நீக்கலாம்.',
    delete_account_cannot_undo:
      'உங்கள் கணக்கை நீக்க நீங்கள் தயாராக இருக்கிறீர்கள். இந்த செயலை மீட்டெடுக்க முடியாது.',
    account_org_profile:
      'உங்கள் கணக்கு, பாடங்கள், நிறுவன விவரங்கள் அனைத்தும் அழிக்கப்படும்.',
    deleting_account_database:
      'உங்கள் கணக்கு நீக்கப்படும் போது அனைத்து தரவுகளும் நீக்கப்படும்.',
    account_confirm_delete: 'நீங்கள் உங்கள் கணக்கை நீக்க விரும்புகிறீர்களா?',
    action_cannot_be_undone: 'இந்த செயலை மீள முடியாது.',
    account_delete_message_success: 'உங்கள் கணக்கு வெற்றிகரமாக நீக்கப்பட்டது.',
    message_edit: 'திருத்து',
    message_delete: 'நீக்கு',
    message_reply: 'பதில்',
    attached_file: 'இணைக்கப்பட்ட கோப்பு',
    attach_file: 'கோப்பை இணைக்கவும்',
    attach_des: '25 MB வரை, அதிகபட்ச கோப்பு அளவு',
    view: 'பார்க்கவும்',
    go_to_marketplace: 'சந்தைக்குச் செல்லவும்',
    learning_center: 'கற்றல் மையம்',
    knowledge_center: 'அறிவு மையம்',
    sharebot: 'ShareBot',
    sharebot_help_message: 'இன்று உங்களுக்கு எவ்வாறு உதவலாம்?',
    my_organization: 'என் நிறுவனம்',
    world_knowledge: 'உலக அறிவு',
    welcome_to_sharelook: 'Sharelook-இற்குத் வரவேற்கிறோம்!',
    sharelook_you_want_go: 'இன்று நீங்கள் எங்கே செல்ல விரும்புகிறீர்கள்?',
    shareLook_learning_management_system:
      'ShareLook கற்றல் மேலாண்மை அமைப்பை அணுகி உங்கள் நிறுவனத்தில் நேரடி நிகழ்வுகள் மற்றும் பாடங்களை உருவாக்கவும், அணுகவும்.',
    shareLook_powerful_ai_system:
      'ShareLook-இன் சக்திவாய்ந்த AI அமைப்பை பயன்படுத்தி PDF ஆவணங்களைப் பதிவேற்றிக் உடனடி அறிவைப் பெறவும். உங்கள் நிறுவனத்திலிருந்தோ அல்லது உலக அறிவுத் தளத்திலிருந்தோ விரைவான பதில்களைப் பெறவும்.',
    edit_now: 'இப்போது திருத்து',
    sharelook_log_out:
      'Sharelook-இல் இருந்து வெளியேறி விட்டீர்கள். மீண்டும் உள்நுழையவும்!',
    sorry_error: 'மன்னிக்கவும்! பிழை ஏற்பட்டுள்ளது.',
    login: 'உள்நுழையவும்',
    refresh_page: 'பக்கத்தை புதுப்பிக்கவும்',
    just_a_moment: 'ஒரு நிமிடம் காத்திருக்கவும்',
    enter_lname_fname: 'தொடர உங்கள் முழுப் பெயரையும் உள்ளிடவும்.',
    procced_to_sharelook: 'Sharelook-க்கு செல்லவும்',
    option_one: 'விருப்பம் 1',
    option_two: 'விருப்பம் 2',
    selected_image: 'தேர்ந்தெடுக்கப்பட்ட படம்:',
    add_text: 'உரையைச் சேர்க்கவும்',
    linkdin_is_required: 'LinkedIn தேவைப்படுகிறது.',
    bio_is_required: 'சுயவிவரம் தேவைப்படுகிறது.',
    save_user_information: 'பயனர் தகவல்களைச் சேமிக்கவும்',
    select_all: 'அனைத்தையும் தேர்வு செய்',
    enable_ai: 'AI-ஐ இயக்கு',
    load_more: 'மேலும் ஏற்று',
    channel_id: 'சேனல் ஐடி',
    send: 'அனுப்பு',
    v4: 'தகவல்',
    subscription: 'சந்தா',
    reset_user_flag: 'பயனர் கொடியை மீட்டமைக்கவும்',
    delete_my_accont: 'என் கணக்கை நீக்கு',
    sharebot_sub_error: 'சந்தாவைப் பெறும் போது பிழை. மீண்டும் முயற்சிக்கவும்!',
    sharebot_no_sub: 'தற்போது எந்த சந்தாவும் இல்லை.',
    sharebot_dont_sub: 'முன்னதாக எந்த சந்தாவும் இல்லை.',
    sharebot_prev_sub: 'முந்தைய சந்தா',
    sharebot_sub: 'ShareBot சந்தா',
    sharebot_un_sub: 'ShareBot சந்தாவை ரத்துசெய்யவும்',
    sharebot_no_available: 'தகவல் எதுவும் கிடைக்கவில்லை',
    sharebot_start_date: 'தொடக்க தேதி:',
    sharebot_end_date: 'முடிவு தேதி:',
    sharebot_sure: 'நீங்கள் உறுதியாக இருக்கிறீர்களா?',
    sharebot_do_you_want: 'நீங்கள் விரும்புகிறீர்களா',
    unsubscribe: 'சந்தாவிலிருந்து வெளியேறு',
    unsubscribe_what: 'வெளியேற விரும்புகிறீர்களா?',
    subscribe: 'சந்தா பெறுங்கள்',
    subscribe_what: 'சந்தா பெற விரும்புகிறீர்களா?',
    subscribe_now: 'இப்போது சந்தா பெறுங்கள்',
    confirm: 'உறுதிசெய்',
    sharebot_intel_knowledge_center: 'ShareBot அறிவு மையம்',
    sharebot_welcome_paragraph:
      'ShareBot அறிவு மையத்திற்கு வரவேற்கிறோம், தொழில்முனைவோர்களுக்கான தகவல்களை விரைவில் பெற உருவாக்கப்பட்ட AI உதவியாளர்.',
    expired: 'காலாவதியானது',
    active: 'செயலில் உள்ளது',
    Inactive: 'செயலற்றது',
    yearly_subscription: 'ஆண்டுக்கான சந்தா',
    monthly_subscription: 'மாத சந்தா',
    no_sharebot_org: 'உங்களுக்கு எந்த ShareBot நிறுவனமும் இல்லை',
    sharebot_start_free_trial: 'இலவச பரிசோதனையைத் தொடங்கவும்',
    sub_month: 'மாத சந்தா',
    sub_year: 'ஆண்டு சந்தா',
    question_per_month:
      'தரவுக் சேமிப்பு (1TB) மற்றும் மாதத்திற்கு 1000 கேள்விகள்',
    sharebot_para:
      'தொடர்ந்தால், நிறுவனம் உடனடியாக நீக்கப்படும். இந்த நடவடிக்கை ShareBot வழங்கிய அனைத்து மதிப்புடைய அறிவுகளையும் நீக்கி விடும், மற்றும் அதை மீட்க முடியாது.',
    cancelled_date: 'ரத்து தேதி:',
    live_straming_para:
      'நீங்கள் உங்கள் மாதாந்திர நேரடி ஒளிபரப்பு வரம்பை மாற்ற விரும்பினால், தயவுசெய்து தொடர்பு கொள்ளவும்',
    sharelook_agree: 'நான் Sharelook–இன்',
    terms_condition: 'விதிமுறைகள் மற்றும் நிபந்தனைகள்',
    and: 'மற்றும்',
    privacy_policy: 'தனியுரிமைக் கொள்கை',
    save_for_later: 'பின்னர் சேமி',
    ai: 'ஏ.ஐ.',
    no_video_yet: 'இன்னும் எந்த வீடியோவும் தேர்வு செய்யப்படவில்லை!',
    are_you_sure_delete_video: 'இந்த வீடியோவை நீக்க உறுதியாக இருக்கிறீர்களா?',
    video_des: 'விளக்கம்',
    video_now: 'இப்போது',
    video_playing: 'இப்போது இயக்கப்படுகிறது:',
    video_no: 'வீடியோ எண்',
    ai_generated_course: 'ஏ.ஐ பொருத்த மாண்புரு பாடநெறி',
    create_course_on_our_own: 'தனியாக பாடநெறி உருவாக்குக',
    ai_Assisted_ourse_reation: 'ஏ.ஐ உதவியுடன் பாடநெறி உருவாக்குதல்',
    pending: 'நிலுவையிலுள்ளது',
    published: 'பதிவு செய்யப்பட்டது',
    intro_course: 'உங்கள் பாடநெறியில்?',
    clone_course: 'நகல் எடுக்க விரும்புகிறீர்களா?',
    browser_audio_not_support: 'உங்கள் உலாவி ஆடியோ குறியீடுகளை ஆதரிக்கவில்லை.',
    audio_popup_content:
      'நீங்கள் தட்டச்சு செய்த உரைக்கே பல நடங்களைப் பயன்படுத்தலாம். Lorem Ipsum என்பது அச்சிடுதல் மற்றும் எழுத்துரு துறையில் பரவலாகப் பயன்படுத்தப்படும் மாதிரி உரை.',
    close: 'மூடு',
    podcast_rec: 'பதிவு',
    create_podcast: 'பாட்காஸ்டை உருவாக்குக',
    add_admin: 'நிர்வாகியைச் சேர்க்கவும்',
    delete_all: 'அனைத்தையும் நீக்கு',
    ai_podcast_audio: 'ஏ.ஐ பாட்காஸ்ட் ஒலி',
    language: 'மொழி',
    podcast_download_content:
      '*இலவசப்படுத்தப்பட்ட ஆடியோ கோப்பை பதிவிறக்கி, உங்கள் சொந்த திருத்தத்திற்காக பயன்படுத்தவும்.',
    upload_audio: 'ஆடியோ பதிவேற்று',
    browser_do_not_support_audio:
      'உங்கள் உலாவி ஆடியோ இயங்குதளம் ஆதரிக்கவில்லை.',
    upload_cover: 'கவர் படத்தை பதிவேற்றவும்',
    upload_ai_creator: 'ஏ.ஐ உருவாக்குனரை பதிவேற்றவும்',
    required_cover_image: 'கவாரம் படம் அவசியம்!',
    room_required_name: 'பாட்காஸ்ட் பெயர் அவசியம்!',
    add_guest_list: 'தயவுசெய்து விருந்தினர்கள் பட்டியலைச் சேர்க்கவும்!',
    podcast_add_participants: 'பங்கேற்பாளரைச் சேர்க்கவும்',
    topic_required: 'குறைந்தது ஒரு தலைப்பு தேவை',
    podcast_description: 'விளக்கம்',
    podcast_date: 'தேதி',
    date: 'தேதி',
    podcast_time: 'நேரம்',
    podcast_to: 'முதல்',
    podcast_all_day: 'முழு நாள்',
    podcast_start_date_time: 'துவக்க தேதி மற்றும் நேரம் அவசியம்!',
    podcast_id: 'ஐடி',
    selected_user: 'தேர்ந்தெடுக்கப்பட்ட பயனர்களை அழைக்கவும்',
    see_more: 'மேலும் காண்க',
    see_less: 'குறைவாக காண்க',
    no_review_yet:
      'இன்னும் மதிப்புரைகள் இல்லை, முதலில் أنت மதிப்புரையாக இருக்கலாம்.',
    request_to_speak: 'பயனரின் பேசும் கோரிக்கையை ஏற்க வேண்டுமா?',
    kick_user: 'இந்த பயனரை நீக்க வேண்டுமா?',
    accept_request: 'கோரிக்கையை ஏற்கவும்',
    kick: 'நீக்கு',
    started: 'தொடங்கியது',
    end: 'முடிவு',
    join_now: 'இப்போதே சேருக',
    podcast_end: 'பாட்காஸ்ட் முடிந்தது',
    connecting: 'இணைக்கிறது...',
    knowledge_center_know_today:
      'இன்று நீங்கள் எதைப் பற்றி தெரிந்து கொள்ள விரும்புகிறீர்கள்?',
    knowledge_center_question: 'தயவுசெய்து முதலில் கேள்வியை உள்ளிடவும்',
    knowledge_center_error: 'மன்னிக்கவும்! தவறு ஏற்பட்டது.',
    knowledge_center_tooltrip:
      'ShareLook–ல் உங்கள் நிறுவனத்தின் கல்வி வளங்களைக் கொண்டு சரியான மேற்கோள்களுடன் விரைவான பதில்களை பெறு, PDF கோப்புகளை முன்னோட்டம் மற்றும் பதிவிறக்கம் செய்யவும்.',
    my_organization: 'என் நிறுவனம்',
    world_knowledge: 'உலக அறிவு',
    open_file: 'கோப்பை திற',
    reference: 'மேற்கோள்',
    are_you_cancel: 'நீங்கள் ரத்து செய்ய உறுதியாக இருக்கிறீர்களா?',
    are_you_remove_media: 'நீங்கள் ஊடகத்தை நீக்க விரும்புகிறீர்களா?',
    terms_agree: 'நான் இது அனைத்தையும் அங்கீகரிக்கிறேன்',
    ready: 'தயார்',
    send_email: 'மின்னஞ்சல் அனுப்பு',
    active_users: 'செயலில் உள்ள பயனர்கள்',
    sign_up_user: 'பதிவு செய்யப்பட்ட பயனர்கள்',
    non_sign_up_user: 'பதிவு செய்யாத பயனர்கள்',
    organisation: 'நிறுவனம்',
    usage_report: 'பயன்பாட்டு அறிக்கை',
    check_email: 'உங்கள் மின்னஞ்சலை சரிபார்க்கவும்',
    delete_schedule: 'அட்டவணையை நீக்கு',
    are_you_sure_delete_schedule:
      'இந்த அட்டவணையை நீக்க உறுதியாக இருக்கிறீர்களா?',
    add_task: 'தயவுசெய்து பணி ஒன்றை உள்ளிடவும்!',
    coaching_available: 'பயிற்சி கிடைக்கும் என்பதை குறிக்கவும்',
    message_booking_coaching:
      'இந்த நேரம் பயனரால் பயிற்சிக்காக முன்பதிவு செய்யப்பட்டுள்ளது.',
    task_day: 'பணியின் நாள்',
    created_task_day: 'இந்த நாளுக்கான பணி உருவாக்கப்பட்டது.',
    event_day: 'நிகழ்வு நாள்',
    has_booked_coaching: 'இந்த நாளுக்கான பயிற்சி முன்பதிவு செய்யப்பட்டது.',
    active_day: 'செயலில் இருக்கும் நாள்',
    selectable_time_slots:
      'வலது பக்கத்தில் தேர்வு செய்யக்கூடிய கால இடைவெளிகள் இந்த நாளுக்கானவை.',
    compare_last_month: 'கடந்த மாதத்துடன் ஒப்பிடு',
    uploading_file: 'உங்கள் கோப்பை பதிவேற்றுகிறது',
    attach_file_course: 'இந்த பாடநெறிக்குக் இணைக்கப்பட்டது.',
    fetch_request: 'உங்கள் கோரிக்கையை செயலாக்குகிறது',
    finilize_upload: 'பதிவேற்றம் நிறைவு செய்யப்படுகிறது',
    scorm_scanned:
      'தயவுசெய்து காத்திருங்கள்... உங்கள் SCORM கோப்பு சோதிக்கப்படுகிறது.',
    scan_status: 'ஸ்கேன் நிலை:',
    scan_completed: 'ஸ்கேன் நிறைவு. உங்கள் கோப்பு ਹੈ',
    scan_progress: 'ஸ்கேன் நடந்து கொண்டிருக்கிறது...',
    check_scorm:
      'SCORM கோப்பு வடிவத்தைச் சரிபார்க்கிறது... தயவுசெய்து காத்திருங்கள்...',
    file_check_success: 'கோப்பு சரிபார்ப்பு வெற்றி!',
    file_check_progress: 'கோப்பு சரிபார்ப்பு நடக்கிறது...',
    scorm_not_upload:
      'நீங்கள் பதிவேற்றிய கோப்பு SCORM 1.2 தரத்துக்கு ஏற்பல்ல. தயவுசெய்து பொருத்தமான கோப்பை மீண்டும் பதிவேற்றவும்.',
    select_question: 'பதில் தேர்வுகள் (ஒரே சரியான பதிலைத் தேர்வுசெய்க)',
    select_answer: 'தயவுசெய்து பதிலைத் தேர்வுசெய்க!',
    check_option_one: 'முதல் விருப்பத்தை உள்ளிடவும்!',
    check_option_two: 'இரண்டாவது விருப்பத்தை உள்ளிடவும்!',
    check_option_three: 'மூன்றாவது விருப்பத்தை உள்ளிடவும்!',
    check_option_four: 'நான்காவது விருப்பத்தை உள்ளிடவும்!',
    question_image: 'கேள்வி படம்',
    select_question_image: 'தயவுசெய்து கேள்வி படத்தைத் தேர்வுசெய்க!',
    ans_image: 'பதில் படம்',
    upload_image_question: 'பதில் படத்தை பதிவேற்றவும்',
    select_image_answer: 'தயவுசெய்து பதில் படத்தைத் தேர்வு செய்க!',
    save_question: 'கேள்வியை சேமிக்கவும்',
    do_you_leave: 'நீங்கள் வெளியே செல்ல விரும்புகிறீர்களா?',
    loose_all_progress: 'உங்கள் அனைத்து முன்னேற்றமும் இழக்கப்படும்.',
    welcome: 'வரவேற்கின்றோம்',
    team_knowledge_quest: 'குழு அறிவுப் பயணம்',
    your_score: 'உங்கள் மதிப்பெண்',
    start_playing: 'விளையாடத் தொடங்கு',
    share_sphere_complete: 'ShareSphere முடிந்தது',
    final_score: 'இறுதி மதிப்பெண்',
    play_next: 'அடுத்ததை விளையாடு',
    you_donot_access_event: 'இந்த நிகழ்வுக்கு நீங்கள் அணுக முடியாது.',
    ai_content_generated: 'இந்த தலைப்புக்கு உள்ளடக்கம் உருவாக்கப்பட்டுள்ளது.',
    ai_popup_confirm_content: 'உள்ளடக்கம் உருவாக்கத்தை உறுதிப்படுத்தவும்',
    limit_transcribe_text:
      'மீதமுள்ள மொழிமாற்ற நேரம்: <0>{{ transcribe_limit }}</0> நிமிடங்கள் <1/><2/> <3>. உங்கள் மொழிபெயர்ப்பு வரம்பை மாற்ற, தயவுசெய்து தொடர்புகொள்ளவும் </3> <4>admin@sharelook.com</4>.',
    you_donot_access_event: 'இந்த நிகழ்வுக்கான அணுகல் உங்களுக்கு இல்லை.',
    ai_course_title_training: 'தலைமை பயிற்சி பாடநெறிகள்',
    ai_course_object: 'டிஜிட்டல் உலகில் தலைமை வழிநடத்தல்',
    create_ai_video: 'AI வீடியோ உருவாக்கு',
    generate: 'உருவாக்கு',
    video_generate_process:
      'வீடியோ உருவாக்கும் செயல்முறை சிறிது நேரம் எடுத்துக்கொள்ளலாம். முடிந்ததும் உங்கள் மின்னஞ்சலில் தகவல் அனுப்பப்படும்.',
    stripe_account_connect:
      'உங்கள் Stripe கணக்கு செயலற்றுள்ளது. தொடர இணைக்கவோ அல்லது செயல்படுத்தவோ செய்யவும்.',
    ai_creator: 'AI உருவாக்குபவர்',
    check_video_status: 'வீடியோ உருவாக்க நிலையை சரிபார்க்கிறது...',
    video_on_queue: 'வீடியோ உருவாக்கத்திற்கு வரிசையில் உள்ளது.',
    video_fail_generation:
      'மன்னிக்கவும், வீடியோ உருவாக்கம் தோல்வியடைந்தது. மற்றொன்றை முயற்சிக்கவும்.',
    video_currently_generated: 'இந்த வீடியோ தற்போது உருவாக்கப்படுகிறது.',
    checking_status: 'நிலையை சரிபார்க்கிறது',
    check_status: 'நிலை சரிபார்',
    browser_does_not_support_audio:
      'உங்கள் உலாவி audio குறிச்சொல்லை ஆதரிக்கவில்லை',
    existing_edit_scenario:
      'நீங்கள் உள்ளதையே திருத்த விரும்புகிறீர்களா அல்லது புதிய ஒன்றை உருவாக்க விரும்புகிறீர்களா? புதியதைக் தேர்ந்தெடுத்தால் பழையது அழிக்கப்படும்.',
    generate_scenario: 'நிகழ்வு உருவாக்கு',
    layout: 'தளவமைப்பு',
    confirm_change: 'மாற்றத்தை உறுதிப்படுத்து',
    generated_ai_creation_message:
      'குறிப்பு: AI மூலம் உருவாக்கப்பட்ட உரைப் பகுதிகள் மட்டுமே சேமிக்கப்படும். மற்ற அனைத்து கூறுகளும் அழிக்கப்படும்.',
    generate_story: 'கதை உருவாக்கு',
    save_original_content: 'மூல உள்ளடக்கத்தை சேமிக்கவும்:',
    story_added_specified_position:
      'பாடத்தில் கதையின் இடம். குறிப்பிட்ட இடத்தில் கதை தொகுப்பாக சேர்க்கப்படும்.',
    position_of_story: 'கதையின் இடம்',
    start_the_lesson: 'பாடம் தொடக்கம்',
    end_the_lesson: 'பாடம் முடிவு',
    add_story_pages: 'பக்கங்களில் கதையைச் சேர்க்கவும்',
    browser_does_not_support: 'உங்கள் உலாவி audio கூறுகளை ஆதரிக்கவில்லை.',
    no_video_available: 'வீடியோக்கள் எதுவும் இல்லை.',
    no_podcast_available: 'பாட்காஸ்ட்கள் எதுவும் இல்லை.',
    no_item_baskets: 'கூடைவில் எந்த உருப்படியும் இல்லை.',
    ai_course_object: 'டிஜிட்டல் உலகில் தலைமை வழிநடத்தல்'
  },
  v2: {
    n_data: 'தகவல் இல்லை',
    change: 'மாற்றவும்',
    remove: 'அகற்று',
    auto_background: 'தானாக பின்னணி',
    create_new_course_org:
      'உங்கள் நிறுவனத்திற்கு புதிய பாடநெறியை உருவாக்கவும்.',
    create_new_course_marketplace:
      'விளம்பர சந்தைக்கான புதிய பாடநெறியை உருவாக்கவும்.',
    create_new_course_both:
      'உங்கள் நிறுவனம் மற்றும் விளம்பர சந்தைக்கான புதிய பாடநெறியை உருவாக்கவும்.',
    ok: 'சரி',
    page_bg: 'பக்கத்தின் பின்னணி',
    lesson_cover: 'பாடத்தின் முகப்பு படம்',
    create_skill_journey: 'திறன் பயணத்தை உருவாக்கவும்',
    Metamaze: 'மெட்டாமேஸ்',
    events: 'நிகழ்வுகள்',
    scroms: 'SCORMகள்',
    min_score_pass: 'கடந்து செல்ல குறைந்தபட்ச மதிப்பெண்',
    no_scorms_available: 'எந்த SCORMகளும் கிடைக்கவில்லை.',
    no_events_available: 'நிகழ்வுகள் கிடைக்கவில்லை.',
    no_courses_available: 'பாடநெறிகள் கிடைக்கவில்லை.',
    no_courses_baskets: 'பாடநெறிகள் கூடைவில் இல்லை.',
    no_mazes_baskets: 'மேஸ்கள் கூடைவில் இல்லை.',
    no_scroms_baskets: 'SCORMகள் கூடைவில் இல்லை.',
    no_events_baskets: 'நிகழ்வுகள் கூடைவில் இல்லை.',
    sorry: 'மன்னிக்கவும்!',
    option_1: 'விருப்பம் 1',
    option_2: 'விருப்பம் 2',
    enter_number_words: 'அதிகபட்ச வார்த்தைகளின் எண்ணிக்கையை உள்ளிடவும்.',
    summarize: 'சுருக்கவும்',
    answer: 'பதில்',
    hold_tight_one_minute:
      'தயவு செய்து காத்திருங்கள்! நாம் இன்னும் தயார் செய்ய்கிறோம். இது ஒரு நிமிடம் வரை நேரம் எடுக்கலாம்.',
    enter_question: 'உங்கள் கேள்வியை உள்ளிடவும்.',
    enter_relevant_documents: 'தக்க ஆவணங்களின் எண்ணிக்கையை உள்ளிடவும்.',
    please_input_relevant_documents:
      'தயவு செய்து பொருத்தமான ஆவண எண்ணிக்கையை உள்ளிடவும்!',
    please_wait_loading_results:
      'தயவு செய்து முடிவுகள் ஏற்றப்படும் வரை காத்திருக்கவும்...',
    proceed_to_add_voice: 'சொலி சேர்க்க தொடரவும்',
    results: 'முடிவுகள்',
    no_result_found_try_asking_questions:
      'முடிவுகள் இல்லை. மேலும் கேள்விகள் கேட்க முயற்சிக்கவும்.',
    eg: 'உதா.,',
    what_make_sales_manager: 'என்னால் நான் விற்பனை மேலாளராக ஆகலாம்?',
    please_select_lang: 'தயவு செய்து எந்த மொழியையும் தேர்ந்தெடுக்கவும்!',
    search: 'தேடல்',
    please_copy_desired_content:
      'இடதுபுற பெட்டியில் இருந்து தேவையான உள்ளடக்கத்தை வலது பெட்டிக்கு நகலெடுக்கவும்.',
    rating_req: 'மதிப்பீடு கட்டாயம்.',
    review_req: 'விமர்சனம் கட்டாயம்.',
    rating_review_req: 'மதிப்பீடு மற்றும் விமர்சனமும் இரண்டும் வழங்க வேண்டும்.',
    how_rate_this: 'இதை நீங்கள் எப்படி மதிப்பீடு செய்வீர்கள்?',
    amazing_above_expectations: 'அற்புதம்! எதிர்பார்ப்புகளை மீறியது!',
    certificates: 'சான்றிதழ்கள்',
    you_no_certificates: 'தற்போது உங்களுக்கு எந்த சான்றிதழ்களும் இல்லை.',
    please_add_review:
      'தயவு செய்து மதிப்பீடு உடன் விமர்சனமும் வழங்கவும், நன்றி!',
    post: 'பதிவு செய்',
    rate: 'மதிப்பீடு செய்',
    avg_rating: 'சராசரி மதிப்பீடு',
    no_review_found: 'விமர்சனம் இல்லை',
    are_sure_to_disale_zoom_integration:
      'Zoom ஒருங்கிணைப்பை முடக்க விரும்புகிறீர்களா?',
    badges: 'பேஜ்கள்',
    you_no_badge_available: 'தற்போது உங்களுக்கு எந்த பேஜ்களும் இல்லை.',
    download_certificate: 'சான்றிதழ் பதிவிறக்கு',
    loading: 'பதிவேற்றப்படுகிறது...',
    no_file_attached: 'எந்த கோப்பும் இணைக்கப்படவில்லை',
    you_do_not_have_any_notes: 'உங்களுக்கு எந்த குறிப்புகளும் இல்லை.',
    question: 'கேள்வி',
    score: 'மதிப்பெண்',
    alert_score_message:
      'ஒருவர் அல்லது பலர் தங்கள் மதிப்பெண்களை சமர்ப்பித்துள்ளனர்.',
    alert_question_message: 'இப்போது வரை எந்த கேள்விகளும் சேர்க்கப்படவில்லை.',
    button_submit: 'சமர்ப்பி',
    button_allScores: 'அனைத்து மதிப்பெண்களும் சமர்ப்பிக்கப்பட்டன.',
    record_wait: 'பதிவேற்றம் ஆரம்பிக்கிறது. தயவு செய்து காத்திருங்கள்...',
    buttonSubmit_warning:
      'சமர்ப்பிக்குமுன் அனைத்து மதிப்பெண்களையும் உள்ளிடவும்.',
    upload_ar_assets: 'AR சொத்துகளை பதிவேற்று',
    edit_ar_assets: 'AR சொத்துகளை திருத்து',
    edit_maze_assets: 'MetaMaze சொத்துகளை திருத்து',
    upload_assets: 'சொத்துகளை பதிவேற்று',
    upload_maze_assets: 'MetaMaze சொத்துகளை பதிவேற்று',
    trigger_title: 'தூண்டுகோல் தலைப்பு',
    model_title: 'மாதிரி தலைப்பு',
    trigger_description: 'தூண்டுகோல் விளக்கம்',
    model_description: 'மாதிரி விளக்கம்',
    please_type_target_description: 'இலக்கு விளக்கத்தை தட்டச்சு செய்யவும்.',
    please_type_model_description: 'மாதிரி விளக்கத்தை தட்டச்சு செய்யவும்.',
    trigger_image: 'தூண்டுகோல் படம்*',
    model_image: 'மாதிரி படம்*',
    upload_trigger_image: 'தூண்டுகோல் படத்தை பதிவேற்று',
    upload_model_image: 'மாதிரி படத்தை பதிவேற்று',
    drag_n_drop: 'இழுத்து விடுக',
    file_size_should_not_exceed:
      '(பட கோப்பு (JPEG) அளவு 512 KB ஐ தாண்டக்கூடாது)',
    zip_size_should_not_exceed: '(ZIP கோப்பு அளவு 60 MB ஐ தாண்டக்கூடாது)',
    ar_content: 'AR உள்ளடக்கம்*',
    model_content: '3D மாதிரி*',
    upload_3d_zip: 'ZIP / வீடியோ பதிவேற்று',
    upload_3d_maze_zip: 'ZIP பதிவேற்று',
    audio_content: 'ஒலி உள்ளடக்கம்',
    _mp3: '(.mp3)',
    content_attached: 'ZIP இணைக்கப்பட்டது.',
    video_attached: 'வீடியோ இணைக்கப்பட்டது.',
    audio_attached: 'ஒலி இணைக்கப்பட்டது.',
    enter_trigger_image_title: 'தூண்டுகோல் படத் தலைப்பை உள்ளிடவும்.',
    enter_model_title: 'MetaMaze மாதிரி தலைப்பை உள்ளிடவும்.',
    ar_preview_image: 'AR முன்னோட்ட படம்',
    upload_preview_image: 'முன்னோட்ட படத்தை பதிவேற்று',
    upload_audio: 'ஒலி பதிவேற்று',
    creating___: 'உருவாக்கப்படுகிறது...',
    updating___: 'புதுப்பிக்கப்படுகிறது...',
    create: 'உருவாக்கு',
    update: 'புதுப்பி',
    ar_assets: '3D படம்',
    _3d_files_mp4: '(சுருக்கப்பட்ட .obj, .fbx அல்லது .mp4 வீடியோ)',
    _3d_files_mp4_ar: '(சுருக்கப்பட்ட .obj, .fbx)',
    maze_3d_files_mp4: '(சுருக்கப்பட்ட .obj, .fbx)',
    _jpg_files: 'மட்டுமே .jpg களை ஆதரிக்கிறது',
    persons_have_submitted_their_scores:
      'ஒருவர் / ஒருவரே தங்களுடைய மதிப்பெண்களை சமர்ப்பித்துள்ளனர்.',
    no_questions_added_till_now: 'இன்னும் எந்த கேள்விகளும் சேர்க்கப்படவில்லை.',
    submit: 'சமர்ப்பி',
    all_scores_submitted: 'அனைத்து மதிப்பெண்களும் சமர்ப்பிக்கப்பட்டன.',
    recording_is_starting: 'பதிவேற்று ஆரம்பிக்கிறது. காத்திருக்கவும்...',
    please_input_scores_before_submitting:
      'சமர்ப்பிப்பதற்கு முன் அனைத்து மதிப்பெண்களையும் உள்ளிடவும்.',
    end_for_all: 'அனைவருக்கும் முடி',
    full_screen: 'முழு திரை',
    breakout_room: 'பிரேக்அவுட் அறை',
    send_invitations: 'அரசுரைகளை அனுப்பு',
    add_participants: 'பங்கேற்பாளர்களைச் சேர்க்கவும்',
    create_breakout_room: 'பிரேக்அவுட் அறை உருவாக்கவும்',
    connecting: 'இணைக்கப்படுகிறது...',
    currently_broadcaster_unavailable: 'தற்போது பிராட்காஸ்டர் இல்லை.',
    how_many_breakout_room_to_create:
      'நீங்கள் எத்தனை பிரேக்அவுட் அறைகளை உருவாக்க விரும்புகிறீர்கள்?',
    create_upto_three_breakout_rooms: '*3 பிரேக்அவுட் அறைகள் வரை உருவாக்கவும்',
    allow: 'அனுமதி',
    additional: 'மேலும்',
    attachment: 'இணைப்புகள்',
    no_description_available: 'விளக்கம் இல்லை.',
    people: 'மக்கள்',
    waiting: 'காத்திருக்கிறது',
    hand_raising_users: 'கையை எழுப்பும் பயனர்கள்',
    invite: 'அரசுரை',
    create_room: 'அறை உருவாக்கவும்',
    create_live_event: 'நேரடி நிகழ்வை உருவாக்கவும்',
    support_upto_fivethousand_participants:
      'நிகழ்விற்கு 5,000 பங்கேற்பாளர்களுக்கு ஆதரவு',
    support_upto_ten_participants:
      'நேரடி வீடியோ நிகழ்விற்கு 10 பங்கேற்பாளர்கள் ஆதரவு',
    support_upto_twohundred_participants:
      'நிகழ்விற்கு 200 பங்கேற்பாளர்களுக்கு ஆதரவு',
    supprt_upto_five_participants:
      'நேரடி வீடியோ நிகழ்விற்கு 5 பங்கேற்பாளர்கள் ஆதரவு',
    support_upto_twentyfive_participants:
      'நிகழ்விற்கு 25 நேரடி வீடியோ பங்கேற்பாளர்களுக்கு ஆதரவு',
    two_live_video_participants:
      'நிகழ்விற்கு 2 நேரடி வீடியோ பங்கேற்பாளர்கள் உள்ளனர் (ஹோஸ்ட் மற்றும் கலந்து கொள்ளும்)',
    you_can_have_upto_five_examinees:
      'நீங்கள் அதிகபட்சம் 5 தேர்வாளர்களை வைத்திருக்கலாம்.',
    you_can_have_upto_twentyfive_participants:
      'நீங்கள் அதிகபட்சம் 25 பங்கேற்பாளர்களை வைத்திருக்கலாம்.',
    you_can_have_upto_five_participants:
      'நீங்கள் அதிகபட்சம் 5 பங்கேற்பாளர்களை வைத்திருக்கலாம்.',
    you_can_have_upto_ten_participants:
      'நீங்கள் அதிகபட்சம் 10 பங்கேற்பாளர்களை வைத்திருக்கலாம்.',
    select_hosts_email: 'ஹோஸ்ட் மின்னஞ்சலை தேர்ந்தெடு',
    send_invite_email: 'அரசுரை மின்னஞ்சல் அனுப்பு',
    do_not_send_invite_email: 'அரசுரை மின்னஞ்சல் அனுப்ப வேண்டாம்',
    error: 'பிழை',
    max_twentyfive_users_allowed:
      'அதிகபட்சம் 25 பயனர்கள் தேர்வு செய்ய அனுமதிக்கப்படுகிறது',
    max_five_users_allowed:
      'அதிகபட்சம் 5 பயனர்கள் தேர்வு செய்ய அனுமதிக்கப்படுகிறது',
    max_ten_users_allowed:
      'அதிகபட்சம் 10 பயனர்கள் தேர்வு செய்ய அனுமதிக்கப்படுகிறது',
    no_user_found: 'பயனர் எதுவும் இல்லை',
    transcribe_to: 'மாற்றம் செய்ய',
    integrate_zoom_to_start_meeting:
      'Zoom கூட்டத்தை தொடங்க உங்கள் கணக்குடன் Zoom ஐ ஒருங்கிணைக்கவும்.',
    zoom_is_not_integrated: 'Zoom ஒருங்கிணைக்கப்படவில்லை.',
    delete_poll: 'வாக்கு கணக்கீட்டை நீக்கு',
    add_poll: 'வாக்கு கணக்கீட்டை சேர்க்கவும்',
    live_now: 'இப்போதே நேரலை!',
    average_rating: 'சராசரி மதிப்பீடு',
    review: 'விமர்சனம்',
    time_spent: 'கொடுத்த நேரம்',
    total: 'மொத்தம்',
    mins: 'நிமிடங்கள்',
    no_data: 'இந்த வினாத்தாளுக்கான தரவு இல்லை.',
    total_score: 'மொத்த மதிப்பெண்',
    pass_score: 'ஓடிய மதிப்பெண்',
    point: 'மதிப்பெண்',
    wrong: 'தவறு',
    response: 'பதில்',
    submitted: 'சமர்ப்பிக்கப்பட்டது',
    average: 'சராசரி',
    total_play: 'மொத்த விளையாட்டு',
    view_graph: 'வரைகலை பார்வை',
    time_spent_mins: 'கடந்த நேரம் (நிமிடங்கள்)',
    play: 'விளையாடு',
    ideal_path: 'சரியான பாதை',
    user_incorrect_path: 'பயனர் தவறான பாதை',
    ideal_path_taken: 'பயனர் எடுத்த சரியான பாதை',
    scenario: 'நிகழ்வு',
    option: 'விருப்பம்',
    spend: 'செலவு',
    average_spending_time: 'சராசரி செலவிடும் நேரம்',
    activity_overview: 'செயல்பாட்டு மேலோட்டம்',
    live_event: 'நேரடி நிகழ்வு',
    live_assessment: 'நேரடி மதிப்பீடு',
    report_download: 'அறிக்கை பதிவிறக்கம்',
    all_workshops: 'அனைத்து பணிமனைகள்',
    overview_average_activity: 'மேலோட்ட சராசரி செயல்',
    overview_workshop_graph: 'மேலோட்ட பணிமனை வரைகலை',
    mazes: 'அலைவரிசைகள்',
    correct_feedback: 'தவறு இல்லை கருத்து',
    incorrect_feedback: 'தவறான கருத்து',
    checkin_checkout: 'உள் நுழைவு - வெளியேறு',
    minutes: 'நிமிடங்கள்',
    incorrect_path: 'தவறான பாதை',
    answer_not_available: 'பதில் கிடைக்கவில்லை',
    views: 'பார்வைகள்',
    item: 'பொருள்',
    questions: 'வினாக்கள்',
    total_points: 'மொத்த புள்ளிகள்',
    total_attempts: 'மொத்த முயற்சிகள்',
    created_date: 'உருவாக்கப்பட்ட தேதி',
    host_name: 'அயற்றுநர் பெயர்',
    host_section: 'அயற்றுநர் பகுதி',
    choose_products: 'பொருட்களை தேர்ந்தெடு',
    add_to_basket: 'கணக்கெடுப்புக்கு சேர்',
    basket: 'கணக்கெடு',
    times: 'முறை',
    scorms: 'SCORMகள்',
    skill_journey_overview: 'திறன் பயண மேலோட்டம்',
    how_to_use: 'எப்படிச் செயல்படுத்துவது',
    live_broadcast_description:
      'நாங்கள் நேரடி வீடியோக்களை எளிதில் பயன்படுத்தக்கூடிய பாடநெறி கட்டுமானத்தில் ஒருங்கிணைத்துள்ளோம்',
    live_broadcast_subdescription:
      'ShareLook இன் காப்புரிமைப் பெற்ற நேரடி ஒளிபரப்புச் செயல்பாட்டுடன், நீங்கள் ஈடுபாட்டை உருவாக்கி, கற்றல்களை தானாகச் செயற்படுத்தி, அறிவைப் பகிர்ந்து கொள்ளலாம்.',
    disclaimer: `என் திறன் பயணம்:
  - எந்த மூன்றாம் தரப்பின் உரிமைகளையும் மீறாது
  - தவறான தகவல்கள், அவமரியாதை, தவறான நடத்தை, பாலியல் அல்லது வன்முறையைக் கொண்டிருக்காது
  - மற்றவர்களுக்கு தனிப்பட்ட தாக்குதல்கள் செய்யாது
  - பிறரை போல நடமாட்டம் செய்யாது
  - ஒளிப்படங்கள் அல்லது தனிப்பட்ட தகவல்களை அவர்களுடைய அனுமதியின்றி பகிராது மற்றும் எந்தவொரு தரவு பாதுகாப்பு சட்டத்தையும் மீறாது
  - வணிகக் குறிக்கோளோ அல்லது “ஸ்பாம்” வகையிலான எந்தவொரு அழைப்பையும் கொண்டிருக்காது`,
    price: 'விலை',
    video_link: 'வீடியோ இணைப்பு',
    category: 'வகை',
    objectives: 'நோக்கங்கள்',
    marketplace_description: 'வணிக விளக்கம்',

    live_discussion: 'நேரடி கலந்துரையாடல்',
    poll: 'வாக்கெடுப்பு',
    hide_grid: 'கட்டத்தை மறை',
    show_grid: 'கட்டத்தை காண்பி',
    stop_screen_share: 'திரை பகிர்வை நிறுத்து',
    screen_share: 'திரை பகிர்வு',
    mute: 'சமாதானம்',
    unmute: 'சமாதானம் நீக்கு',
    raise_hand: 'கை எழுப்பு',
    waiting__: 'காத்திருக்கிறது...',
    audio_active: 'ஒலி செயல்பாட்டில் உள்ளது'
  },
  general: {
    save: 'சேமிக்கவும்',
    autosaved: 'தானாகசேமிக்கப்பட்டது',
    back_to: 'திரும்பு',
    by: 'மூலம்',
    chat: 'சாட்',
    completed: 'நிறைவடைந்தது',
    canceled: 'ரத்து செய்யப்பட்டது',
    component: 'கூறு',
    confirm: 'உறுதிப்படுத்தவும்',
    course: 'படிப்பு',
    skill: 'திறன் பயணம்',
    maze: 'மேட்டாமேஸ்',
    channel: 'சேனல்',
    podcast: 'பாட்காஸ்ட்',

    date: 'தேதி',
    details: 'விவரங்கள்',
    empty: 'தகவல் இல்லை',
    enrolled: 'பதிவுச் செய்யப்பட்டது',
    free: 'இலவசம்',
    graph: 'வரைபடம்',
    loading: 'ஏற்றுகிறது...',
    lesson: 'பாடம்',
    lessons: 'பாடங்கள்',
    live_assessment: 'நேரலை மதிப்பீடு',
    live_event: 'நேரலை நிகழ்வு',
    no: 'இல்லை',
    of: 'உடைய',
    or: 'அல்லது',
    organization: 'நிறுவனம்',
    page: 'பக்கம்',
    pages: 'பக்கங்கள்',
    personal: 'தனிப்பட்ட',
    poll: 'கருத்து கணிப்பு',
    rating: 'மதிப்பீடு',
    reset: 'மீட்டமை',
    signin: 'உள்நுழைக',
    signup: 'பதிவுபெறுக',
    soon: 'விரைவில்',
    type: 'வகை',
    uploading: 'பதிவேற்றுகிறது...',
    yes: 'ஆம்',
    something_went_wrong: 'ஏதோ தவறு ஏற்பட்டிருக்கிறது!',
    view_all: 'அனைத்தையும் காட்டு',
    upload_successful: 'பதிவேற்றம் வெற்றியடைந்தது',
    upload_successful_message:
      'உங்கள் எக்செல் ஆவணங்கள் வெற்றிகரமாக பதிவேற்றம் செய்யப்பட்டு தற்போது செயலாக்கப்படுகின்றன. இது சிறிது நேரம் எடுக்கலாம்.',
    check_email_upload_successful:
      'பதிவேற்றிய பயனர் பட்டியலின் </1>அறிக்கைக்கு<1> தயவுசெய்து <0>உங்கள் மின்னஞ்சலைச் சரிபார்க்கவும்</0>.',
    is_private: 'தனிப்பட்ட'
  },

  account: {
    title: 'கணக்கு',
    subtitle: 'உங்கள் அமைப்புகள் மற்றும் கணக்கு தகவல்களை நிர்வகிக்கவும்.',
    saved: 'கணக்கு வெற்றிகரமாக மாற்றப்பட்டது'
  },

  assessments: {
    title: 'மதிப்பீடுகள்',
    subtitle: 'ஒரு மதிப்பீட்டை உருவாக்கவும்',
    finished: 'மதிப்பீடு முடிந்தது',
    countdown: 'இல் நேரலை மதிப்பீடு ஒளிபரப்பப்படும் ',
    create: 'மதிப்பீட்டை உருவாக்கவும்',
    list_title: 'உங்கள் மதிப்பீடுகள்',
    delete_warning:
      'இந்த உருப்படியை நீக்க விரும்புவதில் நீங்கள் உறுதியாக உள்ளீர்களா?',
    details_title: 'மதிப்பீட்டு விவரங்களைச் சேர்க்கவும்',
    details_subtitle:
      'உங்கள் மதிப்பீட்டிற்கு பெயரிட்டு, மேலும் அதிலிருந்து அவர்கள் என்ன கற்றுக்கொள்ள எதிர்பார்க்க வேண்டும் என்பதை பார்வையாளர்களிடம் சொல்லுங்கள்.',
    disclaimer: `எனது பதிவு செய்யப்பட்ட மதிப்பீடு பின்வருவனவற்றை கொண்டிருக்காது என்று நான் உத்தரவாதம் அளிக்கிறேன்:
    - எந்தவொரு மூன்றாம் தரப்பினரின் உரிமைகளையும் மீறுதலை
    - அவதூறு, வெறுப்பூட்டுகிற, அநாகரீகமான, மோசமான, ஆபாசமான, வன்முறை, துஷ்பிரயோகம், அவமதிப்பு, அச்சுறுத்தல் அல்லது பாரபட்சமான உள்ளடக்கம், நட்சத்திரக் குறிப்புகளுடன் கூட மறைக்கப்பட்ட உள்ளிட்ட எந்தவொரு சட்டவிரோதத்தையும் கொண்டிருத்தல்
    - மற்ற நபர்கள் மீதான தனிப்பட்ட தாக்குதல்களைக் கொண்டிருத்தல்
    - பிற பங்கேற்பாளர்கள், பொது நபர்கள் அல்லது பிரபலங்களைப் போல் ஆள்மாறாட்டம் ஆகியவற்றைக் கொண்டிருத்தல்
    - எந்தவொரு தனிநபரின் எந்தவொரு பதிவு அல்லது தனிப்பட்ட தகவல்களையும் அத்தகைய நபரின் அனுமதியின்றி கொண்டிருப்பது மற்றும் உலகின் எந்தவொருப் பகுதியின் தகவல் பாதுகாப்பு ஒழுங்குமுறைகளை மீறுதலை
    - எந்தவொரு வணிகம் தொடர்பான வற்புறுத்தும் வேண்டுதலை அல்லது எந்த வகையான "ஸ்பேம்" கொண்டிருத்தல்`,
    assessment_details: 'மதிப்பீட்டு விவரங்கள்',

    assessment_settings: 'மதிப்பீட்டு அமைப்புகள்'
  },

  buildersettings: {
    title: 'அமைப்புகளை வெளியிடுக',
    subtitle:
      'உங்கள் நிகழ்வைக் காணக்கூடிய மற்றும் தொடர்பு கொள்ளக்கூடிய வகையில் உங்கள் நிகழ்வில் அமைப்புகளைச் சேர்க்கவும்'
  },

  buttons: {
    market_place: 'Market Place',
    back_to_normal: 'Back To Normal',
    add: 'சேர்க்கவும்',
    add_page: 'பக்கத்தைச் சேர்க்கவும்',
    add_lesson: 'பாடங்களைச் சேர்க்கவும்',
    add_answer: 'புதிய பதிலைச் சேர்க்கவும்',
    add_group: 'குழுவைச் சேர்க்கவும்',
    add_organization: 'நிறுவனத்தைச் சேர்க்கவும்',
    add_question: 'கேள்வியைச் சேர்க்கவும்',
    add_quiz: 'வினாடி வினாவைச் சேர்க்கவும்',
    add_users: 'பயனர்களைச் சேர்க்கவும்',
    back: 'திரும்பு',
    back_to_course: 'படிப்பின் கண்ணோட்டத்திற்குத் திரும்பு',
    back_to_lesson: 'பாட கண்ணோட்டத்திற்குத் திரும்பு',
    back_to_media: 'மீடியா நூலகத்திற்குத் திரும்பு',
    back_to_details: 'விவரங்களுக்குத் திரும்பு',
    cancel: 'ரத்துசெய்',
    clear: 'அழி',
    close: 'மூடு',
    clone: 'குளோன்',
    close_lesson: 'பாடத்தை மூடு',
    clone_course: 'குளோன் படிப்பு',
    confirm: 'உறுதிப்படுத்தவும்',
    create: 'உருவாக்கு',
    download: 'பதிவிறக்கவும்',
    download_mass_user_tamplate: 'டெம்ப்ளேட்டைப் பதிவிறக்கவும்',
    add_mass_users: 'பெரிய எண்ணிக்கை பயனர்களைச் சேர்க்கவும்',
    upload_excel_list: 'எக்செல் பட்டியலைப் பதிவேற்றுக',
    delete: 'மீடியாவை நீக்கு',
    edit: 'திருத்து',
    edit_course: ' படிப்பைத் திருத்து',
    enroll: 'பதிவுசெய்க',
    finish: 'முடிக்கவும்',
    upload_image: 'படத்தை பதிவேற்றம் செய்யவும்',
    upload_image_video: 'படம் அல்லது வீடியோவைப் பதிவேற்றவும்',
    select_media_library: 'மீடியா நூலகத்தைத் தேர்ந்தெடுக்கவும்',
    make_public: 'பகிரங்கமாக்குங்கள்',
    make_private: 'தனிப்பட்டதாக்குங்கள்',
    make_org: 'நிறுவனத்தை உருவாக்குங்கள்',
    media: 'மீடியா நூலகம்',
    my_theme: 'எனது தீம்',
    next: 'அடுத்தது',
    next_lesson: 'அடுத்த பாடம்',
    next_step: 'அடுத்தப் படி',
    previous_step: 'முந்தைய படி',
    publish: 'வெளியிடு',
    publish_assessment: 'உங்கள் மதிப்பீட்டை வெளியிடுங்கள்',
    publish_course: 'உங்கள் படிப்பை வெளியிடுங்கள்',
    publish_event: 'உங்கள் நிகழ்வை வெளியிடுங்கள்',
    reset: 'மீட்டமை',
    reset_elements: 'கூறுகளை மீட்டமை',
    save: 'சேமிக்கவும்',
    creating: 'உருவாக்குகிறது...',
    updating: 'அப்டேட் செய்கிறது...',
    saved: 'சேமிக்கப்பட்டது',
    save_for_later: 'பிறகு சேமிக்கவும்',
    save_settings: 'அமைப்புகளைச் சேமிக்கவும்',
    select_files: 'கோப்புகளைத் தேர்ந்தெடுக்கவும்',
    select_theme: 'தீம் தேர்ந்தெடுக்கவும்',
    start_lesson: 'பாடத்தைத் தொடக்கவும்',
    update: 'அப்டேட்',
    upload: 'பதிவேற்றவும்',
    upload_audio: 'ஆடியோவைப் பதிவேற்றுக',
    upload_photo: 'ஒரு சுயவிவரப் புகைப்படத்தைப் பதிவேற்றுக',
    upload_video: 'வீடியோவைப் பதிவேற்றவும்',
    enrolled: 'பதிவுச் செய்யப்பட்டது',
    unenroll: 'பதிவை நீக்கு',
    from_library: 'மீடியா நூலகம்',
    remove: 'நீக்கு',
    removed: 'நீக்கப்பட்டது',
    start_broadcast: 'ஒளிபரப்பைத் தொடங்குங்கள்',
    end_broadcast: 'ஒளிபரப்பை முடிக்கவும்',
    camera: 'கேமரா',
    screen: 'திரை',
    screen_with_camera: 'கேமராவுடன் திரை',
    insert: 'செருகு',

    inserting: 'செருகுகிறது'
  },

  card: {
    quick_add: 'விரைவாக சேர்க்க',
    add: 'சேர்',
    clone: 'குளோன்',
    completed: 'பாடங்கள் முடிந்தது'
  },

  course: {
    upcoming_course: 'வரவிருக்கும் படிப்பு',
    unPublishEvent: 'வெளியிடாத நிகழ்வு',
    unPublishAssessment: 'வெளியிடாத மதிப்பீடு',
    pastCourse: 'பயிற்சி படிப்பு',
    upcoming: 'வரவிருக்கும் நேரலை நிகழ்வு',
    pastEvent: 'கடந்த நேரலை நிகழ்வு',
    pastAssessment: 'கடந்த நேரலை மதிப்பீடு',
    upcomingAssessment: 'வரவிருக்கும் நேரலை மதிப்பீடு',
    created: 'உருவாக்கிய தேதி:',
    assignees: 'ஒதுக்கீட்டாளர்கள்',
    organisations:
      ' {{ நிறுவனங்கள் }} நிறுவனங்கள், <2> {{ பயனர்கள் }} பயனர்கள்</2>',
    event_date: 'நேரலை நிகழ்வு தேதி <1> {{ தேதி }} </1>',
    delete_warning: 'இதை நீக்க விரும்புவதை நீங்கள் உறுதி செய்கிறீர்களா',
    clonning_no_lesson:
      'இந்த கோர்ஸை குளோன் செய்ய குறைந்தபட்சம் ஒரு பாடத்தையாவது தயவுசெய்து சேர்க்கவும்.',
    clone_warning: 'இதை குளோன் செய்ய விரும்புவதை நீங்கள் உறுதி செய்கிறீர்களா',
    clone_success: 'குளோனிங் செயல்பாட்டில் உள்ளது',
    disclaimer: `எனது படிப்புப் பின்வருவனவற்றை கொண்டிருக்காது என்று நான் உத்தரவாதம் அளிக்கிறேன்:
- எந்தவொரு மூன்றாம் தரப்பினரின் உரிமைகளையும் மீறுதலை
- அவதூறு, வெறுப்பூட்டுகிற, அநாகரீகமான, மோசமான, ஆபாசமான, வன்முறை, துஷ்பிரயோகம், அவமதிப்பு, அச்சுறுத்தல் அல்லது பாரபட்சமான உள்ளடக்கம், நட்சத்திரக் குறிப்புகளுடன் கூட மறைக்கப்பட்ட உள்ளிட்ட எந்தவொரு சட்டவிரோதத்தையும் கொண்டிருத்தல்
- மற்ற நபர்கள் மீதான தனிப்பட்ட தாக்குதல்களைக் கொண்டிருத்தல்
- பிற பங்கேற்பாளர்கள், பொது நபர்கள் அல்லது பிரபலங்களைப் போல் ஆள்மாறாட்டம் ஆகியவற்றைக் கொண்டிருத்தல்
- எந்தவொரு தனிநபரின் எந்தவொரு பதிவு அல்லது தனிப்பட்ட தகவல்களையும் அத்தகைய நபரின் அனுமதியின்றி கொண்டிருப்பது மற்றும் உலகின் எந்தவொருப் பகுதியின் தகவல் பாதுகாப்பு ஒழுங்குமுறைகளை மீறுதலை
- எந்தவொரு வணிகம் தொடர்பான வற்புறுத்தும் வேண்டுதலை அல்லது எந்த வகையான "ஸ்பேம்" கொண்டிருத்தல்`
  },

  coursecreate: {
    dropzone_text: 'மீடியாவைச் செருகவும்',
    sidebar_text:
      'உங்கள் <3 /> பாடங்களுக்கு ஒரு தீம் <1 /> ஐத் தேர்ந்தெடுக்கவும்',
    delete_warning:
      'இந்த பாடத்தை நீக்க விரும்புவதை நீங்கள் உறுதிப்படுத்துகிறீர்களா?'
  },

  coursepage: {
    quizview_loading: 'பதில்களைச் சரிபார்க்கிறது. தயவுசெய்து காத்திருங்கள்...',
    quizview_answer: 'உங்கள் பதில்'
  },

  coursequiz: {
    title: 'அனைத்து பாடங்களிலும் வினாடி வினாக்கள்'
  },

  dashboard: {
    tooltip_title: 'இந்த வீடியோவை மீண்டும் காட்ட வேண்டாம்',
    page_title: 'உங்கள் படிப்புகளின் புள்ளிவிவரம்',
    page_subtitle: 'நீங்கள் உருவாக்கிய படிப்புகளின் நிலை',
    profile_add_info:
      'உங்கள் சுயவிவரத்தை முடிக்க உங்கள் <1>{{முழுமையற்ற உரை}}</1> ஐச் சேர்க்கவும்.',
    profile_build:
      'உங்கள் சுயவிவரத்தை உருவாக்கவும் <1>இங்கே</ 1>, உங்கள் ஆர்வங்களையும் திறன்களையும் எங்களுக்குத் தெரியப்படுத்துங்கள்.',
    profile_title: 'சுயவிவர வலிமை',
    more_details: 'கூடுதல் தகவல்கள்'
  },

  errors: {
    answer: 'தயவுசெய்து பதிலை உள்ளிடுக',
    answer_correct: 'சரியான பதிலைத் தேர்வுசெய்க',
    code: 'தயவுசெய்து உங்கள் குறியீட்டை உள்ளிடவும்',
    criterion: 'தயவுசெய்து அளவுகோலை உள்ளிடவும்',
    duration: 'கால அளவு தேவைப்படுகிறது',
    element: 'தயவுசெய்து கூறை உள்ளிடவும',
    email: 'தயவுசெய்து உங்கள் மின்னஞ்சலை உள்ளிடவும்',
    email_invalid: 'உள்ளிடப்பட்ட மின்னஞ்சல் தவறானது',
    feedback_correct: 'தயவுசெய்து கருத்தை சரியாக உள்ளிடவும்',
    feedback_incorrect: 'உள்ளிடப்பட்ட கருத்து தவறானது',
    host: 'தயவுசெய்து நிகழ்வு ஹோஸ்டை உள்ளிடவும்',
    host_assessment: 'தயவுசெய்து மதிப்பீட்டு ஹோஸ்டை உள்ளிடவும்',
    image: 'தயவுசெய்து ஒரு படத்தை பதிவேற்றவும்',
    location: 'தயவுசெய்து உங்கள் இருப்பிடத்தை உள்ளிடவும்',
    live_location: 'தயவுசெய்து ஒரு ஒளிபரப்பு இருப்பிடத்தைத் தேர்வுசெய்க',
    limit: 'தயவுசெய்து லைவ்-ஸ்ட்ரீமிங் நிமிடங்களை உள்ளிடவும்',
    min_3char: 'குறைந்தபட்சம் 3 எழுத்துக்கள்',
    number: 'தயவுசெய்து நேர்மறை எண்ணை உள்ளிடவும்.',
    host_email_require: `ஹோஸ்டின் மின்னஞ்சல்கள் தேவைப்படுகிறது.`,
    attendee_email_require: `பங்கேற்பாளரின் மின்னஞ்சல்கள் தேவைப்படுகிறது.`,
    name: 'தயவுசெய்து உங்கள் பெயரை உள்ளிடவும்',
    not_found_course: ' படிப்புக் கிடைக்கவில்லை',
    not_found_event: 'நிகழ்வு கிடைக்கவில்லை',
    not_found_assessment: 'மதிப்பீடு கிடைக்கவில்லை',
    password: 'தயவுசெய்து உங்கள் கடவுச்சொல்லை உள்ளிடவும்',
    password_digit: 'குறைந்தபட்சமாக ஒரு எண் தேவை',
    password_short:
      'கடவுச்சொல் மிகச் சிறியதாக உள்ளது, குறைந்தபட்சம் 10 எழுத்துக்கள் தேவை',
    password_special: 'குறைந்தபட்சம் ஒரு ஸ்பெஷல் எழுத்து தேவை',
    password_uppercase: 'குறைந்தது ஒரு பெரிய எழுத்து தேவை',
    password_lowercase: 'குறைந்தது ஒரு சிறிய எழுத்து தேவை',
    phone: 'தயவுசெய்து உங்கள் தொலைபேசியை உள்ளிடவும்',
    phone_invalid: 'தவறான தொலைபேசி எண்',
    position: 'தயவுசெய்து உங்கள் நிலையை உள்ளிடவும்',
    question: 'தயவுசெய்து கேள்வியை உள்ளிடவும்',
    start_date: 'தொடங்கும் தேதி & நேரம் தேவைப்படுகிறது',
    tag: 'தயவுசெய்து ஒரு குறிச்சொல்லைத் தேர்ந்தெடுக்கவும்',
    topics: 'தயவுசெய்து ஒரு தலைப்பையாவது தேர்ந்தெடுக்கவும்.',
    live_topics: 'தயவுசெய்து தலைப்புகளைச் சேர்க்கவும்',
    title: 'தயவுசெய்து தலைப்பை உள்ளிடுக',
    title_assessment: 'தயவுசெய்து மதிப்பீட்டு தலைப்பை உள்ளிடவும்',
    title_course: 'தயவுசெய்து படிப்புத் தலைப்பை உள்ளிடவும்',
    title_empty: 'தலைப்பு காலியாக இருக்கக்கூடாது',
    title_event: 'தயவுசெய்து நிகழ்வு தலைப்பை உள்ளிடவும்',
    title_lesson: 'தயவுசெய்து பாடத்தலைப்பை உள்ளிடவும்',
    title_quiz: 'தயவுசெய்து வினாடி வினா பெயரை உள்ளிடவும்',
    username: 'தயவுசெய்து உங்கள் பயனர்பெயரை உள்ளிடவும்',
    upload_error: 'பிழை - கோப்பு பொருந்தவில்லை!',
    upload_more_than_10:
      'நீங்கள் ஒரே நேரத்தில் அதிகபட்சம் 10 கோப்புகளை மட்டுமே பதிவேற்ற முடியும்.',
    topics_max: 'தயவுசெய்து அதிகபட்சம் 3 தலைப்புகளைச் சேர்க்கவும்.',
    upload_excel:
      'தயவுசெய்து நீங்கள் சரியான கோப்பை பதிவேற்றியுள்ளீர்கள் என்பதை உறுதிப்படுத்தவும்.',
    title_excel: 'டெம்ப்ளேட்டை பதிவேற்றுவதில் பிழை:',
    file_size_exceed: 'கோப்பு அளவு மீறியது',
    subtitle_excel:
      'தயவுசெய்து நீங்கள் வழங்கப்பட்ட டெம்ப்ளேட்டை பயன்படுத்துகிறீர்கள் மற்றும் நெடுவரிசைகள் சரியாக நிரப்பப்படுகின்றன என்பதை உறுதிப்படுத்தவும்.',
    select_broadcast_option:
      'தயவுசெய்து இந்த நிகழ்வை ஒளிபரப்ப ஒரு விருப்பத்தேர்வை தேர்ந்தெடுக்கவும்',
    multi_hosts_number_error:
      'தொகுப்பாளரின் எண்ணிக்கை நிகழ்வுக்காக குறிப்பிடப்பட்டதை விட அதிகமாக இருக்கக்கூடாது.',
    conference_people_number_error: `பங்கேற்பாளரின் எண்ணிக்கை நிகழ்வுக்காக குறிப்பிடப்பட்டதை விட அதிகமாக இருக்கக்கூடாது.`,
    select_max_host:
      'நிகழ்வுக்காக குறைந்தது 1 தொகுப்பாளரைத் தேர்ந்தெடுக்கவும்.',
    select_max_conference:
      'நிகழ்வுக்காக குறைந்தது 1 பங்கேற்பாளரைத் தேர்ந்தெடுக்கவும்.',
    stream_stop_error: 'எதிர்பாராத விதமாக ஸ்ட்ரீமிங் நிறுத்தப்பட்டது!',
    unsecure_context:
      'அபாயகரமான பிழை: பாதுகாப்பற்ற சூழல் காரணமாக கேமரா மற்றும் மைக்கை ப்ரௌசரால் அணுக முடியாது. தயவுசெய்து SSL ஐ நிறுவி https வழியாக அணுகவும்',
    ws_not_supported:
      'அபாயகரமான பிழை: இந்த ப்ரௌசரில் வெப்சாக்கெட் ஆதரிக்கப்படவில்லை',
    no_org: 'தொடர குறைந்தது 1 அமைப்பைத் தேர்ந்தெடுக்கவும்.',
    no_org_group: 'தொடர குறைந்தபட்சம் 1 நிறுவன குழுவையாவது தேர்ந்தெடுக்கவும்.',
    waiting_to_join: 'யாராவது சேரக் காத்திருக்கிறார்கள்!'
  },

  events: {
    title: 'நேரலை நிகழ்வு விவரங்களைச் சேர்க்கவும்',
    change_host: 'ஹோஸ்டை மாற்றவும்',
    finished: 'நிகழ்வு முடிந்தது',
    countdown: 'இல் நேரலை நிகழ்வு ஒளிபரப்பப்படும் ',
    subtitle:
      'உங்கள் நேரலை நிகழ்வுக்கு பெயரிடுங்கள் மற்றும் அதிலிருந்து அவர்கள் என்ன கற்றுக்கொள்ள  எதிர்பார்க்க வேண்டும் என்பதை உங்கள் பார்வையாளர்களிடம் சொல்லுங்கள்.',
    poll_disabled: 'இந்த நிகழ்வில் கருத்து கணிப்பு கிடைக்கவில்லை',
    disclaimer: `எனது பதிவு செய்யப்பட்ட நிகழ்வு பின்வருவனவற்றை கொண்டிருக்காது என்று நான் உத்தரவாதம் அளிக்கிறேன்:
  - எந்தவொரு மூன்றாம் தரப்பினரின் உரிமைகளையும் மீறுதலை
- அவதூறு, வெறுப்பூட்டுகிற, அநாகரீகமான, மோசமான, ஆபாசமான, வன்முறை, துஷ்பிரயோகம், அவமதிப்பு, அச்சுறுத்தல் அல்லது பாரபட்சமான உள்ளடக்கம், நட்சத்திரக் குறிப்புகளுடன் கூட மறைக்கப்பட்ட உள்ளிட்ட எந்தவொரு சட்டவிரோதத்தையும் கொண்டிருத்தல்
- மற்ற நபர்கள் மீதான தனிப்பட்ட தாக்குதல்களைக் கொண்டிருத்தல்
- பிற பங்கேற்பாளர்கள், பொது நபர்கள் அல்லது பிரபலங்களைப் போல் ஆள்மாறாட்டம் ஆகியவற்றைக் கொண்டிருத்தல்
- எந்தவொரு தனிநபரின் எந்தவொரு பதிவு அல்லது தனிப்பட்ட தகவல்களையும் அத்தகைய நபரின் அனுமதியின்றி கொண்டிருப்பது மற்றும் உலகின் எந்தவொருப் பகுதியின் தகவல் பாதுகாப்பு ஒழுங்குமுறைகளை மீறுதலை
- எந்தவொரு வணிகம் தொடர்பான வற்புறுத்தும் வேண்டுதலை அல்லது எந்த வகையான "ஸ்பேம்" கொண்டிருத்தல்`,
    prompt_message:
      'இந்தப் பக்கத்தை விட்டு வெளியேறுவது உங்கள் நிகழ்வை முடிக்கும். இந்தப் பக்கத்தை விட்டு வெளியேறுவதில் நீங்கள் உறுதியாக இருக்கிறீர்களா?',
    duration_exceed_message:
      'உங்கள் ஒளிபரப்பு நேரம் மீறியது, ஆப் ஒளிபரப்பை நிறுத்தப் போகிறது.',
    before_schedule_message:
      'திட்டமிடப்பட்ட நிகழ்வு நேரத்திற்கு முன்பே நீங்கள் ஒளிபரப்பைத் தொடங்க உள்ளீர்கள். ஒளிபரப்பை நிறுத்தினால் நிகழ்வு முடிவடையும் என்பதை நினைவில் கொள்ளுங்கள்.',
    browser_unsupportive_message:
      'உங்கள் உலாவி திரை பகிர்வை ஆதரிக்கவில்லை. இந்த இணைப்பில் ஆதரிக்கப்பட்ட உலாவிகளைக் காணலாம்',
    cancel_switch_host_message:
      'ஹோஸ்ட் கிடைக்கவில்லை. நிகழ்வு உங்கள் தரப்பிலிருந்து தொடரும்.',
    coaching_prompt_message:
      'நிகழ்வு முடியும் வரை இந்த பக்கத்தை விட்டு நீங்கள் வெளியேற முடியாது.',
    event_modal_warn: ' நீங்கள் இந்த நிகழ்வை விட்டு வெளியேற விரும்புகிறீர்களா?',
    confirm_message:
      'நீங்கள் OK என்பதைக் கிளிக் செய்தால் உங்கள் நிகழ்வு முடிவடையும்.',
    screen_share_denied: 'உங்கள் திரையைப் பகிர நீங்கள் மறுத்துவிட்டீர்கள்',
    media_not_found:
      'உங்கள் சாதனத்தில் கேமரா அல்லது மைக் காணப்படவில்லை அல்லது அனுமதிக்கப்படவில்லை.',
    media_not_access:
      'கேமரா அல்லது மைக் சாதனங்கள் வேறு சில செயல்களால் பயன்படுத்தப்படுகிறது அதனால் அதை ரீட் செய்ய முடியவில்லை',
    constraint_error:
      'உங்கள் வீடியோ மற்றும் ஆடியோ கட்டுப்பாடுகளுக்கு பொருந்தக்கூடிய எந்த சாதனமும் இல்லை. நீங்கள் வீடியோ மற்றும் ஆடியோ கட்டுப்பாடுகளை மாற்றலாம்',
    media_access_denied: 'கேமரா மற்றும் மைக்கை அணுக உங்களுக்கு அனுமதி இல்லை.'
  },

  filters: {
    days7: 'கடந்த 7 நாட்கள்',
    days15: 'கடந்த 15 நாட்கள்',
    days30: 'கடந்த 30 நாட்கள்',
    days365: 'கடந்த 365 நாட்கள்',
    date: 'உருவாக்கப்பட்ட தேதி',
    relevance: 'தொடர்பான',
    popularity: 'பிரபலமான',
    name: 'பெயர்',
    group: 'குழு',
    Newest_to_Oldest: 'புதியது முதல் பழையது',
    Oldest_to_Newest: 'பழையது முதல் புதியது',
    A_Z: 'A to Z',
    Z_A: 'Z to A'
  },

  helpers: {
    password:
      'உங்கள் கணக்கின் பாதுகாப்பை உறுதிப்படுத்த, உங்கள் கடவுச்சொல்லில் குறைந்தபட்சம் ஒரு சிறிய எழுத்து, எண் தேவை. நீங்கள் குறைந்தபட்சம் 10 எழுத்துகளின் நீளத்தையும் கொண்டிருக்க வேண்டும்.',
    phone:
      'உங்கள் நாட்டின் தொலைபேசி குறியீட்டைச் சேர்க்கவும், எடுத்துக்காட்டாக: +65',
    username:
      'உங்கள் பயனர்பெயர் பொதுத் தகவலாகக் கருதப்படுகிறது மற்றும் தேவைக்கேற்ப பிற பயனர்களுடன் பகிரப்படுகிறது. எனவே, உங்கள் பயனர்பெயரில் தனிப்பட்ட தகவல்களைப் பயன்படுத்த வேண்டாம் என்று நாங்கள் பரிந்துரைக்கிறோம்',
    public_description_normal:
      'உங்கள் <0><0/></0> சேமிக்கப்பட்டது மற்றும் இயல்பாகவே தனிப்பட்டதாக கருதப்படுகிறது. இதன் பொருள், நீங்கள் மட்டுமே இந்த உள்ளடக்கத்தைக் காண முடியும். இந்த உள்ளடக்கத்தை வெளியிட நீங்கள் கீழே உள்ள விருப்பத்தேர்வுகளில் ஒன்றைத் தேர்ந்தெடுக்கலாம். உங்கள் பாடத்திட்டத்தை பொதுவில் வெளியிடுவது என்பது இயங்குதளத்தில் உள்ள அனைத்து பயனர்களுக்கும் கிடைக்கும் என்பதாகும். ஷேர்லுக் கணக்குடன் தொடர்புடைய அவர்களின் மின்னஞ்சல் முகவரியைப் பயன்படுத்தி குறிப்பிட்ட பயனர்களுடன் உங்கள் பாடத்திட்டத்தைப் பகிர குறிப்பிட்ட பயனர்களின் விருப்பத்தேர்வு உதவுகிறது.',
    public_description_admin:
      'இது <0><0/></0> சேமிக்கப்பட்டது மற்றும் இயல்பாகவே தனிப்பட்டதாக கருதப்படுகிறது. இதன் பொருள் நீங்கள் (மற்றும் உள்ளடக்கம் உருவாக்கியவர்) மட்டுமே இந்த உள்ளடக்கத்தைக் காண முடியும். இந்த உள்ளடக்கத்தை வெளியிட நீங்கள் கீழே உள்ள விருப்பத்தேர்வுகளில் ஒன்றைத் தேர்ந்தெடுக்கலாம். உங்கள் பாடத்திட்டத்தை பொதுவில் வெளியிடுவது என்பது உங்கள் நிறுவனத்திற்கு வெளியே உள்ளவர்கள் உட்பட மேடையில் உள்ள அனைத்து பயனர்களுக்கும் கிடைக்கும் என்பதாகும். அதை நிறுவனத்திற்கு வெளியிடுவது என்பது நிறுவனத்திற்குள் உள்ள அனைத்து பயனர்களும் அதைப் பார்க்க முடியும் என்பதாகும். நீங்கள் இதை 1 அல்லது அதற்கு மேற்பட்ட குழுக்களுக்கும் வெளியிடலாம், அதாவது அந்தக் குழுக்களில் உள்ள பயனர்கள் மட்டுமே அதைப் பார்க்க முடியும். கடைசியாக, உங்கள் நிறுவனத்திற்கு உள்ளேயும் வெளியேயும் குறிப்பிட்ட பயனர்களுக்கு அவர்களின் ஷேர்லுக் கணக்கு மின்னஞ்சல் முகவரியைப் பயன்படுத்தி வெளியிட உங்களுக்கு விருப்பத்தேர்வு உள்ளது.'
  },

  labels: {
    add: 'சேர்க்கவும்',
    portrait: 'Crop Portrait',
    landscape: 'Crop Landscape',
    answer_type: 'பதில் வகை',
    answers: 'பதில்கள்',
    back_to_quiz: 'வினாடி வினா பட்டியலுக்குத் திரும்பு',
    back_to_question: 'கேள்விகள் பட்டியலுக்குத் திரும்பு',
    chat: 'சாட்',
    chat_available: 'இந்த நிகழ்வில் சாட் கிடைக்கவில்லை',
    chat_report: 'சாட் அறிக்கை',
    choice_single: 'ஒற்றை தேர்வு',
    choice_multiple: 'பலவகை தேர்வு',
    choice_free: '"இலவச" தேர்வு',
    choice_sorting: '"வரிசை" தேர்வு',
    choice_matrix: '"மேட்ரிக்ஸ் வரிசை" தேர்வு',
    clone_lesson_permission: 'குளோன் அனுமதி',
    code: 'குறியீடு',
    correct: 'சரியான',
    created: 'உருவாக்கப்பட்ட தேதி',
    clone_modal: 'குளோன் படிப்பு',
    cloning_course: ' படிப்பை குளோனிங் செய்கிறது...',
    cloning: 'குளோனிங்...',
    cloning_course_desc:
      'இந்த செயல்முறை சிறிது நேரம் எடுக்கும். தயவுசெய்து பொறுமையாக இருங்கள்',
    cloning_success: '"<0/>" படிப்பு வெற்றிகரமாக குளோன் செய்யப்பட்டுள்ளது!',
    description: 'விளக்கம்',
    disclaimer: 'உரிமைத் துறப்பு',
    drop_file: 'கோப்பை இங்கே விடுங்கள்...',
    duration: 'கால அளவு',
    edit: 'திருத்து',
    email: 'மின்னஞ்சல்',
    event: 'நிகழ்வு',
    event_all: 'அவரது அனைத்து நிகழ்வுகளும்',
    event_date: 'நேரலை நிகழ்வின் உள்ளூர் தேதி/நேரம்',
    event_this: 'இந்த நிகழ்வு',
    expire: 'காலாவதியாகிறது',
    expiry_date: 'காலாவதி தேதி',
    forgot: 'கடவுச்சொல்லை மறந்துவிட்டீர்களா?',
    group: 'குழு',
    groups_list: 'குழுக்களின் பட்டியல்',
    host: 'ஹோஸ்ட்',
    id_annotation: ' விரிவுரை ஐடி',
    id_quiz: 'வினாடி வினா ஐடி',
    incorrect: 'தவறானது',
    interests: 'ஆர்வங்கள்',
    invited: 'அழைக்கப்பட்டார்',
    live_chat: 'நேரலை கலந்துரையாடல்',
    live_stream_limit: 'நேரலை-ஸ்ட்ரீமிங் நிமிடங்கள்',
    contact_text:
      'உங்கள் மாதாந்திர நேரலை-ஸ்ட்ரீமிங் வரம்பை மாற்ற தயவுசெய்து தொடர்பு கொள்ளவும்',
    contact_admin:
      '<0>உங்கள் மாதாந்திர நேரலை-ஸ்ட்ரீமிங் வரம்பை மாற்ற விரும்பினால் தயவுசெய்து தொடர்பு கொள்ளவும்</0> <1>admin@sharelook.com</1>',
    limit_stream_text:
      'மீதமுள்ள நேரலை ஸ்ட்ரீமிங் நிமிடங்கள்: <0>{{ limit }}</0> minutes <1/><2/> <3>உங்கள் மாதாந்திர நேரலை-ஸ்ட்ரீமிங் வரம்பை மாற்ற தயவுசெய்து தொடர்பு கொள்ளவும்</3> <4>admin@sharelook.com</4>',
    location: 'இடம்',
    lessons: 'பாடங்கள்',
    location_broadcast: 'ஹோஸ்ட் சேவையக இருப்பிடம்',
    location_broadcast_subtitle:
      'ஆடியோவிஷுவல் தாமதத்தைக் குறைக்க ஒளிபரப்பு ஹோஸ்டின் இருப்பிடத்திற்கு மிக நெருக்கமான ஒரு இருப்பிடத்தைச் சேர்க்கவும்',
    media_manager: 'மீடியா மேலாளர்',
    minutes: 'நிமிடங்கள்',
    name: 'பெயர்',
    online_quiz: 'ஆன்லைன் வினாடி வினா',
    organiser: 'நூலாசிரியர்',
    organization: 'நிறுவனம்',
    overall_emotion: 'ஒட்டுமொத்த அனுபவம்:',
    organizations_list: 'நிறுவனங்களின் பட்டியல்',
    password: 'கடவுச்சொல்',
    participants: 'பங்கேற்பாளர்கள்',
    picture: 'படம் (16:9)',
    phone: 'தொலைபேசி',
    photo: 'புகைப்படம்',
    poll: 'கருத்து கணிப்பு',
    position: 'நிலை',
    processing: 'செயலாக்கம்',
    privacy_settings: 'தனியுரிமை அமைப்புகள்',
    question: 'கேள்வி',
    quiz_create: 'புதிய வினாடி வினாவை உருவாக்கவும்',
    quiz_name: 'வினாடி வினாவின் பெயர்',
    quiz_update: 'வினாடி வினாவைப் புதுப்பிக்கவும்',
    select_organization: 'ஒரு நிறுவனத்தைத் தேர்ந்தெடுக்கவும்',
    settings: 'அமைப்புகள்',
    show: 'காட்டு',
    show_graph: 'வரைபட முடிவைக் காட்டு',
    signin: 'உள்நுழைக',
    signup: 'பதிவுபெறுக',
    sort_by: 'மூலம் வரிசைப்படுத்து',
    start_date: 'தொடக்க தேதி',
    tags: 'குறிச்சொற்கள்',
    terms:
      'இந்த <1>விதிமுறைகளையும் நிபந்தனைகளையும்</1> நான் ஒப்புக்கொள்கிறேன்.',
    title: 'தலைப்பு',
    topics: 'தலைப்புகள்',
    topic: 'தலைப்பு',
    total_comments: 'மொத்த கருத்துகள்',
    username: 'பயனர்பெயர்',
    users_list: 'பயனர்களின் பட்டியல்',
    users_emails: 'குறிப்பிட்ட பயனர்களின் மின்னஞ்சல்களைச் செருகவும்',
    description_specifiction_email:
      'பல குறிப்பிட்ட பயனர்களுடன் இதைப் பகிர ஒரு வரியில் 1 மின்னஞ்சல் முகவரியை தயவுசெய்து உள்ளிடவும்.',
    message_specific_email:
      'தயவுசெய்து குறிப்பிட்ட பயனரின் ஒரு மின்னஞ்சலை உள்ளிடவும்.',
    viewers: 'பார்வையாளர்கள்',
    edit_course: 'திருத்து',
    edit_assessment: 'திருத்து',
    edit_event: 'திருத்து',
    delete_course: 'நீக்கு',
    delete_event: 'நீக்கு',
    delete_assessment: 'நீக்கு',
    view_course: 'காண்க',
    view_event: 'காண்க',
    view_assessment: 'காண்க',
    date_event: 'நேரலை நிகழ்வின் தேதி',
    date_assessment: 'நேரலை மதிப்பீட்டின் தேதி',
    clone_of: 'குளோன்',
    clone_course:
      'எல்லா பாடங்களும் மற்றும் பக்கங்களும் அடங்கிய, நீங்கள் அசலில் இருந்து சுயாதீனமாக மாற்றக்கூடிய, இந்த பாடத்தின் ஒரு குளோனை உருவாக்கவும்.',
    make: 'செய்யுங்கள்',
    available_to: 'எந்தவொரு ஷேர்லூக் பயனருக்கும் கிடைக்கும்',
    uploaded_by: 'மூலம் பதிவேற்றியது: ',
    course: 'படிப்பு',
    assessment: 'மதிப்பீடு',
    user_not_exist:
      'பயனர் இல்லை, நீங்கள் ஒரு அழைப்பை அனுப்ப விரும்புகிறீர்களா?',
    check_user: 'அறிவிப்பு',
    user_not_exist_in_org:
      'இந்த நிறுவனத்தில் பயனர் இல்லை, நீங்கள் ஒரு அழைப்பை அனுப்ப விரும்புகிறீர்களா?',
    title_modal_stream: 'நிறுவன நேரலை ஸ்ட்ரீம் வரம்பை மாற்றவும்',
    des_warning_stream: 'நீங்கள் மாற்றப் போகிறீர்கள்',
    monthly_stream: 'மாதாந்திர நேரலை-ஸ்ட்ரீமிங் வரம்பு:',
    min_per_month: 'நிமிடங்கள்/மாதம்',
    broadcast_label: 'நான் செய்ய விரும்புகிறேன்:',
    hosts_emails: `குறிப்பிட்ட ஹோஸ்டின் மின்னஞ்சல்களைச் செருகவும்`,
    attendee_emails: `குறிப்பிட்ட பங்கேற்பாளரின் மின்னஞ்சல்களைச் செருகவும்`,
    description_host_specifiction_email:
      'தயவுசெய்து ஒரு வரிக்கு 1 மின்னஞ்சல் முகவரியை உள்ளிடவும்.',
    presenter_label: 'தொகுப்பாளர்',
    presenter_label_conference: 'மக்களின் எண்ணிக்கை',
    event_privacy: 'கலந்தாய்வு முறை',

    alert: 'எச்சரிக்கை!',
    warning: 'எச்சரிக்கை',
    ok: 'சரி',
    cancel: 'ரத்துசெய்',
    done: 'முடிந்தது',
    insert: 'செருக',
    private: 'தனிப்பட்ட',
    public: 'பொது',
    no_connection: 'Internet Connection Lost',
    switch: 'சொடுக்கி',
    share_screen: 'பகிர் திரை',
    stop_share_screen: '',
    share_screen_with_camera: 'பகிர் திரையை நிறுத்து',
    stop_share_screen_with_camera: 'கேமராவுடன் பகிர் திரையை நிறுத்துங்கள்',
    camera_on: 'கேமரா இயக்கப்பட்டது',
    camera_off: 'கேமரா முடக்கப்பட்டுள்ளது',
    mic_on: 'ஊமையாக இல்லை',
    mic_off: 'ஊமையாக',
    fullscreen: 'முழு திரை',
    live_now: 'இப்போது வாழ்க',
    schedule_on: 'க்கான அட்டவணை',
    organisations: 'நிறுவனங்கள்',
    org_groups: 'அமைப்பு குழுக்கள்',
    specific_user: 'Specific User',
    gif: 'GIF',
    unavailable: 'கிடைக்கவில்லை',
    yes: 'ஆம்',
    no: 'இல்லை',
    event_duration_message: 'அதிகபட்சம் 300 நிமிடங்கள் (5 மணி)',
    send_email: 'மின்னஞ்சல் அறிவிப்பை அனுப்பவும்',
    admin_only: 'நிர்வாகி மட்டும்',
    join: 'சேர',
    leave: 'விடுங்கள்'
  },

  broadcastOptions: {
    stream_from_phone: 'எனது தொலைபேசியுடன் நேரலை ஒளிபரப்பு',
    other_webrtc: 'எனது கணினியிலிருந்து வெபினார்',
    multihost: 'எனது கணினியிலிருந்து மல்டிகாஸ்ட் வெபினார்',
    peer2peer: 'பயிற்சி அமர்வு',
    conference: 'நேரலை கலந்தாய்வு'
  },

  lessoncreate: {
    title: 'பாட விவரங்களைச் சேர்க்கவும்',
    subtitle:
      'உங்கள் பாடத்திற்கு பெயரிடுங்கள் மற்றும் அதிலிருந்து அவர்கள் என்ன கற்றுக்கொள்ள எதிர்பார்க்க வேண்டும் என்பதை உங்கள் பார்வையாளர்களிடம் சொல்லுங்கள்.',
    input_label_title: 'பாடத் தலைப்பு',
    input_label_topics: 'பாடத் தலைப்புகள்',
    input_label_description: 'பாட விளக்கம்',
    delete_warning:
      'இந்தப் பக்கத்தை நீக்க விரும்புவதை நீங்கள் உறுதிப்படுத்துகிறீர்களா?'
  },

  lessonoverview: {
    title: 'பாடத்தைச் சேர்க்கவும்',
    subtitle:
      'ஏற்கனவே உள்ள பாடத்தைச் சேர்க்கவும் அல்லது புதிய ஒன்றை உருவாக்கவும்',
    new_lesson: 'ஒரு புதிய பாடத்தை உருவாக்கவும்',
    new_lesson_sub: 'புதிதாக ஒரு புதிய பாடத்தை உருவாக்கவும்!',
    existing_lesson: 'ஏற்கனவே இருக்கும் பாடத்தைத் தேர்ந்தெடுக்கவும்',
    existing_lesson_sub:
      'ஏற்கனவே உள்ள ஒரு பாடத்திற்கான இணைப்பு, இந்த பாடத்தில் செய்யப்பட்ட மாற்றங்கள் மற்ற படிப்பில் உள்ள பாடத்திலும் பாதிக்கும்.',
    clone_lesson: 'ஏற்கனவே உள்ள பாடத்தை நகலெடு',
    clone_lesson_sub:
      'இந்த படிப்பில் உள்ள பாடத்தின் ஒரு தனித்துவமான நகலை உருவாக்கவும், இந்த பாடத்தில் செய்யப்பட்ட மாற்றங்கள் அசல் பாடத்தை பாதிக்காது.',
    clone_lesson_modal_sub:
      'உங்கள் படிப்பில் நீங்கள் சேர்க்க விரும்பும் பாடத்தின் கீழே உள்ள குளோன் பொத்தானை தயவுசெய்து கிளிக் செய்க.'
  },

  management: {
    groups_title: 'குழுக்களை நிர்வகிக்கவும்',
    delete_warning: 'நீங்கள் உறுதியாக இருக்கிறீர்களா?',
    organizations_title: 'எனது நிறுவனங்கள்',
    organizations_subtitle: 'உங்கள் பட்டியலில் நிறுவனங்களைச் சேர்க்கவும்',
    users_title: 'பயனர்களை நிர்வகிக்கவும்',
    users_position: 'மூத்த கணக்கு மேலாளர்',
    user_not_found: 'பயனர் கிடைக்கவில்லை',
    select_org:
      'தயவுசெய்து பயனர்களை நிர்வகிக்க ஒரு நிறுவனத்தைக் கண்டுபிடித்து தேர்வு செய்யவும்'
  },

  audio: {
    modal_title: 'ஆடியோவைச் செருகவும்',
    list_view: 'பட்டியலாக காண்க',
    create_audio_modal_title: 'ஆடியோவை உருவாக்கவும்',
    edit_audio_modal_title: 'ஆடியோவைத் திருத்து',
    public_audio_not_found: 'ஆடியோ கிடைக்கவில்லை.',
    private_audio_not_found:
      'நீங்கள் இதுவரை எந்தவொரு ஆடியோவையும் பதிவேற்றவில்லை',
    are_you_sure_to_delete: 'நீங்கள் நிச்சயமாக நீக்க விரும்புகிறீர்களா?',
    type_something: 'ஏதாவது தட்டச்சு செய்யவும்',
    select_voice: 'தேர்ந்தெடு',
    file_name: 'கோப்பு பெயர்',
    description: 'விளக்கம்',
    topic: 'தலைப்பு',
    key_words_tag: 'முக்கிய வார்த்தைகளின் குறிச்சொல்',
    mp3_audio: 'MP3 ஆடியோ',
    created: 'உருவாக்கப்பட்டது',
    duration: 'கால அளவு',
    close: 'மூடவும்'
  },

  image: {
    modal_title: 'படத்தைச் செருகவும்',
    image: 'படம்',
    pixel: 'பிக்சல்',
    dimension: 'பரிமாணம்',
    public_image_not_found: 'படம் கிடைக்கவில்லை.',
    private_image_not_found: 'நீங்கள் இதுவரை எந்தவொரு படத்தையும் பதிவேற்றவில்லை'
  },

  annotation: {
    modal_title: 'விரிவுரை'
  },

  text: {
    modal_title: 'உரை ஆசிரியர்'
  },

  video: {
    modal_title: 'வீடியோவைச் செருகவும்',
    image: 'வீடியோ',
    mp4_video: 'MP4 வீடியோ',
    public_video_not_found: 'வீடியோ கிடைக்கவில்லை.',
    private_video_not_found:
      'நீங்கள் இதுவரை எந்தவொரு வீடியோவையும் பதிவேற்றவில்லை'
  },

  media: {
    title: 'மீடியா நூலகம்',
    subtitle: 'உங்கள் கோப்புகளின் நூலகம்',
    modal_title: 'மீடியாவைப் பதிவேற்றவும்',
    delete_warning: 'நீக்குதலை உறுதிப்படுத்தவும்',
    delete_message:
      'நீக்கப்பட்ட மீடியா அவை பயன்படுத்தப்பட்ட பக்கங்களில் இன்னும் தோன்றும்',
    dropzone_text: 'அல்லது இங்கே இழுத்து விடுங்கள்',
    delete_success: 'மீடியா வெற்றிகரமாக நீக்கப்பட்டது',
    upload_file: 'கோப்பை பதிவேற்றவும்',
    drag_drop: 'அல்லது இங்கே இழுத்து விடுங்கள்',
    import_file: 'உங்கள் கணினியிலிருந்து கோப்பு(களை) இறக்குக',
    no_media: 'நீங்கள் இதுவரை எந்தவொரு மீடியாவையும் பதிவேற்றவில்லை',
    media_type: 'மீடியா வகை',
    video: 'வீடியோ',
    image: 'படம்',
    audio: 'ஆடியோ',
    gif: 'GIF',
    transcribed_text: 'Transcribed Text',
    media_not_found: 'மீடியா கிடைக்கவில்லை.',
    of: 'உடைய',
    disclaimer: `எனது மீடியா பின்வருவனவற்றை கொண்டிருக்காது என்று நான் உத்தரவாதம் அளிக்கிறேன்:
  - எந்தவொரு மூன்றாம் தரப்பினரின் உரிமைகளையும் மீறுதலை
- அவதூறு, வெறுப்பூட்டுகிற, அநாகரீகமான, மோசமான, ஆபாசமான, வன்முறை, துஷ்பிரயோகம், அவமதிப்பு, அச்சுறுத்தல் அல்லது பாரபட்சமான உள்ளடக்கம், நட்சத்திரக் குறிப்புகளுடன் கூட மறைக்கப்பட்ட உள்ளிட்ட எந்தவொரு சட்டவிரோதத்தையும் கொண்டிருத்தல்
- மற்ற நபர்கள் மீதான தனிப்பட்ட தாக்குதல்களைக் கொண்டிருத்தல்
- பிற பங்கேற்பாளர்கள், பொது நபர்கள் அல்லது பிரபலங்களைப் போல் ஆள்மாறாட்டம் ஆகியவற்றைக் கொண்டிருத்தல்
- எந்தவொரு தனிநபரின் எந்தவொரு பதிவு அல்லது தனிப்பட்ட தகவல்களையும் அத்தகைய நபரின் அனுமதியின்றி கொண்டிருப்பது மற்றும் உலகின் எந்தவொருப் பகுதியின் தகவல் பாதுகாப்பு ஒழுங்குமுறைகளை மீறுதலை
- எந்தவொரு வணிகம் தொடர்பான வற்புறுத்தும் வேண்டுதலை அல்லது எந்த வகையான "ஸ்பேம்" கொண்டிருத்தல்`,
    my_media: 'எனது மீடியா',
    public_library: 'பொது நூலகம்',
    organization_library: 'நிறுவன நூலகம்',
    upload_from_computer: 'கணினியிலிருந்து பதிவேற்றவும்',
    create: 'உருவாக்கு',
    all: 'அனைத்தும்',
    male: 'ஆண்',
    female: 'பெண்',
    processing_audio: 'ஆடியோவை செயலாக்குகிறது',
    create_annotation: 'சிறுகுறிப்பை உருவாக்கவும்',
    popup_over_lesson_text:
      'கிளிக் செய்தபின் பாடத்தின் மேலே சிறுகுறிப்பு பாப் அப் செய்யும்',
    edit_detail: 'விவரங்களைத் திருத்து',
    delete: 'நீக்கு',
    go_create_audio: 'ஆடியோவை உருவாக்கச் செல்லுங்கள்',
    show_more_details: 'மேலும் விவரங்களைக் காட்டு',
    show_less_details: 'குறைந்த விவரங்களைக் காட்டு',
    drop_files: 'பதிவேற்ற வேண்டிய இடத்துக்கு கோப்புகளை விடுங்கள்',
    or: 'அல்லது',
    import_files: 'கணினியிலிருந்து கோப்புகளை இறக்குக'
  },

  navigation: {
    account: 'கணக்கு',
    assessments: 'மதிப்பீடுகள்',
    dashboard: 'டாஷ்போர்டு',
    groups: 'குழு மேலாண்மை',
    logout: 'வெளியேறு',
    organisations: 'நிறுவனங்கள்',
    organizations_users: 'நிறுவனங்கள் மற்றும் பயனர்கள்',
    reports: 'அறிக்கைகள்',
    schedule: 'அட்டவணை',
    training: 'பயிற்சி',
    nowLive: 'ஒளிபரப்பு',
    users: 'பயனர்கள்',
    workshop: 'எனது ஒர்க் ஷாப்'
  },

  onboarding: {
    step1_title: 'படி 1: உங்களைப் பற்றி எங்களுக்கு கொஞ்சம் சொல்லுங்கள்',
    step1_subtitle:
      'உங்கள் பெயர் என்ன? நீங்கள் எங்கிருந்து வருகிறீர்கள்? நீங்கள் என்ன வேலை செய்கிறீர்கள்?',
    step2_title:
      'படி 2: நீங்கள் மேம்படுத்த விரும்பும் சில திறன்களைத் தேர்ந்தெடுக்கவும்',
    step2_subtitle:
      'அடுத்து, நீங்கள் நன்றாக புரிந்து கொள்ள விரும்புவதை எங்களிடம் கூறுங்கள். ஒருவேளை நீங்கள் இன்னும் எதையாவது வளர்த்து கொள்ள விரும்புகிறீர்களா? ஒரு புதிய படிப்பு? உங்கள் அன்புக்குரியவர் என்ன செய்கிறார்?'
  },

  pagebuilder: {
    title: 'பாடத்தை உருவாக்கவும்',
    subtitle:
      'உங்களிடமிருந்து உங்கள் பார்வையாளர்கள் கற்றுக்கொள்ள உள்ளடக்கத்தை உருவாக்கும் நேரம், நீங்கள் படங்கள், வீடியோக்கள் மற்றும் இன்போகிராபிக்ஸ் செய்யலாம்',
    select_layout: 'ஒரு பக்க அமைப்பைத் தேர்ந்தெடுக்கவும்',
    template1: 'காலியான',
    template2: 'தலைப்பு & வசன வரிகள்',
    template3: 'தலைப்பு & உரை',
    template4: 'தலைப்பு, மீடியா மற்றும் உரை',
    template5: 'தலைப்பு & மீடியா',
    template6: 'தலைப்பு & வினாடி வினா'
  },

  pageconstructor: {
    title: 'பாடம் மற்றும் குளோன் செய்யவும்',
    subtitle:
      'உங்களிடமிருந்து உங்கள் பார்வையாளர்கள் கற்றுக்கொள்ள உள்ளடக்கத்தை உருவாக்கும் நேரம், நீங்கள் படங்கள், வீடியோக்கள் மற்றும் இன்போகிராபிக்ஸ் ஆகியவற்றைச் சேர்க்கலாம்'
  },

  passwordreset: {
    success_coded:
      'நீங்கள் வழங்கிய முகவரிக்கு ஒரு உறுதிப்படுத்தல் குறியீட்டை நாங்கள் மின்னஞ்சல் செய்துள்ளோம், தயவுசெய்து புதிய கடவுச்சொல்லை அமைக்க கீழே உள்ள புலத்தில் குறியீட்டை நகலெடுக்கவும்.',
    success_changed:
      'ஒரு புதிய கடவுச்சொல்லை வெற்றிகரமாக அமைத்துள்ளீர்கள். நீங்கள் இப்போது உள்நுழையலாம்.'
  },

  placeholders: {
    search: 'தேடுங்கள்',
    answer: 'பதில்',
    chat: 'ஏதாவது கூறுங்கள்...',
    code: 'குறியீடு',
    criterion: 'அளவுகோல்',
    date_event: 'தேதி & நேரத்தைத் தேர்ந்தெடுக்கவும்',
    date_start: 'தொடக்க தேதி',
    date_expire: 'காலாவதி தேதி',
    description: 'விளக்கம்',
    elements: 'கூறுகளை வரிசைப்படுத்து',
    email: 'மின்னஞ்சல்',
    feedback_correct: 'கருத்து சரியானது',
    feedback_incorrect: 'கருத்து தவறானது',
    host: 'ஹோஸ்ட்',
    keywords: 'முக்கிய வார்த்தை(களை) தேடுங்கள்',
    lesson_description: 'பாட விளக்கம்',
    location: 'இடம்',
    minutes: 'நிமிடங்கள்',
    name: 'பெயர்',
    organiser: 'நூலாசிரியர்',
    organization: 'நிறுவனம்',
    password: 'கடவுச்சொல்',
    phone: 'தொலைபேசி',
    photo: 'புகைப்படம்',
    picture: 'படம்',
    point: 'புள்ளி',
    position: 'நிலை',
    question: 'கேள்வி',
    quiz: 'வினாடி வினாவின் பெயர்',
    search_course: ' படிப்பு மூலம் தேடுங்கள்',
    search_media: 'மீடியாவை தேடுங்கள்',
    search_name: 'பெயரால் தேடுங்கள்',
    search_title: 'தலைப்பு மூலம் தேடுங்கள்',
    search_training: 'பயிற்சியைத் தேடுங்கள்',
    settings: 'அமைப்புகள்',
    tags: 'குறிச்சொற்கள்',
    title: 'தலைப்பு',
    topics: 'தலைப்புகள்',
    username: 'பயனர்பெயர்',
    keyword: 'முக்கிய வார்த்தைகள்',
    max_500_characters: 'அதிகபட்சம் 500 எழுத்துக்கள் ',
    no_description: 'இந்த கோப்பில் ஒரு விளக்கம் இல்லை',
    no_keyword: 'இந்த கோப்பில் எந்தவொரு முக்கிய வார்த்தைகளும் இல்லை',
    no_topics: 'இந்த கோப்பில் ஒரு தலைப்பு தொகுப்பு இல்லை',
    feedback: 'செய்தி',
    contact: 'நாங்கள் எவ்வாறு உதவ முடியும்?'
  },

  publishsettings: {
    title: 'அமைப்புகளை வெளியிடுக',
    event_subtitle:
      'உங்கள் நிகழ்வைக் காணக்கூடிய மற்றும் தொடர்பு கொள்ளக்கூடிய வகையில் உங்கள் நிகழ்வில் அமைப்புகளைச் சேர்க்கவும்',
    assessment_subtitile:
      'உங்கள் மதிப்பீட்டிற்கு பெயரிடுங்கள் மற்றும் அதிலிருந்து அவர்கள் என்ன கற்றுக்கொள்ள  எதிர்பார்க்க வேண்டும் என்பதை உங்கள் பார்வையாளர்களிடம் சொல்லுங்கள்',
    course_subtitle:
      'உங்கள் படிப்பைக் காணக்கூடிய மற்றும் தொடர்பு கொள்ளக்கூடிய வகையில் உங்கள் படிப்பில் அமைப்புகளைச் சேர்க்கவும்',
    disclaimer: `1.	பதிவு செய்தல்

ஒரு பயனராக பதிவு செய்வதன் மூலமும்/ ஒரு கணக்கை உருவாக்குவதன் மூலமும் நீங்கள் எங்கள் [பயனர் ஒப்பந்தத்தை] மற்றும் எங்கள் [தனியுரிமைக் கொள்கையை] படித்து ஒப்புக்கொள்கிறீர்கள்



2.	பாடத்திட்ட உருவாக்கம்

எங்கள் கருவிகளைப் பயன்படுத்துவதன் மூலமும் மற்றும் பாடத்திட்ட உள்ளடக்கத்தை உருவாக்குவதன் மூலமும், எங்கள் [பயனர் ஒப்பந்தத்தை] மற்றும் எங்கள் [தனியுரிமைக் கொள்கையை] படித்து ஒப்புக்கொள்கிறீர்கள்



3.	நிகழ்வு உருவாக்கம்

எங்கள் கருவிகளைப் பயன்படுத்துவதன் மூலமும் மற்றும் ஒரு நிகழ்வை உருவாக்குவதன் மூலமும், எங்கள் [பயனர் ஒப்பந்தத்தை] மற்றும் எங்கள் [தனியுரிமைக் கொள்கையை] படித்து ஒப்புக்கொள்கிறீர்கள்


4.	மதிப்பீடு உருவாக்கம்

எங்கள் கருவிகளைப் பயன்படுத்துவதன் மூலமும் மற்றும் ஒரு மதிப்பீட்டை உருவாக்குவதன் மூலமும், எங்கள் [பயனர் ஒப்பந்தத்தை] மற்றும் எங்கள் [தனியுரிமைக் கொள்கையை] படித்து ஒப்புக்கொள்கிறீர்கள்`,
    dates_validation_error: 'இரண்டு தேதிகளும் நிரப்பப்பட வேண்டும்.',
    course_dates_validation_error: 'இந்தப் பாடத்திட்டத்திற்கான தொடக்க மற்றும் காலாவதி தேதியை உள்ளிடவும்.',
    emails_validation_error: 'மின்னஞ்சல் பட்டியல் தவறானது.',
    specific_email_validation_error:
      'ஒரே ஒரு மின்னஞ்சல் மட்டுமே அனுமதிக்கப்படுகிறது.',
    i_agree_to_these: 'நான் ஒப்புக்கொள்கிறேன் இந்த ',
    terms_and_conditions: 'விதிமுறைகளையும் நிபந்தனைகளையும்.',
    PublicDescription:
      'இலவச சுயாதீன பயனர்கள்: (தனிப்பட்ட மற்றும் பொது விருப்பத்தேர்வுகள்) உங்கள் [படிப்பு | நிகழ்வு | மதிப்பீடு] சேமிக்கப்பட்டது மற்றும் இயல்பாகவே தனிப்பட்டதாக கருதப்படுகிறது. இதன் பொருள் நீங்கள் மட்டுமே இந்த உள்ளடக்கத்தைக் காண முடியும். இந்த உள்ளடக்கத்தை வெளியிட, கீழே உள்ள make it public  என்பதை நீங்கள் தேர்ந்தெடுக்கலாம். இதன் பொருள் இயங்குதளத்தில் உள்ள அனைத்து பயனர்களுக்கும் இந்த பாடத்திட்டம் கிடைக்கும் என்பதாகும்.',
    OrganisationsDescription:
      'நிறுவன பயனர்கள்: (""Finish"" என்பதற்கு பதிலாக ""Publish"" ஐப் பயன்படுத்தி பிற பயனர்களைப் போலவே அவர்களை வெளியீட்டு பக்கத்திற்கு கொண்டு வாருங்கள், ஆனால் வெளியீட்டு விருப்பத்தேர்வுகள் எதுவும் இல்லாமல்.) உங்கள் [படிப்பு | நிகழ்வு | மதிப்பீடு] சேமிக்கப்பட்டது மற்றும் தனிப்பட்டது. இதன் பொருள் நீங்களும் உங்கள் நிறுவனத்தில் உள்ள நிர்வாகிகளும் மட்டுமே அதைப் பார்க்க முடியும். ஒரு பயனராக, நிர்வாகி உரிமைகள் தேவைப்படுவதால், உங்கள் உள்ளடக்கத்தை உங்கள் நிறுவனத்திற்குள் உங்களால் வெளியிட முடியாது. தயவுசெய்து உங்கள் நிர்வாகிகளில் ஒருவரைத் தொடர்புகொண்டு, உங்கள் உள்ளடக்கத்தை பொதுவில், முழு நிறுவனத்திற்கும், உங்கள் நிறுவனத்தில் உள்ள குறிப்பிட்ட குழுக்களுக்கு அல்லது குறிப்பிட்ட பயனர்களுக்கு வெளியிடச் சொல்லுங்கள்.',
    OrganisationGroupsDescription:
      'நிறுவன நிர்வாகிகள்: (நிறுவனத்திற்குள் உருவாக்கப்பட்ட உள்ளடக்கத்திற்கு: தனிப்பட்ட, பொது, அமைப்பு, குழுக்கள், குறிப்பிட்ட பயனர்கள்): இந்த [படிப்பு | நிகழ்வு | மதிப்பீடு] சேமிக்கப்பட்டு இயல்புநிலையாக தனிப்பட்டதாக கருதப்படுகிறது. இதன் பொருள் நீங்கள் (மற்றும் உள்ளடக்கம் உருவாக்கியவர்) மட்டுமே இந்த உள்ளடக்கத்தைக் காண முடியும். இந்த உள்ளடக்கத்தை வெளியிட நீங்கள் கீழே உள்ள விருப்பத்தேர்வுகளில் ஒன்றைத் தேர்ந்தெடுக்கலாம். உங்கள் பாடத்திட்டத்தை பொதுவில் வெளியிடுவது என்பது உங்கள் நிறுவனத்திற்கு வெளியே உள்ளவர்கள் உட்பட இயங்குதளத்தில் உள்ள அனைத்து பயனர்களுக்கும் கிடைக்கும் என்பதாகும். அதை நிறுவனத்திற்குள் வெளியிடுவது என்பது நிறுவனத்தில் உள்ள அனைத்து பயனர்களும் அதைப் பார்க்க முடியும் என்பதாகும். நீங்கள் இதை 1 அல்லது அதற்கு மேற்பட்ட குழுக்களிலும் வெளியிடலாம், அதாவது அந்தக் குழுக்களில் உள்ள பயனர்கள் மட்டுமே அதைப் பார்க்க முடியும். கடைசியாக, உங்கள் நிறுவனத்திற்கு உள்ளேயும் வெளியேயும் குறிப்பிட்ட பயனர்களுக்கு அவர்களின் ஷேர்லுக் கணக்கு மின்னஞ்சல் முகவரியைப் பயன்படுத்தி வெளியிட உங்களுக்கு விருப்பத்தேர்வு உள்ளது.',
    SpecificUsersDescription:
      'கட்டண சுயாதீன பயனர்கள்: (தனிப்பட்ட, பொது மற்றும் குறிப்பிட்ட பயனர்கள்) உங்கள் [படிப்பு | நிகழ்வு | மதிப்பீடு] சேமிக்கப்பட்டது மற்றும் இயல்பாகவே தனிப்பட்டதாக கருதப்படுகிறது. இதன் பொருள் நீங்கள் மட்டுமே இந்த உள்ளடக்கத்தைக் காண முடியும். இந்த உள்ளடக்கத்தை வெளியிட நீங்கள் கீழே உள்ள விருப்பத்தேர்வுகளில் ஒன்றைத் தேர்ந்தெடுக்கலாம். உங்கள் பாடத்திட்டத்தை பொதுவில் வெளியிடுவது என்பது மேடையில் உள்ள அனைத்து பயனர்களுக்கும் கிடைக்கும் என்பதாகும். குறிப்பிட்ட பயனர்களின் விருப்பத்தேர்வு என்பது குறிப்பிட்ட பயனர்களின் ஷேர்லுக் கணக்குடன் தொடர்புடைய மின்னஞ்சல் முகவரியைப் பயன்படுத்தி உங்கள் பாடத்திட்டத்தைப் பகிர்ந்து கொள்ள உதவும் ஒரு விருப்பத்தேர்வு ஆகும்.'
  },

  quiz: {
    quiz_empty: 'நீங்கள் இன்னும் ஒரு வினாடி வினாவை உருவாக்கவில்லை',
    questions_empty: 'நீங்கள் இன்னும் ஒரு கேள்வியை உருவாக்கவில்லை'
  },

  regions: {
    asia_pacific_australia: 'ஆஸ்திரேலியா',
    asia_pacific_india: 'இந்தியா',
    asia_pacific_japan: 'ஜப்பான்',
    asia_pacific_s_korea: 'தென் கொரியா',
    asia_pacific_singapore: 'சிங்கப்பூர்',
    asia_pacific_taiwan: 'தைவான்',
    eu_belgium: 'பெல்ஜியம்',
    eu_germany: 'ஜெர்மனி',
    eu_ireland: 'அயர்லாந்து',
    south_america_brazil: 'பிரேசில்',
    us_central_iowa: 'அயோவா',
    us_east_s_carolina: 'தென் கரோலினா',
    us_east_virginia: 'வர்ஜீனியா',
    us_west_california: 'கலிபோர்னியா',
    us_west_oregon: 'ஒரேகான்'
  },

  reports: {
    title: 'அறிக்கைகள்',
    workshop_report: 'ஒர்க் ஷாப் அறிக்கை',
    user_report: 'பயனர் அறிக்கை',
    organization_workshop: 'நிறுவன ஒர்க் ஷாப்',
    course: 'படிப்பு',
    live_event: 'நேரலை நிகழ்வு',
    workShop_graph: 'ஒர்க் ஷாப் வரைபடம்',
    organization_account: 'நிறுவனக் கணக்கு',
    all: 'அனைத்தும்',
    name: 'பெயர்',
    id_number: 'ஐடி எண்',
    email: 'மின்னஞ்சல்',
    search_user_report: 'பயனர் அறிக்கையைத் தேடுங்கள்',
    participant: ' பங்கேற்பாளர்',
    participants: 'பங்கேற்பாளர்கள்',
    host: 'ஹோஸ்ட்',
    username: 'பயனர்பெயர்',
    event: 'நிகழ்வு',
    quiz: 'வினாடி வினா',
    assessment: 'மதிப்பீடு',
    time: 'நேரம்',
    no_recent_activity: 'சமீபத்திய செயல்பாடு எதுவும் இல்லை',
    workshops: 'ஒர்க் ஷாப்ஸ்',
    courses: 'படிப்புகள்',
    live_events: 'நேரலை நிகழ்வுகள்',
    live_assessments: 'நேரலை மதிப்பீடுகள்',
    quizzes: 'வினாடி வினாக்கள்',
    overview: 'கண்ணோட்டம்',
    by: 'மூலம்',
    views: 'பார்த்தது',
    status: 'நிலை',
    poll: 'கருத்து கணிப்பு',
    comment: 'கருத்து',
    comments: 'கருத்துகள்',
    no_comments: 'கருத்துகள் இல்லை',
    no_polls: 'கருத்துக் கணிப்புகள் இல்லை',
    live_date: 'நேரலை தேதி',
    score: 'மதிப்பெண்',
    question: 'கேள்வி',
    submit: 'சமர்ப்பிக்கவும்',
    recent_activity: 'சமீபத்திய செயல்பாடு',
    ago: 'முன்பு',
    no_data_found: 'தகவல்கள் காணப்படவில்லை',
    start_end_live: 'தொடங்கும் / முடியும் நேரலை',
    join_leave_date: 'சேருங்கள் / விட்டுச்செல்லுங்கள்',
    watched_time: 'பார்த்த நேரம்',
    complete: 'முழுமை',
    in_complete: 'முழுமையற்றது',
    today: 'இன்று',
    seven_days: '7 நாட்கள்',
    last_month: 'கடந்த மாதம்',
    one_year: '1 வருடம்',
    all_time: 'அனைத்து நேர',
    report: 'அறிக்கை',
    from_date: 'தேதியிலிருந்து',
    to_date: 'தேதி வரை',
    all_workshop: 'அனைத்து ஒர்க் ஷாப்',
    all_participants: 'அனைத்து பங்கேற்பாளர்கள்',
    live_assessment: 'நேரலை மதிப்பீடு',
    users: 'பயனர்கள்',
    download: 'பதிவிறக்கு',
    recent: 'சமீபத்திய',
    WorkShop: 'ஒர்க் ஷாப்',
    Activity: 'செயல்பாடு',
    created_date: 'உருவாக்கிய தேதி',
    lessons: 'பாடங்கள்',
    lesson: 'பாடம்',
    completed: 'நிறைவடைந்தது',
    report_download: 'அறிக்கை பதிவிறக்கம்',
    this_month: 'இந்த மாதம்',
    search_course: 'படிப்பைத் தேடுங்கள்',
    participants_graph: 'பங்கேற்பாளர்கள் வரைபடம்',
    viewed: 'பார்த்தது',
    enrolled: 'பதிவுசெய்தது',
    description: 'விளக்கம்',
    topic: 'தலைப்பு',
    analytic: 'பகுப்பாய்வு',
    quiz_list: 'வினாடி வினா பட்டியல்',
    select_one: 'ஒன்றை தேர்ந்தெடு',
    group_status: 'குழுவின் நிலை',
    duration_min: 'கால அளவு(நிமிடம்)',
    submit_poll: 'கருத்துக் கணிப்பை சமர்ப்பிக்கவும்',
    download_events: 'நிகழ்வுகளைப் பதிவிறக்குக',
    search_event: 'நிகழ்வை தேடு',
    duration: 'கால அளவு',
    total_participants: 'மொத்த பங்கேற்பாளர்கள்',
    message: 'செய்தி',
    avg_message: 'சராசரி. செய்தி',
    per_message: 'செய்திகள் / நிகழ்வின் ஒரு சதவீதம்'
  },

  signup: {
    success_step1:
      'நீங்கள் வழங்கிய முகவரிக்கு ஒரு சரிபார்ப்புக் குறியீட்டை நாங்கள் மின்னஞ்சல் செய்துள்ளோம், உங்கள் பதிவை உறுதிப்படுத்த கீழேயுள்ள புலத்தில் தயவுசெய்து குறியீட்டை நகலெடுக்கவும்.',
    success_step2: 'நன்றி. நீங்கள் வெற்றிகரமாக பதிவுசெய்துள்ளீர்கள்.',
    privacy: `ஷேர்லூக்கின் <1> விதிமுறைகள் மற்றும் நிபந்தனைகள்</1> மற்றும் <3> தனியுரிமைக் கொள்கை</3> ஆகியவற்றை நான் ஒப்புக்கொள்கிறேன்`
  },

  stream: {
    emotion_impressive: 'ஈர்க்கக்கூடிய',
    emotion_unimpressive: 'ஈர்க்காத',
    message_not_started: 'விரைவில்',
    message_running: 'நேரலை',
    message_processing:
      'பிளேபேக்கிற்கான நேரலை பதிவை நாங்கள் தற்போது செயலாக்குகிறோம். வீடியோவைக் காண, மேலும் மதிப்பீடுகள் மற்றும் கருத்துக்களைச் சேர்ப்பதைத் தொடர தயவுசெய்து பின்னர் சரிபார்க்கவும்'
  },

  tabs: {
    audience: 'பார்வையாளர்கள்',
    course: ' படிப்பின் கண்ணோட்டம்',
    details: 'நேரலை நிகழ்வு விவரங்கள்',
    description: 'விளக்கம்',
    host: 'ஹோஸ்ட்',
    lesson: 'பாடத்தின் கண்ணோட்டம்',
    lessons: 'பாடங்கள்',
    overview: 'கண்ணோட்டம்',
    page: 'பக்கம் கட்டுபவர்',
    publish: 'வெளியிடு',
    settings: 'அமைப்பை வெளியிடுக',
    total_views: 'மொத்தமாகப் பார்த்தது',
    live_participates: 'நேரலை பங்கேற்பாளர்கள்',
    live_chats: 'நேரலை சாட்ஸ்',
    live_quiz: 'நேரலை கருத்துக் கணிப்புகள்',
    trainer_rating: 'பயிற்சி மதிப்பீடு',
    trainer_times: 'பயிற்சியாளர் நேரம்',
    courses_quizzes: ' படிப்புகளின் வினாடி வினாக்கள்',
    user_list: 'பயனர் பட்டியல்',
    discussion: 'கலந்துரையாடல்',
    notes: 'எனது குறிப்புகள்'
  },

  topics: {
    SALES_TRAINING: 'விற்பனை பயிற்சி',
    NEGOTIATION_TRAINING: 'பேச்சுவார்த்தை பயிற்சி',
    CROSS_CULTURAL_AWARENESS: 'பல்லினக் கலாச்சார விழிப்புணர்வு',
    NETWORKING_SKILLS: 'நெட்வொர்க்கிங் திறன்கள்',
    SOFTWARE_ARCHITECTURE: 'மென்பொருள் கட்டமைப்பு',
    PROJECT_MANAGEMENT: 'திட்ட மேலாண்மை',
    DIGITAL_TRANSFORMATION: 'டிஜிட்டல் மாற்றம்',
    IT_CONSULTING: 'ஐடி ஆலோசனை',
    MANAGEMENT_CONSULTING: 'மேலாண்மை ஆலோசனை',
    HR_CONSULTING: 'மனிதவள ஆலோசனை',
    INTERNET_OF_THINGS: 'விஷயங்களின் தொழில்நுட்ப இணையம் (IoT)',
    CYBERSECURITY: 'சைபர் பாதுகாப்பு',
    PRIVACY_AND_GDRP: 'தனியுரிமை மற்றும் GDPR'
  },

  training: {
    title: 'பயிற்சி',
    title_assessment: 'மதிப்பீடுகள்',
    subtitle: 'பாடத்திட்டங்கள் மற்றும் நேரலை நிகழ்வுகள்',
    enrolled_title: 'பதிவுசெய்யப்பட்ட பாடத்திட்டங்கள் மற்றும் நேரலை நிகழ்வுகள்',
    enrolled_subtitle: 'நீங்கள் சேர்ந்த படிப்புகள் மற்றும் நேரலை நிகழ்வுகள்',
    enrolled_message:
      'நீங்கள் தற்போது எந்தவொரு படிப்புகளிலும் நிகழ்வுகளிலும் சேரவில்லை.',
    past_live_event_title: 'கடந்த நேரலை நிகழ்வுகள்',
    past_live_event_subTitle: 'முடிந்த நேரலை நிகழ்வுகள்',
    past_live_event: 'கடந்தகால நேரலை நிகழ்வுகள் எதுவும் தற்போது இல்லை.',
    recomended_title: 'பரிந்துரைக்கப்படும் படிப்புகள் மற்றும் நேரலை நிகழ்வுகள்',
    now_live_event_title: 'இப்போது நேரலை',
    now_live_event_subTitle:
      'நேரலையில் இருக்கும் நிகழ்வுகள் அல்லது மிக விரைவில் இருக்கும்',
    now_live_event: 'தற்போது நேரலை நிகழ்வு எதுவும் இல்லை.',
    webinar_event_title: 'வெபினார் சேனல்',
    webinar_event_subTitle: 'முடிந்த வெபினார்கள்',
    webinar_event: 'தற்போது வெபினார் எதுவும் இல்லை.',
    p2p_event_title: 'பயிற்சி அமர்வுகள்',
    p2p_event_subTitle: 'முடிந்த பயிற்சி அமர்வு',
    p2p_event: 'தற்போது பயிற்சி அமர்வு எதுவும் இல்லை.',

    now_live_assessment_title: 'இப்போது நேரலை',
    now_live_assessment_subTitle:
      'நேரலையில் இருக்கும் மதிப்பீடு அல்லது மிக விரைவில் இருக்கும்',
    now_live_assessment_message: 'தற்போது நேரலை மதிப்பீடு எதுவும் இல்லை.',

    upcoming_assessment_title: 'வரவிருக்கும் நேரலை மதிப்பீடுகள்',
    upcoming_assessment_subtitle: 'வரவிருக்கும் நேரலை மதிப்பீடுகள்',
    upcoming_assessment_message:
      'தற்போது வரவிருக்கும் நேரலை மதிப்பீடு எதுவும் இல்லை.',

    past_live_assessment_title: 'கடந்தகால நேரலை மதிப்பீடுகள்',
    past_live_assessment_subTitle: 'முடிந்த நேரலை மதிப்பீடுகள்',
    past_live_assessment_message:
      'கடந்தகால நேரலை மதிப்பீடுகள் தற்போது எதுவும் இல்லை.',

    /**
     * <0/> get index 0 of data from Trans component
     * exp -->
     * <Trans i18nKey='training:recomended_subtitle' >
     *    <Navlink>{...something}</Navlink> --> is index 0 of Trans component
     *    <h1>{...something}</h1> --> is index 1 of Trans component
     * </Trans>
     */
    recomended_subtitle:
      'உங்கள் <0><0/></0> இன் அடிப்படையில் படிப்புகள் மற்றும் நேரலை நிகழ்வுகளை நாங்கள் உருவாக்கியுள்ளோம்',
    /**
     * and we also can get data from index to replace in recommended_subtitle by like above string.
     * for exp -->
     * at the end of the recomended_subtitle above will get data from index of component to display
     * <0><0/></0> mean get data index 0 of Trans component above = <Navlink> and <0/> get data index 0 from <Navlink> = {...something}
     */
    search: 'பயிற்சியைத் தேடுங்கள்',
    search_assessment: 'மதிப்பீட்டைத் தேடுங்கள்',
    recomended_message:
      'தற்போது பரிந்துரைக்கப்படும் படிப்புகள் மற்றும் நிகழ்வுகள் எதுவும் இல்லை.'
  },

  warnings: {
    delete: 'நீங்கள் உறுதியாக இருக்கிறீர்களா?'
  },

  workshop: {
    title: 'எனது ஒர்க் ஷாப்',
    subtitle:
      'ஒரு படிப்பதை உருவாக்குங்கள் அல்லது உங்கள் சொந்த ஒரு நேரலை நிகழ்வை ஹோஸ்ட் செய்யுங்கள்',
    new_course: 'ஒரு புதிய படிப்பை உருவாக்குங்கள்',
    new_event: 'ஒரு புதிய நேரலை நிகழ்வை உருவாக்குங்கள்',
    new_assessment: 'ஒரு புதிய நேரலை மதிப்பீட்டை உருவாக்குங்கள்',
    courses_title: 'உருவாக்கிய படிப்புகள் மற்றும் நேரலை நிகழ்வுகள்',
    courses_subtitle:
      'நீங்கள் உருவாக்கிய படிப்பைத் திருத்தி வெளியிடுங்கள் மற்றும் நேரலை நிகழ்வுகளைத் திட்டமிடுங்கள்',
    tags_course: 'படிப்பு',
    tags_live: 'நேரலை நிகழ்வு',
    tags_assessment: 'நேரலை மதிப்பீடு'
  },

  help_center: {
    sidebar: {
      title: 'உங்களுக்கு நாங்கள் எவ்வாறு உதவலாம்?',
      back_to: 'டாஷ்போர்டு'
    },
    menu: {
      help_center: 'உதவி மையம்',
      whats_new: 'புதியது என்ன',
      feedback: 'உங்கள் கருத்து',
      feedback_title: 'ஷேர்லூக்கிற்கு உங்கள் கருத்தை அனுப்பவும்',
      terms_and_conditions: 'விதிமுறைகள் & நிபந்தனைகள்',
      privacy_policy: 'தனியுரிமைக் கொள்கை',
      contact_us: 'எங்களை தொடர்பு கொள்ளுங்கள்'
    },
    get_started: {
      title: 'ஷேர்லூக் உடன் தொடங்கவும்',
      description: {
        main:
          'நாங்கள் நேரலை வீடியோவை ஒரு எளிதில் பயன்படுத்தக்கூடிய படிப்பு கட்டமைப்பாளருக்கு ஒருங்கிணைத்துள்ளோம்',
        tagline:
          'ஷேர்லூக்கின் காப்புரிமை பெற்ற நேரலை ஒளிபரப்பு அமைப்பு மூலம், நீங்கள் ஈடுபாட்டை உருவாக்கலாம், கற்றலை தானியங்குபடுத்தலாம் மற்றும் அறிவு பகிர்வை அதிகரிக்கலாம்.'
      }
    },
    whats_new: {
      title: 'ஷேர்லூக் உடன் தொடங்கவும்',
      description: {
        main:
          'கதை சொல்லும் பாணி கற்றலை குறுகிய காலத்தில் மற்றும் குறைந்த விலையில் உருவாக்க முடியும் என்பது உங்களுக்குத் தெரியுமா? ஷேர்லூக் படிப்பை கட்டுபவர் மற்றும் அந்தந்த திறமைகளை நீங்கள் இணைக்க வேண்டும். நீங்கள் எங்களிடம் "எப்படி" என்று கேட்கலாம்',
        tagline: ''
      }
    },
    create_workshop: 'ஒரு ஒர்க் ஷாப் உருவாக்குவது எப்படி',
    create_course: 'ஒரு படிப்பை உருவாக்குவது எப்படி',
    create_user: 'ஒரு பயனரை உருவாக்குவது எப்படி',
    create_group: 'ஒரு குழுவை உருவாக்குவது எப்படி',
    create_webinar: 'வெபினார் உருவாக்குவது எப்படி',
    create_live_event: 'நேரலை நிகழ்வை உருவாக்குவது எப்படி',
    create_live_assessment: 'நேரலை மதிப்பீட்டை உருவாக்குவது எப்படி',
    create_live_on_mobile: 'மொபைலில் நேரலை உருவாக்கவும்',
    personalize_profile: 'ஒரு சுயவிவரத்தைத் தனிப்பயனாக்குங்கள்',
    manage_group: 'குழுவை நிர்வகிக்கவும்',
    report: 'அறிக்கை',
    add_annotations: 'சிறுகுறிப்புகள்/பாப்அப்களை எவ்வாறு சேர்ப்பது',
    add_audio: 'ஆடியோவை எவ்வாறு சேர்ப்பது',
    add_header_and_footer: 'தலைப்பு மற்றும் அடிக்குறிப்பைச் சேர்த்தல்',
    add_image: 'படத்தை எவ்வாறு சேர்ப்பது',
    add_quiz_content: 'வினாடி வினா உள்ளடக்கத்தை எவ்வாறு சேர்ப்பது',
    add_text_content: 'உரை உள்ளடக்கத்தை எவ்வாறு சேர்ப்பது',
    add_user: 'பயனரை எவ்வாறு சேர்ப்பது',
    add_video: 'வீடியோவை எவ்வாறு சேர்ப்பது',
    clone_course: 'படிப்புகளை குளோன் செய்வது எப்படி',
    find_live_broadcast: 'நேரலை ஒளிபரப்பை எவ்வாறு கண்டுபிடிப்பது',
    contact_us: {
      title: 'எங்களை தொடர்பு கொள்ளுங்கள்',
      subject_placeholder: 'ஒரு தலைப்பை உள்ளிடவும்*',
      content_placeholder: 'ஒரு செய்தியை உள்ளிடவும்*',
      subject_required: '*தலைப்பு தேவை',
      content_required: '*செய்தி தேவை',
      submit: 'அனுப்புக',
      cancel: 'ரத்துசெய்',
      sent: 'அனுப்பப்பட்டது'
    },
    feedback: {
      title: 'ஷேர்லூக்கிற்கு உங்கள் கருத்தை அனுப்பவும்',
      attach_title: 'ஒரு கோப்பை இணைக்கவும்',
      choose: 'கோப்பை தேர்வுச்செய்யுங்கள்',
      detail: 'கோப்பு ஆதரவு குழுவுடன் பகிரப்படும்',
      content_placeholder: 'ஒரு செய்தியை உள்ளிடவும்*',
      content_required: '*செய்தி தேவை',
      submit: 'அனுப்புக',
      cancel: 'ரத்துசெய்',
      sent: 'அனுப்பப்பட்டது'
    }
  },
  discussion: {
    join_discussion: 'கலந்துரையாடலில் சேரவும்'
  },
  notes: {
    title: 'எனது குறிப்புகள்',
    add_note: 'புதிய குறிப்பைச் சேர்க்கவும்'
  }
}
